/*eslint-disable no-prototype-builtins*/
import * as $protobuf from "protobufjs/minimal";

// Common aliases
const $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
const $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

export const ai = $root.ai = (() => {

    /**
     * Namespace ai.
     * @exports ai
     * @namespace
     */
    const ai = {};

    ai.talecast = (function() {

        /**
         * Namespace talecast.
         * @memberof ai
         * @namespace
         */
        const talecast = {};

        talecast.webapp = (function() {

            /**
             * Namespace webapp.
             * @memberof ai.talecast
             * @namespace
             */
            const webapp = {};

            webapp.proto = (function() {

                /**
                 * Namespace proto.
                 * @memberof ai.talecast.webapp
                 * @namespace
                 */
                const proto = {};

                proto.Message = (function() {

                    /**
                     * Properties of a Message.
                     * @memberof ai.talecast.webapp.proto
                     * @interface IMessage
                     * @property {ai.talecast.webapp.proto.WsEventTypeProto|null} [eventType] Message eventType
                     * @property {ai.talecast.webapp.proto.ILoginData|null} [loginData] Message loginData
                     * @property {ai.talecast.webapp.proto.ILogoutData|null} [logoutData] Message logoutData
                     * @property {ai.talecast.webapp.proto.IUpdateProfileData|null} [updateProfileData] Message updateProfileData
                     * @property {ai.talecast.webapp.proto.IPongData|null} [pongData] Message pongData
                     * @property {ai.talecast.webapp.proto.IUserAssetDetailsProto|null} [userAssetDetails] Message userAssetDetails
                     * @property {ai.talecast.webapp.proto.IVoiceMessageProto|null} [voiceMessageProto] Message voiceMessageProto
                     * @property {ai.talecast.webapp.proto.IProjectCreatedProto|null} [projectCreatedProto] Message projectCreatedProto
                     * @property {ai.talecast.webapp.proto.ITtsDetailsProto|null} [ttsDetailsProto] Message ttsDetailsProto
                     * @property {ai.talecast.webapp.proto.IExportProcessProto|null} [exportProcessProto] Message exportProcessProto
                     * @property {ai.talecast.webapp.proto.ISentenceGeneratedProto|null} [sentenceGeneratedProto] Message sentenceGeneratedProto
                     * @property {ai.talecast.webapp.proto.IExportSuccessProto|null} [exportSuccessProto] Message exportSuccessProto
                     * @property {ai.talecast.webapp.proto.ISpriteInfoProto|null} [spriteInfoProto] Message spriteInfoProto
                     * @property {ai.talecast.webapp.proto.IExportInterruptedProto|null} [exportInterruptedProto] Message exportInterruptedProto
                     * @property {ai.talecast.webapp.proto.ITranscodeSuccessProto|null} [transcodeSuccessProto] Message transcodeSuccessProto
                     * @property {ai.talecast.webapp.proto.IUserOrderInfoProto|null} [userOrderInfoProto] Message userOrderInfoProto
                     * @property {ai.talecast.webapp.proto.IPreDownloadProto|null} [preDownloadProto] Message preDownloadProto
                     * @property {ai.talecast.webapp.proto.ITranslateProto|null} [translateProto] Message translateProto
                     * @property {ai.talecast.webapp.proto.ITtsMessageProto|null} [ttsMessageProto] Message ttsMessageProto
                     * @property {ai.talecast.webapp.proto.ITranslationMessageProto|null} [translationMessageProto] Message translationMessageProto
                     */

                    /**
                     * Constructs a new Message.
                     * @memberof ai.talecast.webapp.proto
                     * @classdesc Represents a Message.
                     * @implements IMessage
                     * @constructor
                     * @param {ai.talecast.webapp.proto.IMessage=} [properties] Properties to set
                     */
                    function Message(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Message eventType.
                     * @member {ai.talecast.webapp.proto.WsEventTypeProto} eventType
                     * @memberof ai.talecast.webapp.proto.Message
                     * @instance
                     */
                    Message.prototype.eventType = 0;

                    /**
                     * Message loginData.
                     * @member {ai.talecast.webapp.proto.ILoginData|null|undefined} loginData
                     * @memberof ai.talecast.webapp.proto.Message
                     * @instance
                     */
                    Message.prototype.loginData = null;

                    /**
                     * Message logoutData.
                     * @member {ai.talecast.webapp.proto.ILogoutData|null|undefined} logoutData
                     * @memberof ai.talecast.webapp.proto.Message
                     * @instance
                     */
                    Message.prototype.logoutData = null;

                    /**
                     * Message updateProfileData.
                     * @member {ai.talecast.webapp.proto.IUpdateProfileData|null|undefined} updateProfileData
                     * @memberof ai.talecast.webapp.proto.Message
                     * @instance
                     */
                    Message.prototype.updateProfileData = null;

                    /**
                     * Message pongData.
                     * @member {ai.talecast.webapp.proto.IPongData|null|undefined} pongData
                     * @memberof ai.talecast.webapp.proto.Message
                     * @instance
                     */
                    Message.prototype.pongData = null;

                    /**
                     * Message userAssetDetails.
                     * @member {ai.talecast.webapp.proto.IUserAssetDetailsProto|null|undefined} userAssetDetails
                     * @memberof ai.talecast.webapp.proto.Message
                     * @instance
                     */
                    Message.prototype.userAssetDetails = null;

                    /**
                     * Message voiceMessageProto.
                     * @member {ai.talecast.webapp.proto.IVoiceMessageProto|null|undefined} voiceMessageProto
                     * @memberof ai.talecast.webapp.proto.Message
                     * @instance
                     */
                    Message.prototype.voiceMessageProto = null;

                    /**
                     * Message projectCreatedProto.
                     * @member {ai.talecast.webapp.proto.IProjectCreatedProto|null|undefined} projectCreatedProto
                     * @memberof ai.talecast.webapp.proto.Message
                     * @instance
                     */
                    Message.prototype.projectCreatedProto = null;

                    /**
                     * Message ttsDetailsProto.
                     * @member {ai.talecast.webapp.proto.ITtsDetailsProto|null|undefined} ttsDetailsProto
                     * @memberof ai.talecast.webapp.proto.Message
                     * @instance
                     */
                    Message.prototype.ttsDetailsProto = null;

                    /**
                     * Message exportProcessProto.
                     * @member {ai.talecast.webapp.proto.IExportProcessProto|null|undefined} exportProcessProto
                     * @memberof ai.talecast.webapp.proto.Message
                     * @instance
                     */
                    Message.prototype.exportProcessProto = null;

                    /**
                     * Message sentenceGeneratedProto.
                     * @member {ai.talecast.webapp.proto.ISentenceGeneratedProto|null|undefined} sentenceGeneratedProto
                     * @memberof ai.talecast.webapp.proto.Message
                     * @instance
                     */
                    Message.prototype.sentenceGeneratedProto = null;

                    /**
                     * Message exportSuccessProto.
                     * @member {ai.talecast.webapp.proto.IExportSuccessProto|null|undefined} exportSuccessProto
                     * @memberof ai.talecast.webapp.proto.Message
                     * @instance
                     */
                    Message.prototype.exportSuccessProto = null;

                    /**
                     * Message spriteInfoProto.
                     * @member {ai.talecast.webapp.proto.ISpriteInfoProto|null|undefined} spriteInfoProto
                     * @memberof ai.talecast.webapp.proto.Message
                     * @instance
                     */
                    Message.prototype.spriteInfoProto = null;

                    /**
                     * Message exportInterruptedProto.
                     * @member {ai.talecast.webapp.proto.IExportInterruptedProto|null|undefined} exportInterruptedProto
                     * @memberof ai.talecast.webapp.proto.Message
                     * @instance
                     */
                    Message.prototype.exportInterruptedProto = null;

                    /**
                     * Message transcodeSuccessProto.
                     * @member {ai.talecast.webapp.proto.ITranscodeSuccessProto|null|undefined} transcodeSuccessProto
                     * @memberof ai.talecast.webapp.proto.Message
                     * @instance
                     */
                    Message.prototype.transcodeSuccessProto = null;

                    /**
                     * Message userOrderInfoProto.
                     * @member {ai.talecast.webapp.proto.IUserOrderInfoProto|null|undefined} userOrderInfoProto
                     * @memberof ai.talecast.webapp.proto.Message
                     * @instance
                     */
                    Message.prototype.userOrderInfoProto = null;

                    /**
                     * Message preDownloadProto.
                     * @member {ai.talecast.webapp.proto.IPreDownloadProto|null|undefined} preDownloadProto
                     * @memberof ai.talecast.webapp.proto.Message
                     * @instance
                     */
                    Message.prototype.preDownloadProto = null;

                    /**
                     * Message translateProto.
                     * @member {ai.talecast.webapp.proto.ITranslateProto|null|undefined} translateProto
                     * @memberof ai.talecast.webapp.proto.Message
                     * @instance
                     */
                    Message.prototype.translateProto = null;

                    /**
                     * Message ttsMessageProto.
                     * @member {ai.talecast.webapp.proto.ITtsMessageProto|null|undefined} ttsMessageProto
                     * @memberof ai.talecast.webapp.proto.Message
                     * @instance
                     */
                    Message.prototype.ttsMessageProto = null;

                    /**
                     * Message translationMessageProto.
                     * @member {ai.talecast.webapp.proto.ITranslationMessageProto|null|undefined} translationMessageProto
                     * @memberof ai.talecast.webapp.proto.Message
                     * @instance
                     */
                    Message.prototype.translationMessageProto = null;

                    // OneOf field names bound to virtual getters and setters
                    let $oneOfFields;

                    /**
                     * Message data.
                     * @member {"loginData"|"logoutData"|"updateProfileData"|"pongData"|"userAssetDetails"|"voiceMessageProto"|"projectCreatedProto"|"ttsDetailsProto"|"exportProcessProto"|"sentenceGeneratedProto"|"exportSuccessProto"|"spriteInfoProto"|"exportInterruptedProto"|"transcodeSuccessProto"|"userOrderInfoProto"|"preDownloadProto"|"translateProto"|"ttsMessageProto"|"translationMessageProto"|undefined} data
                     * @memberof ai.talecast.webapp.proto.Message
                     * @instance
                     */
                    Object.defineProperty(Message.prototype, "data", {
                        get: $util.oneOfGetter($oneOfFields = ["loginData", "logoutData", "updateProfileData", "pongData", "userAssetDetails", "voiceMessageProto", "projectCreatedProto", "ttsDetailsProto", "exportProcessProto", "sentenceGeneratedProto", "exportSuccessProto", "spriteInfoProto", "exportInterruptedProto", "transcodeSuccessProto", "userOrderInfoProto", "preDownloadProto", "translateProto", "ttsMessageProto", "translationMessageProto"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    /**
                     * Creates a new Message instance using the specified properties.
                     * @function create
                     * @memberof ai.talecast.webapp.proto.Message
                     * @static
                     * @param {ai.talecast.webapp.proto.IMessage=} [properties] Properties to set
                     * @returns {ai.talecast.webapp.proto.Message} Message instance
                     */
                    Message.create = function create(properties) {
                        return new Message(properties);
                    };

                    /**
                     * Encodes the specified Message message. Does not implicitly {@link ai.talecast.webapp.proto.Message.verify|verify} messages.
                     * @function encode
                     * @memberof ai.talecast.webapp.proto.Message
                     * @static
                     * @param {ai.talecast.webapp.proto.IMessage} message Message message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Message.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.eventType != null && Object.hasOwnProperty.call(message, "eventType"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.eventType);
                        if (message.loginData != null && Object.hasOwnProperty.call(message, "loginData"))
                            $root.ai.talecast.webapp.proto.LoginData.encode(message.loginData, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        if (message.logoutData != null && Object.hasOwnProperty.call(message, "logoutData"))
                            $root.ai.talecast.webapp.proto.LogoutData.encode(message.logoutData, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                        if (message.updateProfileData != null && Object.hasOwnProperty.call(message, "updateProfileData"))
                            $root.ai.talecast.webapp.proto.UpdateProfileData.encode(message.updateProfileData, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                        if (message.pongData != null && Object.hasOwnProperty.call(message, "pongData"))
                            $root.ai.talecast.webapp.proto.PongData.encode(message.pongData, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                        if (message.userAssetDetails != null && Object.hasOwnProperty.call(message, "userAssetDetails"))
                            $root.ai.talecast.webapp.proto.UserAssetDetailsProto.encode(message.userAssetDetails, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                        if (message.voiceMessageProto != null && Object.hasOwnProperty.call(message, "voiceMessageProto"))
                            $root.ai.talecast.webapp.proto.VoiceMessageProto.encode(message.voiceMessageProto, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                        if (message.projectCreatedProto != null && Object.hasOwnProperty.call(message, "projectCreatedProto"))
                            $root.ai.talecast.webapp.proto.ProjectCreatedProto.encode(message.projectCreatedProto, writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
                        if (message.ttsDetailsProto != null && Object.hasOwnProperty.call(message, "ttsDetailsProto"))
                            $root.ai.talecast.webapp.proto.TtsDetailsProto.encode(message.ttsDetailsProto, writer.uint32(/* id 9, wireType 2 =*/74).fork()).ldelim();
                        if (message.exportProcessProto != null && Object.hasOwnProperty.call(message, "exportProcessProto"))
                            $root.ai.talecast.webapp.proto.ExportProcessProto.encode(message.exportProcessProto, writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
                        if (message.sentenceGeneratedProto != null && Object.hasOwnProperty.call(message, "sentenceGeneratedProto"))
                            $root.ai.talecast.webapp.proto.SentenceGeneratedProto.encode(message.sentenceGeneratedProto, writer.uint32(/* id 11, wireType 2 =*/90).fork()).ldelim();
                        if (message.exportSuccessProto != null && Object.hasOwnProperty.call(message, "exportSuccessProto"))
                            $root.ai.talecast.webapp.proto.ExportSuccessProto.encode(message.exportSuccessProto, writer.uint32(/* id 12, wireType 2 =*/98).fork()).ldelim();
                        if (message.spriteInfoProto != null && Object.hasOwnProperty.call(message, "spriteInfoProto"))
                            $root.ai.talecast.webapp.proto.SpriteInfoProto.encode(message.spriteInfoProto, writer.uint32(/* id 13, wireType 2 =*/106).fork()).ldelim();
                        if (message.exportInterruptedProto != null && Object.hasOwnProperty.call(message, "exportInterruptedProto"))
                            $root.ai.talecast.webapp.proto.ExportInterruptedProto.encode(message.exportInterruptedProto, writer.uint32(/* id 14, wireType 2 =*/114).fork()).ldelim();
                        if (message.transcodeSuccessProto != null && Object.hasOwnProperty.call(message, "transcodeSuccessProto"))
                            $root.ai.talecast.webapp.proto.TranscodeSuccessProto.encode(message.transcodeSuccessProto, writer.uint32(/* id 15, wireType 2 =*/122).fork()).ldelim();
                        if (message.userOrderInfoProto != null && Object.hasOwnProperty.call(message, "userOrderInfoProto"))
                            $root.ai.talecast.webapp.proto.UserOrderInfoProto.encode(message.userOrderInfoProto, writer.uint32(/* id 16, wireType 2 =*/130).fork()).ldelim();
                        if (message.preDownloadProto != null && Object.hasOwnProperty.call(message, "preDownloadProto"))
                            $root.ai.talecast.webapp.proto.PreDownloadProto.encode(message.preDownloadProto, writer.uint32(/* id 17, wireType 2 =*/138).fork()).ldelim();
                        if (message.translateProto != null && Object.hasOwnProperty.call(message, "translateProto"))
                            $root.ai.talecast.webapp.proto.TranslateProto.encode(message.translateProto, writer.uint32(/* id 18, wireType 2 =*/146).fork()).ldelim();
                        if (message.ttsMessageProto != null && Object.hasOwnProperty.call(message, "ttsMessageProto"))
                            $root.ai.talecast.webapp.proto.TtsMessageProto.encode(message.ttsMessageProto, writer.uint32(/* id 19, wireType 2 =*/154).fork()).ldelim();
                        if (message.translationMessageProto != null && Object.hasOwnProperty.call(message, "translationMessageProto"))
                            $root.ai.talecast.webapp.proto.TranslationMessageProto.encode(message.translationMessageProto, writer.uint32(/* id 20, wireType 2 =*/162).fork()).ldelim();
                        return writer;
                    };

                    /**
                     * Encodes the specified Message message, length delimited. Does not implicitly {@link ai.talecast.webapp.proto.Message.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof ai.talecast.webapp.proto.Message
                     * @static
                     * @param {ai.talecast.webapp.proto.IMessage} message Message message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Message.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a Message message from the specified reader or buffer.
                     * @function decode
                     * @memberof ai.talecast.webapp.proto.Message
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {ai.talecast.webapp.proto.Message} Message
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Message.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        const end = length === undefined ? reader.len : reader.pos + length, message = new $root.ai.talecast.webapp.proto.Message();
                        while (reader.pos < end) {
                            const tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.eventType = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.loginData = $root.ai.talecast.webapp.proto.LoginData.decode(reader, reader.uint32());
                                    break;
                                }
                            case 3: {
                                    message.logoutData = $root.ai.talecast.webapp.proto.LogoutData.decode(reader, reader.uint32());
                                    break;
                                }
                            case 4: {
                                    message.updateProfileData = $root.ai.talecast.webapp.proto.UpdateProfileData.decode(reader, reader.uint32());
                                    break;
                                }
                            case 5: {
                                    message.pongData = $root.ai.talecast.webapp.proto.PongData.decode(reader, reader.uint32());
                                    break;
                                }
                            case 6: {
                                    message.userAssetDetails = $root.ai.talecast.webapp.proto.UserAssetDetailsProto.decode(reader, reader.uint32());
                                    break;
                                }
                            case 7: {
                                    message.voiceMessageProto = $root.ai.talecast.webapp.proto.VoiceMessageProto.decode(reader, reader.uint32());
                                    break;
                                }
                            case 8: {
                                    message.projectCreatedProto = $root.ai.talecast.webapp.proto.ProjectCreatedProto.decode(reader, reader.uint32());
                                    break;
                                }
                            case 9: {
                                    message.ttsDetailsProto = $root.ai.talecast.webapp.proto.TtsDetailsProto.decode(reader, reader.uint32());
                                    break;
                                }
                            case 10: {
                                    message.exportProcessProto = $root.ai.talecast.webapp.proto.ExportProcessProto.decode(reader, reader.uint32());
                                    break;
                                }
                            case 11: {
                                    message.sentenceGeneratedProto = $root.ai.talecast.webapp.proto.SentenceGeneratedProto.decode(reader, reader.uint32());
                                    break;
                                }
                            case 12: {
                                    message.exportSuccessProto = $root.ai.talecast.webapp.proto.ExportSuccessProto.decode(reader, reader.uint32());
                                    break;
                                }
                            case 13: {
                                    message.spriteInfoProto = $root.ai.talecast.webapp.proto.SpriteInfoProto.decode(reader, reader.uint32());
                                    break;
                                }
                            case 14: {
                                    message.exportInterruptedProto = $root.ai.talecast.webapp.proto.ExportInterruptedProto.decode(reader, reader.uint32());
                                    break;
                                }
                            case 15: {
                                    message.transcodeSuccessProto = $root.ai.talecast.webapp.proto.TranscodeSuccessProto.decode(reader, reader.uint32());
                                    break;
                                }
                            case 16: {
                                    message.userOrderInfoProto = $root.ai.talecast.webapp.proto.UserOrderInfoProto.decode(reader, reader.uint32());
                                    break;
                                }
                            case 17: {
                                    message.preDownloadProto = $root.ai.talecast.webapp.proto.PreDownloadProto.decode(reader, reader.uint32());
                                    break;
                                }
                            case 18: {
                                    message.translateProto = $root.ai.talecast.webapp.proto.TranslateProto.decode(reader, reader.uint32());
                                    break;
                                }
                            case 19: {
                                    message.ttsMessageProto = $root.ai.talecast.webapp.proto.TtsMessageProto.decode(reader, reader.uint32());
                                    break;
                                }
                            case 20: {
                                    message.translationMessageProto = $root.ai.talecast.webapp.proto.TranslationMessageProto.decode(reader, reader.uint32());
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a Message message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof ai.talecast.webapp.proto.Message
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {ai.talecast.webapp.proto.Message} Message
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Message.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a Message message.
                     * @function verify
                     * @memberof ai.talecast.webapp.proto.Message
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Message.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        const properties = {};
                        if (message.eventType != null && message.hasOwnProperty("eventType"))
                            switch (message.eventType) {
                            default:
                                return "eventType: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                            case 5:
                            case 6:
                            case 7:
                            case 8:
                            case 9:
                            case 10:
                            case 11:
                            case 12:
                            case 13:
                            case 14:
                            case 15:
                            case 16:
                            case 17:
                            case 18:
                            case 19:
                                break;
                            }
                        if (message.loginData != null && message.hasOwnProperty("loginData")) {
                            properties.data = 1;
                            {
                                const error = $root.ai.talecast.webapp.proto.LoginData.verify(message.loginData);
                                if (error)
                                    return "loginData." + error;
                            }
                        }
                        if (message.logoutData != null && message.hasOwnProperty("logoutData")) {
                            if (properties.data === 1)
                                return "data: multiple values";
                            properties.data = 1;
                            {
                                const error = $root.ai.talecast.webapp.proto.LogoutData.verify(message.logoutData);
                                if (error)
                                    return "logoutData." + error;
                            }
                        }
                        if (message.updateProfileData != null && message.hasOwnProperty("updateProfileData")) {
                            if (properties.data === 1)
                                return "data: multiple values";
                            properties.data = 1;
                            {
                                const error = $root.ai.talecast.webapp.proto.UpdateProfileData.verify(message.updateProfileData);
                                if (error)
                                    return "updateProfileData." + error;
                            }
                        }
                        if (message.pongData != null && message.hasOwnProperty("pongData")) {
                            if (properties.data === 1)
                                return "data: multiple values";
                            properties.data = 1;
                            {
                                const error = $root.ai.talecast.webapp.proto.PongData.verify(message.pongData);
                                if (error)
                                    return "pongData." + error;
                            }
                        }
                        if (message.userAssetDetails != null && message.hasOwnProperty("userAssetDetails")) {
                            if (properties.data === 1)
                                return "data: multiple values";
                            properties.data = 1;
                            {
                                const error = $root.ai.talecast.webapp.proto.UserAssetDetailsProto.verify(message.userAssetDetails);
                                if (error)
                                    return "userAssetDetails." + error;
                            }
                        }
                        if (message.voiceMessageProto != null && message.hasOwnProperty("voiceMessageProto")) {
                            if (properties.data === 1)
                                return "data: multiple values";
                            properties.data = 1;
                            {
                                const error = $root.ai.talecast.webapp.proto.VoiceMessageProto.verify(message.voiceMessageProto);
                                if (error)
                                    return "voiceMessageProto." + error;
                            }
                        }
                        if (message.projectCreatedProto != null && message.hasOwnProperty("projectCreatedProto")) {
                            if (properties.data === 1)
                                return "data: multiple values";
                            properties.data = 1;
                            {
                                const error = $root.ai.talecast.webapp.proto.ProjectCreatedProto.verify(message.projectCreatedProto);
                                if (error)
                                    return "projectCreatedProto." + error;
                            }
                        }
                        if (message.ttsDetailsProto != null && message.hasOwnProperty("ttsDetailsProto")) {
                            if (properties.data === 1)
                                return "data: multiple values";
                            properties.data = 1;
                            {
                                const error = $root.ai.talecast.webapp.proto.TtsDetailsProto.verify(message.ttsDetailsProto);
                                if (error)
                                    return "ttsDetailsProto." + error;
                            }
                        }
                        if (message.exportProcessProto != null && message.hasOwnProperty("exportProcessProto")) {
                            if (properties.data === 1)
                                return "data: multiple values";
                            properties.data = 1;
                            {
                                const error = $root.ai.talecast.webapp.proto.ExportProcessProto.verify(message.exportProcessProto);
                                if (error)
                                    return "exportProcessProto." + error;
                            }
                        }
                        if (message.sentenceGeneratedProto != null && message.hasOwnProperty("sentenceGeneratedProto")) {
                            if (properties.data === 1)
                                return "data: multiple values";
                            properties.data = 1;
                            {
                                const error = $root.ai.talecast.webapp.proto.SentenceGeneratedProto.verify(message.sentenceGeneratedProto);
                                if (error)
                                    return "sentenceGeneratedProto." + error;
                            }
                        }
                        if (message.exportSuccessProto != null && message.hasOwnProperty("exportSuccessProto")) {
                            if (properties.data === 1)
                                return "data: multiple values";
                            properties.data = 1;
                            {
                                const error = $root.ai.talecast.webapp.proto.ExportSuccessProto.verify(message.exportSuccessProto);
                                if (error)
                                    return "exportSuccessProto." + error;
                            }
                        }
                        if (message.spriteInfoProto != null && message.hasOwnProperty("spriteInfoProto")) {
                            if (properties.data === 1)
                                return "data: multiple values";
                            properties.data = 1;
                            {
                                const error = $root.ai.talecast.webapp.proto.SpriteInfoProto.verify(message.spriteInfoProto);
                                if (error)
                                    return "spriteInfoProto." + error;
                            }
                        }
                        if (message.exportInterruptedProto != null && message.hasOwnProperty("exportInterruptedProto")) {
                            if (properties.data === 1)
                                return "data: multiple values";
                            properties.data = 1;
                            {
                                const error = $root.ai.talecast.webapp.proto.ExportInterruptedProto.verify(message.exportInterruptedProto);
                                if (error)
                                    return "exportInterruptedProto." + error;
                            }
                        }
                        if (message.transcodeSuccessProto != null && message.hasOwnProperty("transcodeSuccessProto")) {
                            if (properties.data === 1)
                                return "data: multiple values";
                            properties.data = 1;
                            {
                                const error = $root.ai.talecast.webapp.proto.TranscodeSuccessProto.verify(message.transcodeSuccessProto);
                                if (error)
                                    return "transcodeSuccessProto." + error;
                            }
                        }
                        if (message.userOrderInfoProto != null && message.hasOwnProperty("userOrderInfoProto")) {
                            if (properties.data === 1)
                                return "data: multiple values";
                            properties.data = 1;
                            {
                                const error = $root.ai.talecast.webapp.proto.UserOrderInfoProto.verify(message.userOrderInfoProto);
                                if (error)
                                    return "userOrderInfoProto." + error;
                            }
                        }
                        if (message.preDownloadProto != null && message.hasOwnProperty("preDownloadProto")) {
                            if (properties.data === 1)
                                return "data: multiple values";
                            properties.data = 1;
                            {
                                const error = $root.ai.talecast.webapp.proto.PreDownloadProto.verify(message.preDownloadProto);
                                if (error)
                                    return "preDownloadProto." + error;
                            }
                        }
                        if (message.translateProto != null && message.hasOwnProperty("translateProto")) {
                            if (properties.data === 1)
                                return "data: multiple values";
                            properties.data = 1;
                            {
                                const error = $root.ai.talecast.webapp.proto.TranslateProto.verify(message.translateProto);
                                if (error)
                                    return "translateProto." + error;
                            }
                        }
                        if (message.ttsMessageProto != null && message.hasOwnProperty("ttsMessageProto")) {
                            if (properties.data === 1)
                                return "data: multiple values";
                            properties.data = 1;
                            {
                                const error = $root.ai.talecast.webapp.proto.TtsMessageProto.verify(message.ttsMessageProto);
                                if (error)
                                    return "ttsMessageProto." + error;
                            }
                        }
                        if (message.translationMessageProto != null && message.hasOwnProperty("translationMessageProto")) {
                            if (properties.data === 1)
                                return "data: multiple values";
                            properties.data = 1;
                            {
                                const error = $root.ai.talecast.webapp.proto.TranslationMessageProto.verify(message.translationMessageProto);
                                if (error)
                                    return "translationMessageProto." + error;
                            }
                        }
                        return null;
                    };

                    /**
                     * Creates a Message message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof ai.talecast.webapp.proto.Message
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {ai.talecast.webapp.proto.Message} Message
                     */
                    Message.fromObject = function fromObject(object) {
                        if (object instanceof $root.ai.talecast.webapp.proto.Message)
                            return object;
                        const message = new $root.ai.talecast.webapp.proto.Message();
                        switch (object.eventType) {
                        default:
                            if (typeof object.eventType === "number") {
                                message.eventType = object.eventType;
                                break;
                            }
                            break;
                        case "LOGIN":
                        case 0:
                            message.eventType = 0;
                            break;
                        case "LOGOUT":
                        case 1:
                            message.eventType = 1;
                            break;
                        case "UPDATE_PROFILE":
                        case 2:
                            message.eventType = 2;
                            break;
                        case "PONG":
                        case 3:
                            message.eventType = 3;
                            break;
                        case "USER_ASSET_DETAILS":
                        case 4:
                            message.eventType = 4;
                            break;
                        case "CLONE_VOICE":
                        case 5:
                            message.eventType = 5;
                            break;
                        case "PROJECT_CREATED":
                        case 6:
                            message.eventType = 6;
                            break;
                        case "TTS_MESSAGE":
                        case 7:
                            message.eventType = 7;
                            break;
                        case "EXPORT_PROCESS":
                        case 8:
                            message.eventType = 8;
                            break;
                        case "USER_LEVEL_CHANGED":
                        case 9:
                            message.eventType = 9;
                            break;
                        case "SENTENCE_GENERATED":
                        case 10:
                            message.eventType = 10;
                            break;
                        case "EXPORT_SUCCESS":
                        case 11:
                            message.eventType = 11;
                            break;
                        case "SPRITE_GENERATED":
                        case 12:
                            message.eventType = 12;
                            break;
                        case "EXPORT_INTERRUPTED":
                        case 13:
                            message.eventType = 13;
                            break;
                        case "TRANSCODE_SUCCESS":
                        case 14:
                            message.eventType = 14;
                            break;
                        case "PRE_DOWNLOAD_COMPLETE":
                        case 15:
                            message.eventType = 15;
                            break;
                        case "VOICE_MODEL_CREATED":
                        case 16:
                            message.eventType = 16;
                            break;
                        case "TRANSLATE_COMPLETE":
                        case 17:
                            message.eventType = 17;
                            break;
                        case "TTS_DETAIL":
                        case 18:
                            message.eventType = 18;
                            break;
                        case "TRANSLATION_MESSAGE":
                        case 19:
                            message.eventType = 19;
                            break;
                        }
                        if (object.loginData != null) {
                            if (typeof object.loginData !== "object")
                                throw TypeError(".ai.talecast.webapp.proto.Message.loginData: object expected");
                            message.loginData = $root.ai.talecast.webapp.proto.LoginData.fromObject(object.loginData);
                        }
                        if (object.logoutData != null) {
                            if (typeof object.logoutData !== "object")
                                throw TypeError(".ai.talecast.webapp.proto.Message.logoutData: object expected");
                            message.logoutData = $root.ai.talecast.webapp.proto.LogoutData.fromObject(object.logoutData);
                        }
                        if (object.updateProfileData != null) {
                            if (typeof object.updateProfileData !== "object")
                                throw TypeError(".ai.talecast.webapp.proto.Message.updateProfileData: object expected");
                            message.updateProfileData = $root.ai.talecast.webapp.proto.UpdateProfileData.fromObject(object.updateProfileData);
                        }
                        if (object.pongData != null) {
                            if (typeof object.pongData !== "object")
                                throw TypeError(".ai.talecast.webapp.proto.Message.pongData: object expected");
                            message.pongData = $root.ai.talecast.webapp.proto.PongData.fromObject(object.pongData);
                        }
                        if (object.userAssetDetails != null) {
                            if (typeof object.userAssetDetails !== "object")
                                throw TypeError(".ai.talecast.webapp.proto.Message.userAssetDetails: object expected");
                            message.userAssetDetails = $root.ai.talecast.webapp.proto.UserAssetDetailsProto.fromObject(object.userAssetDetails);
                        }
                        if (object.voiceMessageProto != null) {
                            if (typeof object.voiceMessageProto !== "object")
                                throw TypeError(".ai.talecast.webapp.proto.Message.voiceMessageProto: object expected");
                            message.voiceMessageProto = $root.ai.talecast.webapp.proto.VoiceMessageProto.fromObject(object.voiceMessageProto);
                        }
                        if (object.projectCreatedProto != null) {
                            if (typeof object.projectCreatedProto !== "object")
                                throw TypeError(".ai.talecast.webapp.proto.Message.projectCreatedProto: object expected");
                            message.projectCreatedProto = $root.ai.talecast.webapp.proto.ProjectCreatedProto.fromObject(object.projectCreatedProto);
                        }
                        if (object.ttsDetailsProto != null) {
                            if (typeof object.ttsDetailsProto !== "object")
                                throw TypeError(".ai.talecast.webapp.proto.Message.ttsDetailsProto: object expected");
                            message.ttsDetailsProto = $root.ai.talecast.webapp.proto.TtsDetailsProto.fromObject(object.ttsDetailsProto);
                        }
                        if (object.exportProcessProto != null) {
                            if (typeof object.exportProcessProto !== "object")
                                throw TypeError(".ai.talecast.webapp.proto.Message.exportProcessProto: object expected");
                            message.exportProcessProto = $root.ai.talecast.webapp.proto.ExportProcessProto.fromObject(object.exportProcessProto);
                        }
                        if (object.sentenceGeneratedProto != null) {
                            if (typeof object.sentenceGeneratedProto !== "object")
                                throw TypeError(".ai.talecast.webapp.proto.Message.sentenceGeneratedProto: object expected");
                            message.sentenceGeneratedProto = $root.ai.talecast.webapp.proto.SentenceGeneratedProto.fromObject(object.sentenceGeneratedProto);
                        }
                        if (object.exportSuccessProto != null) {
                            if (typeof object.exportSuccessProto !== "object")
                                throw TypeError(".ai.talecast.webapp.proto.Message.exportSuccessProto: object expected");
                            message.exportSuccessProto = $root.ai.talecast.webapp.proto.ExportSuccessProto.fromObject(object.exportSuccessProto);
                        }
                        if (object.spriteInfoProto != null) {
                            if (typeof object.spriteInfoProto !== "object")
                                throw TypeError(".ai.talecast.webapp.proto.Message.spriteInfoProto: object expected");
                            message.spriteInfoProto = $root.ai.talecast.webapp.proto.SpriteInfoProto.fromObject(object.spriteInfoProto);
                        }
                        if (object.exportInterruptedProto != null) {
                            if (typeof object.exportInterruptedProto !== "object")
                                throw TypeError(".ai.talecast.webapp.proto.Message.exportInterruptedProto: object expected");
                            message.exportInterruptedProto = $root.ai.talecast.webapp.proto.ExportInterruptedProto.fromObject(object.exportInterruptedProto);
                        }
                        if (object.transcodeSuccessProto != null) {
                            if (typeof object.transcodeSuccessProto !== "object")
                                throw TypeError(".ai.talecast.webapp.proto.Message.transcodeSuccessProto: object expected");
                            message.transcodeSuccessProto = $root.ai.talecast.webapp.proto.TranscodeSuccessProto.fromObject(object.transcodeSuccessProto);
                        }
                        if (object.userOrderInfoProto != null) {
                            if (typeof object.userOrderInfoProto !== "object")
                                throw TypeError(".ai.talecast.webapp.proto.Message.userOrderInfoProto: object expected");
                            message.userOrderInfoProto = $root.ai.talecast.webapp.proto.UserOrderInfoProto.fromObject(object.userOrderInfoProto);
                        }
                        if (object.preDownloadProto != null) {
                            if (typeof object.preDownloadProto !== "object")
                                throw TypeError(".ai.talecast.webapp.proto.Message.preDownloadProto: object expected");
                            message.preDownloadProto = $root.ai.talecast.webapp.proto.PreDownloadProto.fromObject(object.preDownloadProto);
                        }
                        if (object.translateProto != null) {
                            if (typeof object.translateProto !== "object")
                                throw TypeError(".ai.talecast.webapp.proto.Message.translateProto: object expected");
                            message.translateProto = $root.ai.talecast.webapp.proto.TranslateProto.fromObject(object.translateProto);
                        }
                        if (object.ttsMessageProto != null) {
                            if (typeof object.ttsMessageProto !== "object")
                                throw TypeError(".ai.talecast.webapp.proto.Message.ttsMessageProto: object expected");
                            message.ttsMessageProto = $root.ai.talecast.webapp.proto.TtsMessageProto.fromObject(object.ttsMessageProto);
                        }
                        if (object.translationMessageProto != null) {
                            if (typeof object.translationMessageProto !== "object")
                                throw TypeError(".ai.talecast.webapp.proto.Message.translationMessageProto: object expected");
                            message.translationMessageProto = $root.ai.talecast.webapp.proto.TranslationMessageProto.fromObject(object.translationMessageProto);
                        }
                        return message;
                    };

                    /**
                     * Creates a plain object from a Message message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof ai.talecast.webapp.proto.Message
                     * @static
                     * @param {ai.talecast.webapp.proto.Message} message Message
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Message.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        const object = {};
                        if (options.defaults)
                            object.eventType = options.enums === String ? "LOGIN" : 0;
                        if (message.eventType != null && message.hasOwnProperty("eventType"))
                            object.eventType = options.enums === String ? $root.ai.talecast.webapp.proto.WsEventTypeProto[message.eventType] === undefined ? message.eventType : $root.ai.talecast.webapp.proto.WsEventTypeProto[message.eventType] : message.eventType;
                        if (message.loginData != null && message.hasOwnProperty("loginData")) {
                            object.loginData = $root.ai.talecast.webapp.proto.LoginData.toObject(message.loginData, options);
                            if (options.oneofs)
                                object.data = "loginData";
                        }
                        if (message.logoutData != null && message.hasOwnProperty("logoutData")) {
                            object.logoutData = $root.ai.talecast.webapp.proto.LogoutData.toObject(message.logoutData, options);
                            if (options.oneofs)
                                object.data = "logoutData";
                        }
                        if (message.updateProfileData != null && message.hasOwnProperty("updateProfileData")) {
                            object.updateProfileData = $root.ai.talecast.webapp.proto.UpdateProfileData.toObject(message.updateProfileData, options);
                            if (options.oneofs)
                                object.data = "updateProfileData";
                        }
                        if (message.pongData != null && message.hasOwnProperty("pongData")) {
                            object.pongData = $root.ai.talecast.webapp.proto.PongData.toObject(message.pongData, options);
                            if (options.oneofs)
                                object.data = "pongData";
                        }
                        if (message.userAssetDetails != null && message.hasOwnProperty("userAssetDetails")) {
                            object.userAssetDetails = $root.ai.talecast.webapp.proto.UserAssetDetailsProto.toObject(message.userAssetDetails, options);
                            if (options.oneofs)
                                object.data = "userAssetDetails";
                        }
                        if (message.voiceMessageProto != null && message.hasOwnProperty("voiceMessageProto")) {
                            object.voiceMessageProto = $root.ai.talecast.webapp.proto.VoiceMessageProto.toObject(message.voiceMessageProto, options);
                            if (options.oneofs)
                                object.data = "voiceMessageProto";
                        }
                        if (message.projectCreatedProto != null && message.hasOwnProperty("projectCreatedProto")) {
                            object.projectCreatedProto = $root.ai.talecast.webapp.proto.ProjectCreatedProto.toObject(message.projectCreatedProto, options);
                            if (options.oneofs)
                                object.data = "projectCreatedProto";
                        }
                        if (message.ttsDetailsProto != null && message.hasOwnProperty("ttsDetailsProto")) {
                            object.ttsDetailsProto = $root.ai.talecast.webapp.proto.TtsDetailsProto.toObject(message.ttsDetailsProto, options);
                            if (options.oneofs)
                                object.data = "ttsDetailsProto";
                        }
                        if (message.exportProcessProto != null && message.hasOwnProperty("exportProcessProto")) {
                            object.exportProcessProto = $root.ai.talecast.webapp.proto.ExportProcessProto.toObject(message.exportProcessProto, options);
                            if (options.oneofs)
                                object.data = "exportProcessProto";
                        }
                        if (message.sentenceGeneratedProto != null && message.hasOwnProperty("sentenceGeneratedProto")) {
                            object.sentenceGeneratedProto = $root.ai.talecast.webapp.proto.SentenceGeneratedProto.toObject(message.sentenceGeneratedProto, options);
                            if (options.oneofs)
                                object.data = "sentenceGeneratedProto";
                        }
                        if (message.exportSuccessProto != null && message.hasOwnProperty("exportSuccessProto")) {
                            object.exportSuccessProto = $root.ai.talecast.webapp.proto.ExportSuccessProto.toObject(message.exportSuccessProto, options);
                            if (options.oneofs)
                                object.data = "exportSuccessProto";
                        }
                        if (message.spriteInfoProto != null && message.hasOwnProperty("spriteInfoProto")) {
                            object.spriteInfoProto = $root.ai.talecast.webapp.proto.SpriteInfoProto.toObject(message.spriteInfoProto, options);
                            if (options.oneofs)
                                object.data = "spriteInfoProto";
                        }
                        if (message.exportInterruptedProto != null && message.hasOwnProperty("exportInterruptedProto")) {
                            object.exportInterruptedProto = $root.ai.talecast.webapp.proto.ExportInterruptedProto.toObject(message.exportInterruptedProto, options);
                            if (options.oneofs)
                                object.data = "exportInterruptedProto";
                        }
                        if (message.transcodeSuccessProto != null && message.hasOwnProperty("transcodeSuccessProto")) {
                            object.transcodeSuccessProto = $root.ai.talecast.webapp.proto.TranscodeSuccessProto.toObject(message.transcodeSuccessProto, options);
                            if (options.oneofs)
                                object.data = "transcodeSuccessProto";
                        }
                        if (message.userOrderInfoProto != null && message.hasOwnProperty("userOrderInfoProto")) {
                            object.userOrderInfoProto = $root.ai.talecast.webapp.proto.UserOrderInfoProto.toObject(message.userOrderInfoProto, options);
                            if (options.oneofs)
                                object.data = "userOrderInfoProto";
                        }
                        if (message.preDownloadProto != null && message.hasOwnProperty("preDownloadProto")) {
                            object.preDownloadProto = $root.ai.talecast.webapp.proto.PreDownloadProto.toObject(message.preDownloadProto, options);
                            if (options.oneofs)
                                object.data = "preDownloadProto";
                        }
                        if (message.translateProto != null && message.hasOwnProperty("translateProto")) {
                            object.translateProto = $root.ai.talecast.webapp.proto.TranslateProto.toObject(message.translateProto, options);
                            if (options.oneofs)
                                object.data = "translateProto";
                        }
                        if (message.ttsMessageProto != null && message.hasOwnProperty("ttsMessageProto")) {
                            object.ttsMessageProto = $root.ai.talecast.webapp.proto.TtsMessageProto.toObject(message.ttsMessageProto, options);
                            if (options.oneofs)
                                object.data = "ttsMessageProto";
                        }
                        if (message.translationMessageProto != null && message.hasOwnProperty("translationMessageProto")) {
                            object.translationMessageProto = $root.ai.talecast.webapp.proto.TranslationMessageProto.toObject(message.translationMessageProto, options);
                            if (options.oneofs)
                                object.data = "translationMessageProto";
                        }
                        return object;
                    };

                    /**
                     * Converts this Message to JSON.
                     * @function toJSON
                     * @memberof ai.talecast.webapp.proto.Message
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Message.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for Message
                     * @function getTypeUrl
                     * @memberof ai.talecast.webapp.proto.Message
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    Message.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/ai.talecast.webapp.proto.Message";
                    };

                    return Message;
                })();

                /**
                 * WsEventTypeProto enum.
                 * @name ai.talecast.webapp.proto.WsEventTypeProto
                 * @enum {number}
                 * @property {number} LOGIN=0 LOGIN value
                 * @property {number} LOGOUT=1 LOGOUT value
                 * @property {number} UPDATE_PROFILE=2 UPDATE_PROFILE value
                 * @property {number} PONG=3 PONG value
                 * @property {number} USER_ASSET_DETAILS=4 USER_ASSET_DETAILS value
                 * @property {number} CLONE_VOICE=5 CLONE_VOICE value
                 * @property {number} PROJECT_CREATED=6 PROJECT_CREATED value
                 * @property {number} TTS_MESSAGE=7 TTS_MESSAGE value
                 * @property {number} EXPORT_PROCESS=8 EXPORT_PROCESS value
                 * @property {number} USER_LEVEL_CHANGED=9 USER_LEVEL_CHANGED value
                 * @property {number} SENTENCE_GENERATED=10 SENTENCE_GENERATED value
                 * @property {number} EXPORT_SUCCESS=11 EXPORT_SUCCESS value
                 * @property {number} SPRITE_GENERATED=12 SPRITE_GENERATED value
                 * @property {number} EXPORT_INTERRUPTED=13 EXPORT_INTERRUPTED value
                 * @property {number} TRANSCODE_SUCCESS=14 TRANSCODE_SUCCESS value
                 * @property {number} PRE_DOWNLOAD_COMPLETE=15 PRE_DOWNLOAD_COMPLETE value
                 * @property {number} VOICE_MODEL_CREATED=16 VOICE_MODEL_CREATED value
                 * @property {number} TRANSLATE_COMPLETE=17 TRANSLATE_COMPLETE value
                 * @property {number} TTS_DETAIL=18 TTS_DETAIL value
                 * @property {number} TRANSLATION_MESSAGE=19 TRANSLATION_MESSAGE value
                 */
                proto.WsEventTypeProto = (function() {
                    const valuesById = {}, values = Object.create(valuesById);
                    values[valuesById[0] = "LOGIN"] = 0;
                    values[valuesById[1] = "LOGOUT"] = 1;
                    values[valuesById[2] = "UPDATE_PROFILE"] = 2;
                    values[valuesById[3] = "PONG"] = 3;
                    values[valuesById[4] = "USER_ASSET_DETAILS"] = 4;
                    values[valuesById[5] = "CLONE_VOICE"] = 5;
                    values[valuesById[6] = "PROJECT_CREATED"] = 6;
                    values[valuesById[7] = "TTS_MESSAGE"] = 7;
                    values[valuesById[8] = "EXPORT_PROCESS"] = 8;
                    values[valuesById[9] = "USER_LEVEL_CHANGED"] = 9;
                    values[valuesById[10] = "SENTENCE_GENERATED"] = 10;
                    values[valuesById[11] = "EXPORT_SUCCESS"] = 11;
                    values[valuesById[12] = "SPRITE_GENERATED"] = 12;
                    values[valuesById[13] = "EXPORT_INTERRUPTED"] = 13;
                    values[valuesById[14] = "TRANSCODE_SUCCESS"] = 14;
                    values[valuesById[15] = "PRE_DOWNLOAD_COMPLETE"] = 15;
                    values[valuesById[16] = "VOICE_MODEL_CREATED"] = 16;
                    values[valuesById[17] = "TRANSLATE_COMPLETE"] = 17;
                    values[valuesById[18] = "TTS_DETAIL"] = 18;
                    values[valuesById[19] = "TRANSLATION_MESSAGE"] = 19;
                    return values;
                })();

                proto.LoginData = (function() {

                    /**
                     * Properties of a LoginData.
                     * @memberof ai.talecast.webapp.proto
                     * @interface ILoginData
                     * @property {string|null} [username] LoginData username
                     * @property {string|null} [password] LoginData password
                     */

                    /**
                     * Constructs a new LoginData.
                     * @memberof ai.talecast.webapp.proto
                     * @classdesc Represents a LoginData.
                     * @implements ILoginData
                     * @constructor
                     * @param {ai.talecast.webapp.proto.ILoginData=} [properties] Properties to set
                     */
                    function LoginData(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * LoginData username.
                     * @member {string} username
                     * @memberof ai.talecast.webapp.proto.LoginData
                     * @instance
                     */
                    LoginData.prototype.username = "";

                    /**
                     * LoginData password.
                     * @member {string} password
                     * @memberof ai.talecast.webapp.proto.LoginData
                     * @instance
                     */
                    LoginData.prototype.password = "";

                    /**
                     * Creates a new LoginData instance using the specified properties.
                     * @function create
                     * @memberof ai.talecast.webapp.proto.LoginData
                     * @static
                     * @param {ai.talecast.webapp.proto.ILoginData=} [properties] Properties to set
                     * @returns {ai.talecast.webapp.proto.LoginData} LoginData instance
                     */
                    LoginData.create = function create(properties) {
                        return new LoginData(properties);
                    };

                    /**
                     * Encodes the specified LoginData message. Does not implicitly {@link ai.talecast.webapp.proto.LoginData.verify|verify} messages.
                     * @function encode
                     * @memberof ai.talecast.webapp.proto.LoginData
                     * @static
                     * @param {ai.talecast.webapp.proto.ILoginData} message LoginData message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    LoginData.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.username != null && Object.hasOwnProperty.call(message, "username"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.username);
                        if (message.password != null && Object.hasOwnProperty.call(message, "password"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.password);
                        return writer;
                    };

                    /**
                     * Encodes the specified LoginData message, length delimited. Does not implicitly {@link ai.talecast.webapp.proto.LoginData.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof ai.talecast.webapp.proto.LoginData
                     * @static
                     * @param {ai.talecast.webapp.proto.ILoginData} message LoginData message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    LoginData.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a LoginData message from the specified reader or buffer.
                     * @function decode
                     * @memberof ai.talecast.webapp.proto.LoginData
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {ai.talecast.webapp.proto.LoginData} LoginData
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    LoginData.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        const end = length === undefined ? reader.len : reader.pos + length, message = new $root.ai.talecast.webapp.proto.LoginData();
                        while (reader.pos < end) {
                            const tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.username = reader.string();
                                    break;
                                }
                            case 2: {
                                    message.password = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a LoginData message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof ai.talecast.webapp.proto.LoginData
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {ai.talecast.webapp.proto.LoginData} LoginData
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    LoginData.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a LoginData message.
                     * @function verify
                     * @memberof ai.talecast.webapp.proto.LoginData
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    LoginData.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.username != null && message.hasOwnProperty("username"))
                            if (!$util.isString(message.username))
                                return "username: string expected";
                        if (message.password != null && message.hasOwnProperty("password"))
                            if (!$util.isString(message.password))
                                return "password: string expected";
                        return null;
                    };

                    /**
                     * Creates a LoginData message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof ai.talecast.webapp.proto.LoginData
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {ai.talecast.webapp.proto.LoginData} LoginData
                     */
                    LoginData.fromObject = function fromObject(object) {
                        if (object instanceof $root.ai.talecast.webapp.proto.LoginData)
                            return object;
                        const message = new $root.ai.talecast.webapp.proto.LoginData();
                        if (object.username != null)
                            message.username = String(object.username);
                        if (object.password != null)
                            message.password = String(object.password);
                        return message;
                    };

                    /**
                     * Creates a plain object from a LoginData message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof ai.talecast.webapp.proto.LoginData
                     * @static
                     * @param {ai.talecast.webapp.proto.LoginData} message LoginData
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    LoginData.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        const object = {};
                        if (options.defaults) {
                            object.username = "";
                            object.password = "";
                        }
                        if (message.username != null && message.hasOwnProperty("username"))
                            object.username = message.username;
                        if (message.password != null && message.hasOwnProperty("password"))
                            object.password = message.password;
                        return object;
                    };

                    /**
                     * Converts this LoginData to JSON.
                     * @function toJSON
                     * @memberof ai.talecast.webapp.proto.LoginData
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    LoginData.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for LoginData
                     * @function getTypeUrl
                     * @memberof ai.talecast.webapp.proto.LoginData
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    LoginData.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/ai.talecast.webapp.proto.LoginData";
                    };

                    return LoginData;
                })();

                proto.LogoutData = (function() {

                    /**
                     * Properties of a LogoutData.
                     * @memberof ai.talecast.webapp.proto
                     * @interface ILogoutData
                     * @property {string|null} [userId] LogoutData userId
                     */

                    /**
                     * Constructs a new LogoutData.
                     * @memberof ai.talecast.webapp.proto
                     * @classdesc Represents a LogoutData.
                     * @implements ILogoutData
                     * @constructor
                     * @param {ai.talecast.webapp.proto.ILogoutData=} [properties] Properties to set
                     */
                    function LogoutData(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * LogoutData userId.
                     * @member {string} userId
                     * @memberof ai.talecast.webapp.proto.LogoutData
                     * @instance
                     */
                    LogoutData.prototype.userId = "";

                    /**
                     * Creates a new LogoutData instance using the specified properties.
                     * @function create
                     * @memberof ai.talecast.webapp.proto.LogoutData
                     * @static
                     * @param {ai.talecast.webapp.proto.ILogoutData=} [properties] Properties to set
                     * @returns {ai.talecast.webapp.proto.LogoutData} LogoutData instance
                     */
                    LogoutData.create = function create(properties) {
                        return new LogoutData(properties);
                    };

                    /**
                     * Encodes the specified LogoutData message. Does not implicitly {@link ai.talecast.webapp.proto.LogoutData.verify|verify} messages.
                     * @function encode
                     * @memberof ai.talecast.webapp.proto.LogoutData
                     * @static
                     * @param {ai.talecast.webapp.proto.ILogoutData} message LogoutData message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    LogoutData.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.userId != null && Object.hasOwnProperty.call(message, "userId"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.userId);
                        return writer;
                    };

                    /**
                     * Encodes the specified LogoutData message, length delimited. Does not implicitly {@link ai.talecast.webapp.proto.LogoutData.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof ai.talecast.webapp.proto.LogoutData
                     * @static
                     * @param {ai.talecast.webapp.proto.ILogoutData} message LogoutData message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    LogoutData.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a LogoutData message from the specified reader or buffer.
                     * @function decode
                     * @memberof ai.talecast.webapp.proto.LogoutData
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {ai.talecast.webapp.proto.LogoutData} LogoutData
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    LogoutData.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        const end = length === undefined ? reader.len : reader.pos + length, message = new $root.ai.talecast.webapp.proto.LogoutData();
                        while (reader.pos < end) {
                            const tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.userId = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a LogoutData message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof ai.talecast.webapp.proto.LogoutData
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {ai.talecast.webapp.proto.LogoutData} LogoutData
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    LogoutData.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a LogoutData message.
                     * @function verify
                     * @memberof ai.talecast.webapp.proto.LogoutData
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    LogoutData.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.userId != null && message.hasOwnProperty("userId"))
                            if (!$util.isString(message.userId))
                                return "userId: string expected";
                        return null;
                    };

                    /**
                     * Creates a LogoutData message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof ai.talecast.webapp.proto.LogoutData
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {ai.talecast.webapp.proto.LogoutData} LogoutData
                     */
                    LogoutData.fromObject = function fromObject(object) {
                        if (object instanceof $root.ai.talecast.webapp.proto.LogoutData)
                            return object;
                        const message = new $root.ai.talecast.webapp.proto.LogoutData();
                        if (object.userId != null)
                            message.userId = String(object.userId);
                        return message;
                    };

                    /**
                     * Creates a plain object from a LogoutData message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof ai.talecast.webapp.proto.LogoutData
                     * @static
                     * @param {ai.talecast.webapp.proto.LogoutData} message LogoutData
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    LogoutData.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        const object = {};
                        if (options.defaults)
                            object.userId = "";
                        if (message.userId != null && message.hasOwnProperty("userId"))
                            object.userId = message.userId;
                        return object;
                    };

                    /**
                     * Converts this LogoutData to JSON.
                     * @function toJSON
                     * @memberof ai.talecast.webapp.proto.LogoutData
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    LogoutData.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for LogoutData
                     * @function getTypeUrl
                     * @memberof ai.talecast.webapp.proto.LogoutData
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    LogoutData.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/ai.talecast.webapp.proto.LogoutData";
                    };

                    return LogoutData;
                })();

                proto.UpdateProfileData = (function() {

                    /**
                     * Properties of an UpdateProfileData.
                     * @memberof ai.talecast.webapp.proto
                     * @interface IUpdateProfileData
                     * @property {string|null} [userId] UpdateProfileData userId
                     * @property {string|null} [newName] UpdateProfileData newName
                     * @property {string|null} [newEmail] UpdateProfileData newEmail
                     */

                    /**
                     * Constructs a new UpdateProfileData.
                     * @memberof ai.talecast.webapp.proto
                     * @classdesc Represents an UpdateProfileData.
                     * @implements IUpdateProfileData
                     * @constructor
                     * @param {ai.talecast.webapp.proto.IUpdateProfileData=} [properties] Properties to set
                     */
                    function UpdateProfileData(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * UpdateProfileData userId.
                     * @member {string} userId
                     * @memberof ai.talecast.webapp.proto.UpdateProfileData
                     * @instance
                     */
                    UpdateProfileData.prototype.userId = "";

                    /**
                     * UpdateProfileData newName.
                     * @member {string} newName
                     * @memberof ai.talecast.webapp.proto.UpdateProfileData
                     * @instance
                     */
                    UpdateProfileData.prototype.newName = "";

                    /**
                     * UpdateProfileData newEmail.
                     * @member {string} newEmail
                     * @memberof ai.talecast.webapp.proto.UpdateProfileData
                     * @instance
                     */
                    UpdateProfileData.prototype.newEmail = "";

                    /**
                     * Creates a new UpdateProfileData instance using the specified properties.
                     * @function create
                     * @memberof ai.talecast.webapp.proto.UpdateProfileData
                     * @static
                     * @param {ai.talecast.webapp.proto.IUpdateProfileData=} [properties] Properties to set
                     * @returns {ai.talecast.webapp.proto.UpdateProfileData} UpdateProfileData instance
                     */
                    UpdateProfileData.create = function create(properties) {
                        return new UpdateProfileData(properties);
                    };

                    /**
                     * Encodes the specified UpdateProfileData message. Does not implicitly {@link ai.talecast.webapp.proto.UpdateProfileData.verify|verify} messages.
                     * @function encode
                     * @memberof ai.talecast.webapp.proto.UpdateProfileData
                     * @static
                     * @param {ai.talecast.webapp.proto.IUpdateProfileData} message UpdateProfileData message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateProfileData.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.userId != null && Object.hasOwnProperty.call(message, "userId"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.userId);
                        if (message.newName != null && Object.hasOwnProperty.call(message, "newName"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.newName);
                        if (message.newEmail != null && Object.hasOwnProperty.call(message, "newEmail"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.newEmail);
                        return writer;
                    };

                    /**
                     * Encodes the specified UpdateProfileData message, length delimited. Does not implicitly {@link ai.talecast.webapp.proto.UpdateProfileData.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof ai.talecast.webapp.proto.UpdateProfileData
                     * @static
                     * @param {ai.talecast.webapp.proto.IUpdateProfileData} message UpdateProfileData message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateProfileData.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes an UpdateProfileData message from the specified reader or buffer.
                     * @function decode
                     * @memberof ai.talecast.webapp.proto.UpdateProfileData
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {ai.talecast.webapp.proto.UpdateProfileData} UpdateProfileData
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateProfileData.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        const end = length === undefined ? reader.len : reader.pos + length, message = new $root.ai.talecast.webapp.proto.UpdateProfileData();
                        while (reader.pos < end) {
                            const tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.userId = reader.string();
                                    break;
                                }
                            case 2: {
                                    message.newName = reader.string();
                                    break;
                                }
                            case 3: {
                                    message.newEmail = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes an UpdateProfileData message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof ai.talecast.webapp.proto.UpdateProfileData
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {ai.talecast.webapp.proto.UpdateProfileData} UpdateProfileData
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateProfileData.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies an UpdateProfileData message.
                     * @function verify
                     * @memberof ai.talecast.webapp.proto.UpdateProfileData
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    UpdateProfileData.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.userId != null && message.hasOwnProperty("userId"))
                            if (!$util.isString(message.userId))
                                return "userId: string expected";
                        if (message.newName != null && message.hasOwnProperty("newName"))
                            if (!$util.isString(message.newName))
                                return "newName: string expected";
                        if (message.newEmail != null && message.hasOwnProperty("newEmail"))
                            if (!$util.isString(message.newEmail))
                                return "newEmail: string expected";
                        return null;
                    };

                    /**
                     * Creates an UpdateProfileData message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof ai.talecast.webapp.proto.UpdateProfileData
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {ai.talecast.webapp.proto.UpdateProfileData} UpdateProfileData
                     */
                    UpdateProfileData.fromObject = function fromObject(object) {
                        if (object instanceof $root.ai.talecast.webapp.proto.UpdateProfileData)
                            return object;
                        const message = new $root.ai.talecast.webapp.proto.UpdateProfileData();
                        if (object.userId != null)
                            message.userId = String(object.userId);
                        if (object.newName != null)
                            message.newName = String(object.newName);
                        if (object.newEmail != null)
                            message.newEmail = String(object.newEmail);
                        return message;
                    };

                    /**
                     * Creates a plain object from an UpdateProfileData message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof ai.talecast.webapp.proto.UpdateProfileData
                     * @static
                     * @param {ai.talecast.webapp.proto.UpdateProfileData} message UpdateProfileData
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    UpdateProfileData.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        const object = {};
                        if (options.defaults) {
                            object.userId = "";
                            object.newName = "";
                            object.newEmail = "";
                        }
                        if (message.userId != null && message.hasOwnProperty("userId"))
                            object.userId = message.userId;
                        if (message.newName != null && message.hasOwnProperty("newName"))
                            object.newName = message.newName;
                        if (message.newEmail != null && message.hasOwnProperty("newEmail"))
                            object.newEmail = message.newEmail;
                        return object;
                    };

                    /**
                     * Converts this UpdateProfileData to JSON.
                     * @function toJSON
                     * @memberof ai.talecast.webapp.proto.UpdateProfileData
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    UpdateProfileData.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for UpdateProfileData
                     * @function getTypeUrl
                     * @memberof ai.talecast.webapp.proto.UpdateProfileData
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    UpdateProfileData.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/ai.talecast.webapp.proto.UpdateProfileData";
                    };

                    return UpdateProfileData;
                })();

                proto.PongData = (function() {

                    /**
                     * Properties of a PongData.
                     * @memberof ai.talecast.webapp.proto
                     * @interface IPongData
                     * @property {string|null} [pongMsg] PongData pongMsg
                     */

                    /**
                     * Constructs a new PongData.
                     * @memberof ai.talecast.webapp.proto
                     * @classdesc Represents a PongData.
                     * @implements IPongData
                     * @constructor
                     * @param {ai.talecast.webapp.proto.IPongData=} [properties] Properties to set
                     */
                    function PongData(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * PongData pongMsg.
                     * @member {string} pongMsg
                     * @memberof ai.talecast.webapp.proto.PongData
                     * @instance
                     */
                    PongData.prototype.pongMsg = "";

                    /**
                     * Creates a new PongData instance using the specified properties.
                     * @function create
                     * @memberof ai.talecast.webapp.proto.PongData
                     * @static
                     * @param {ai.talecast.webapp.proto.IPongData=} [properties] Properties to set
                     * @returns {ai.talecast.webapp.proto.PongData} PongData instance
                     */
                    PongData.create = function create(properties) {
                        return new PongData(properties);
                    };

                    /**
                     * Encodes the specified PongData message. Does not implicitly {@link ai.talecast.webapp.proto.PongData.verify|verify} messages.
                     * @function encode
                     * @memberof ai.talecast.webapp.proto.PongData
                     * @static
                     * @param {ai.talecast.webapp.proto.IPongData} message PongData message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PongData.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.pongMsg != null && Object.hasOwnProperty.call(message, "pongMsg"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.pongMsg);
                        return writer;
                    };

                    /**
                     * Encodes the specified PongData message, length delimited. Does not implicitly {@link ai.talecast.webapp.proto.PongData.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof ai.talecast.webapp.proto.PongData
                     * @static
                     * @param {ai.talecast.webapp.proto.IPongData} message PongData message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PongData.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a PongData message from the specified reader or buffer.
                     * @function decode
                     * @memberof ai.talecast.webapp.proto.PongData
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {ai.talecast.webapp.proto.PongData} PongData
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PongData.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        const end = length === undefined ? reader.len : reader.pos + length, message = new $root.ai.talecast.webapp.proto.PongData();
                        while (reader.pos < end) {
                            const tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.pongMsg = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a PongData message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof ai.talecast.webapp.proto.PongData
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {ai.talecast.webapp.proto.PongData} PongData
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PongData.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a PongData message.
                     * @function verify
                     * @memberof ai.talecast.webapp.proto.PongData
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    PongData.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.pongMsg != null && message.hasOwnProperty("pongMsg"))
                            if (!$util.isString(message.pongMsg))
                                return "pongMsg: string expected";
                        return null;
                    };

                    /**
                     * Creates a PongData message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof ai.talecast.webapp.proto.PongData
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {ai.talecast.webapp.proto.PongData} PongData
                     */
                    PongData.fromObject = function fromObject(object) {
                        if (object instanceof $root.ai.talecast.webapp.proto.PongData)
                            return object;
                        const message = new $root.ai.talecast.webapp.proto.PongData();
                        if (object.pongMsg != null)
                            message.pongMsg = String(object.pongMsg);
                        return message;
                    };

                    /**
                     * Creates a plain object from a PongData message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof ai.talecast.webapp.proto.PongData
                     * @static
                     * @param {ai.talecast.webapp.proto.PongData} message PongData
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    PongData.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        const object = {};
                        if (options.defaults)
                            object.pongMsg = "";
                        if (message.pongMsg != null && message.hasOwnProperty("pongMsg"))
                            object.pongMsg = message.pongMsg;
                        return object;
                    };

                    /**
                     * Converts this PongData to JSON.
                     * @function toJSON
                     * @memberof ai.talecast.webapp.proto.PongData
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    PongData.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for PongData
                     * @function getTypeUrl
                     * @memberof ai.talecast.webapp.proto.PongData
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    PongData.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/ai.talecast.webapp.proto.PongData";
                    };

                    return PongData;
                })();

                proto.UserAssetDetailProto = (function() {

                    /**
                     * Properties of a UserAssetDetailProto.
                     * @memberof ai.talecast.webapp.proto
                     * @interface IUserAssetDetailProto
                     * @property {number|null} [order] UserAssetDetailProto order
                     * @property {string|null} [url] UserAssetDetailProto url
                     */

                    /**
                     * Constructs a new UserAssetDetailProto.
                     * @memberof ai.talecast.webapp.proto
                     * @classdesc Represents a UserAssetDetailProto.
                     * @implements IUserAssetDetailProto
                     * @constructor
                     * @param {ai.talecast.webapp.proto.IUserAssetDetailProto=} [properties] Properties to set
                     */
                    function UserAssetDetailProto(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * UserAssetDetailProto order.
                     * @member {number} order
                     * @memberof ai.talecast.webapp.proto.UserAssetDetailProto
                     * @instance
                     */
                    UserAssetDetailProto.prototype.order = 0;

                    /**
                     * UserAssetDetailProto url.
                     * @member {string} url
                     * @memberof ai.talecast.webapp.proto.UserAssetDetailProto
                     * @instance
                     */
                    UserAssetDetailProto.prototype.url = "";

                    /**
                     * Creates a new UserAssetDetailProto instance using the specified properties.
                     * @function create
                     * @memberof ai.talecast.webapp.proto.UserAssetDetailProto
                     * @static
                     * @param {ai.talecast.webapp.proto.IUserAssetDetailProto=} [properties] Properties to set
                     * @returns {ai.talecast.webapp.proto.UserAssetDetailProto} UserAssetDetailProto instance
                     */
                    UserAssetDetailProto.create = function create(properties) {
                        return new UserAssetDetailProto(properties);
                    };

                    /**
                     * Encodes the specified UserAssetDetailProto message. Does not implicitly {@link ai.talecast.webapp.proto.UserAssetDetailProto.verify|verify} messages.
                     * @function encode
                     * @memberof ai.talecast.webapp.proto.UserAssetDetailProto
                     * @static
                     * @param {ai.talecast.webapp.proto.IUserAssetDetailProto} message UserAssetDetailProto message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UserAssetDetailProto.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.order != null && Object.hasOwnProperty.call(message, "order"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.order);
                        if (message.url != null && Object.hasOwnProperty.call(message, "url"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.url);
                        return writer;
                    };

                    /**
                     * Encodes the specified UserAssetDetailProto message, length delimited. Does not implicitly {@link ai.talecast.webapp.proto.UserAssetDetailProto.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof ai.talecast.webapp.proto.UserAssetDetailProto
                     * @static
                     * @param {ai.talecast.webapp.proto.IUserAssetDetailProto} message UserAssetDetailProto message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UserAssetDetailProto.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a UserAssetDetailProto message from the specified reader or buffer.
                     * @function decode
                     * @memberof ai.talecast.webapp.proto.UserAssetDetailProto
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {ai.talecast.webapp.proto.UserAssetDetailProto} UserAssetDetailProto
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UserAssetDetailProto.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        const end = length === undefined ? reader.len : reader.pos + length, message = new $root.ai.talecast.webapp.proto.UserAssetDetailProto();
                        while (reader.pos < end) {
                            const tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.order = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.url = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a UserAssetDetailProto message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof ai.talecast.webapp.proto.UserAssetDetailProto
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {ai.talecast.webapp.proto.UserAssetDetailProto} UserAssetDetailProto
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UserAssetDetailProto.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a UserAssetDetailProto message.
                     * @function verify
                     * @memberof ai.talecast.webapp.proto.UserAssetDetailProto
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    UserAssetDetailProto.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.order != null && message.hasOwnProperty("order"))
                            if (!$util.isInteger(message.order))
                                return "order: integer expected";
                        if (message.url != null && message.hasOwnProperty("url"))
                            if (!$util.isString(message.url))
                                return "url: string expected";
                        return null;
                    };

                    /**
                     * Creates a UserAssetDetailProto message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof ai.talecast.webapp.proto.UserAssetDetailProto
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {ai.talecast.webapp.proto.UserAssetDetailProto} UserAssetDetailProto
                     */
                    UserAssetDetailProto.fromObject = function fromObject(object) {
                        if (object instanceof $root.ai.talecast.webapp.proto.UserAssetDetailProto)
                            return object;
                        const message = new $root.ai.talecast.webapp.proto.UserAssetDetailProto();
                        if (object.order != null)
                            message.order = object.order | 0;
                        if (object.url != null)
                            message.url = String(object.url);
                        return message;
                    };

                    /**
                     * Creates a plain object from a UserAssetDetailProto message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof ai.talecast.webapp.proto.UserAssetDetailProto
                     * @static
                     * @param {ai.talecast.webapp.proto.UserAssetDetailProto} message UserAssetDetailProto
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    UserAssetDetailProto.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        const object = {};
                        if (options.defaults) {
                            object.order = 0;
                            object.url = "";
                        }
                        if (message.order != null && message.hasOwnProperty("order"))
                            object.order = message.order;
                        if (message.url != null && message.hasOwnProperty("url"))
                            object.url = message.url;
                        return object;
                    };

                    /**
                     * Converts this UserAssetDetailProto to JSON.
                     * @function toJSON
                     * @memberof ai.talecast.webapp.proto.UserAssetDetailProto
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    UserAssetDetailProto.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for UserAssetDetailProto
                     * @function getTypeUrl
                     * @memberof ai.talecast.webapp.proto.UserAssetDetailProto
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    UserAssetDetailProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/ai.talecast.webapp.proto.UserAssetDetailProto";
                    };

                    return UserAssetDetailProto;
                })();

                proto.UserAssetDetailsProto = (function() {

                    /**
                     * Properties of a UserAssetDetailsProto.
                     * @memberof ai.talecast.webapp.proto
                     * @interface IUserAssetDetailsProto
                     * @property {string|null} [assetId] UserAssetDetailsProto assetId
                     * @property {Array.<ai.talecast.webapp.proto.IUserAssetDetailProto>|null} [details] UserAssetDetailsProto details
                     */

                    /**
                     * Constructs a new UserAssetDetailsProto.
                     * @memberof ai.talecast.webapp.proto
                     * @classdesc Represents a UserAssetDetailsProto.
                     * @implements IUserAssetDetailsProto
                     * @constructor
                     * @param {ai.talecast.webapp.proto.IUserAssetDetailsProto=} [properties] Properties to set
                     */
                    function UserAssetDetailsProto(properties) {
                        this.details = [];
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * UserAssetDetailsProto assetId.
                     * @member {string} assetId
                     * @memberof ai.talecast.webapp.proto.UserAssetDetailsProto
                     * @instance
                     */
                    UserAssetDetailsProto.prototype.assetId = "";

                    /**
                     * UserAssetDetailsProto details.
                     * @member {Array.<ai.talecast.webapp.proto.IUserAssetDetailProto>} details
                     * @memberof ai.talecast.webapp.proto.UserAssetDetailsProto
                     * @instance
                     */
                    UserAssetDetailsProto.prototype.details = $util.emptyArray;

                    /**
                     * Creates a new UserAssetDetailsProto instance using the specified properties.
                     * @function create
                     * @memberof ai.talecast.webapp.proto.UserAssetDetailsProto
                     * @static
                     * @param {ai.talecast.webapp.proto.IUserAssetDetailsProto=} [properties] Properties to set
                     * @returns {ai.talecast.webapp.proto.UserAssetDetailsProto} UserAssetDetailsProto instance
                     */
                    UserAssetDetailsProto.create = function create(properties) {
                        return new UserAssetDetailsProto(properties);
                    };

                    /**
                     * Encodes the specified UserAssetDetailsProto message. Does not implicitly {@link ai.talecast.webapp.proto.UserAssetDetailsProto.verify|verify} messages.
                     * @function encode
                     * @memberof ai.talecast.webapp.proto.UserAssetDetailsProto
                     * @static
                     * @param {ai.talecast.webapp.proto.IUserAssetDetailsProto} message UserAssetDetailsProto message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UserAssetDetailsProto.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.assetId != null && Object.hasOwnProperty.call(message, "assetId"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.assetId);
                        if (message.details != null && message.details.length)
                            for (let i = 0; i < message.details.length; ++i)
                                $root.ai.talecast.webapp.proto.UserAssetDetailProto.encode(message.details[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        return writer;
                    };

                    /**
                     * Encodes the specified UserAssetDetailsProto message, length delimited. Does not implicitly {@link ai.talecast.webapp.proto.UserAssetDetailsProto.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof ai.talecast.webapp.proto.UserAssetDetailsProto
                     * @static
                     * @param {ai.talecast.webapp.proto.IUserAssetDetailsProto} message UserAssetDetailsProto message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UserAssetDetailsProto.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a UserAssetDetailsProto message from the specified reader or buffer.
                     * @function decode
                     * @memberof ai.talecast.webapp.proto.UserAssetDetailsProto
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {ai.talecast.webapp.proto.UserAssetDetailsProto} UserAssetDetailsProto
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UserAssetDetailsProto.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        const end = length === undefined ? reader.len : reader.pos + length, message = new $root.ai.talecast.webapp.proto.UserAssetDetailsProto();
                        while (reader.pos < end) {
                            const tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.assetId = reader.string();
                                    break;
                                }
                            case 2: {
                                    if (!(message.details && message.details.length))
                                        message.details = [];
                                    message.details.push($root.ai.talecast.webapp.proto.UserAssetDetailProto.decode(reader, reader.uint32()));
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a UserAssetDetailsProto message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof ai.talecast.webapp.proto.UserAssetDetailsProto
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {ai.talecast.webapp.proto.UserAssetDetailsProto} UserAssetDetailsProto
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UserAssetDetailsProto.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a UserAssetDetailsProto message.
                     * @function verify
                     * @memberof ai.talecast.webapp.proto.UserAssetDetailsProto
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    UserAssetDetailsProto.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.assetId != null && message.hasOwnProperty("assetId"))
                            if (!$util.isString(message.assetId))
                                return "assetId: string expected";
                        if (message.details != null && message.hasOwnProperty("details")) {
                            if (!Array.isArray(message.details))
                                return "details: array expected";
                            for (let i = 0; i < message.details.length; ++i) {
                                const error = $root.ai.talecast.webapp.proto.UserAssetDetailProto.verify(message.details[i]);
                                if (error)
                                    return "details." + error;
                            }
                        }
                        return null;
                    };

                    /**
                     * Creates a UserAssetDetailsProto message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof ai.talecast.webapp.proto.UserAssetDetailsProto
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {ai.talecast.webapp.proto.UserAssetDetailsProto} UserAssetDetailsProto
                     */
                    UserAssetDetailsProto.fromObject = function fromObject(object) {
                        if (object instanceof $root.ai.talecast.webapp.proto.UserAssetDetailsProto)
                            return object;
                        const message = new $root.ai.talecast.webapp.proto.UserAssetDetailsProto();
                        if (object.assetId != null)
                            message.assetId = String(object.assetId);
                        if (object.details) {
                            if (!Array.isArray(object.details))
                                throw TypeError(".ai.talecast.webapp.proto.UserAssetDetailsProto.details: array expected");
                            message.details = [];
                            for (let i = 0; i < object.details.length; ++i) {
                                if (typeof object.details[i] !== "object")
                                    throw TypeError(".ai.talecast.webapp.proto.UserAssetDetailsProto.details: object expected");
                                message.details[i] = $root.ai.talecast.webapp.proto.UserAssetDetailProto.fromObject(object.details[i]);
                            }
                        }
                        return message;
                    };

                    /**
                     * Creates a plain object from a UserAssetDetailsProto message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof ai.talecast.webapp.proto.UserAssetDetailsProto
                     * @static
                     * @param {ai.talecast.webapp.proto.UserAssetDetailsProto} message UserAssetDetailsProto
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    UserAssetDetailsProto.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        const object = {};
                        if (options.arrays || options.defaults)
                            object.details = [];
                        if (options.defaults)
                            object.assetId = "";
                        if (message.assetId != null && message.hasOwnProperty("assetId"))
                            object.assetId = message.assetId;
                        if (message.details && message.details.length) {
                            object.details = [];
                            for (let j = 0; j < message.details.length; ++j)
                                object.details[j] = $root.ai.talecast.webapp.proto.UserAssetDetailProto.toObject(message.details[j], options);
                        }
                        return object;
                    };

                    /**
                     * Converts this UserAssetDetailsProto to JSON.
                     * @function toJSON
                     * @memberof ai.talecast.webapp.proto.UserAssetDetailsProto
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    UserAssetDetailsProto.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for UserAssetDetailsProto
                     * @function getTypeUrl
                     * @memberof ai.talecast.webapp.proto.UserAssetDetailsProto
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    UserAssetDetailsProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/ai.talecast.webapp.proto.UserAssetDetailsProto";
                    };

                    return UserAssetDetailsProto;
                })();

                proto.ProjectCreatedProto = (function() {

                    /**
                     * Properties of a ProjectCreatedProto.
                     * @memberof ai.talecast.webapp.proto
                     * @interface IProjectCreatedProto
                     * @property {number|Long|null} [projectId] ProjectCreatedProto projectId
                     * @property {boolean|null} [isSucceed] ProjectCreatedProto isSucceed
                     * @property {number|Long|null} [duration] ProjectCreatedProto duration
                     * @property {string|null} [projectName] ProjectCreatedProto projectName
                     */

                    /**
                     * Constructs a new ProjectCreatedProto.
                     * @memberof ai.talecast.webapp.proto
                     * @classdesc Represents a ProjectCreatedProto.
                     * @implements IProjectCreatedProto
                     * @constructor
                     * @param {ai.talecast.webapp.proto.IProjectCreatedProto=} [properties] Properties to set
                     */
                    function ProjectCreatedProto(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * ProjectCreatedProto projectId.
                     * @member {number|Long} projectId
                     * @memberof ai.talecast.webapp.proto.ProjectCreatedProto
                     * @instance
                     */
                    ProjectCreatedProto.prototype.projectId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                    /**
                     * ProjectCreatedProto isSucceed.
                     * @member {boolean} isSucceed
                     * @memberof ai.talecast.webapp.proto.ProjectCreatedProto
                     * @instance
                     */
                    ProjectCreatedProto.prototype.isSucceed = false;

                    /**
                     * ProjectCreatedProto duration.
                     * @member {number|Long} duration
                     * @memberof ai.talecast.webapp.proto.ProjectCreatedProto
                     * @instance
                     */
                    ProjectCreatedProto.prototype.duration = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                    /**
                     * ProjectCreatedProto projectName.
                     * @member {string} projectName
                     * @memberof ai.talecast.webapp.proto.ProjectCreatedProto
                     * @instance
                     */
                    ProjectCreatedProto.prototype.projectName = "";

                    /**
                     * Creates a new ProjectCreatedProto instance using the specified properties.
                     * @function create
                     * @memberof ai.talecast.webapp.proto.ProjectCreatedProto
                     * @static
                     * @param {ai.talecast.webapp.proto.IProjectCreatedProto=} [properties] Properties to set
                     * @returns {ai.talecast.webapp.proto.ProjectCreatedProto} ProjectCreatedProto instance
                     */
                    ProjectCreatedProto.create = function create(properties) {
                        return new ProjectCreatedProto(properties);
                    };

                    /**
                     * Encodes the specified ProjectCreatedProto message. Does not implicitly {@link ai.talecast.webapp.proto.ProjectCreatedProto.verify|verify} messages.
                     * @function encode
                     * @memberof ai.talecast.webapp.proto.ProjectCreatedProto
                     * @static
                     * @param {ai.talecast.webapp.proto.IProjectCreatedProto} message ProjectCreatedProto message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ProjectCreatedProto.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.projectId != null && Object.hasOwnProperty.call(message, "projectId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.projectId);
                        if (message.isSucceed != null && Object.hasOwnProperty.call(message, "isSucceed"))
                            writer.uint32(/* id 2, wireType 0 =*/16).bool(message.isSucceed);
                        if (message.duration != null && Object.hasOwnProperty.call(message, "duration"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.duration);
                        if (message.projectName != null && Object.hasOwnProperty.call(message, "projectName"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.projectName);
                        return writer;
                    };

                    /**
                     * Encodes the specified ProjectCreatedProto message, length delimited. Does not implicitly {@link ai.talecast.webapp.proto.ProjectCreatedProto.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof ai.talecast.webapp.proto.ProjectCreatedProto
                     * @static
                     * @param {ai.talecast.webapp.proto.IProjectCreatedProto} message ProjectCreatedProto message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ProjectCreatedProto.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a ProjectCreatedProto message from the specified reader or buffer.
                     * @function decode
                     * @memberof ai.talecast.webapp.proto.ProjectCreatedProto
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {ai.talecast.webapp.proto.ProjectCreatedProto} ProjectCreatedProto
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ProjectCreatedProto.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        const end = length === undefined ? reader.len : reader.pos + length, message = new $root.ai.talecast.webapp.proto.ProjectCreatedProto();
                        while (reader.pos < end) {
                            const tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.projectId = reader.int64();
                                    break;
                                }
                            case 2: {
                                    message.isSucceed = reader.bool();
                                    break;
                                }
                            case 3: {
                                    message.duration = reader.int64();
                                    break;
                                }
                            case 4: {
                                    message.projectName = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a ProjectCreatedProto message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof ai.talecast.webapp.proto.ProjectCreatedProto
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {ai.talecast.webapp.proto.ProjectCreatedProto} ProjectCreatedProto
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ProjectCreatedProto.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a ProjectCreatedProto message.
                     * @function verify
                     * @memberof ai.talecast.webapp.proto.ProjectCreatedProto
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ProjectCreatedProto.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.projectId != null && message.hasOwnProperty("projectId"))
                            if (!$util.isInteger(message.projectId) && !(message.projectId && $util.isInteger(message.projectId.low) && $util.isInteger(message.projectId.high)))
                                return "projectId: integer|Long expected";
                        if (message.isSucceed != null && message.hasOwnProperty("isSucceed"))
                            if (typeof message.isSucceed !== "boolean")
                                return "isSucceed: boolean expected";
                        if (message.duration != null && message.hasOwnProperty("duration"))
                            if (!$util.isInteger(message.duration) && !(message.duration && $util.isInteger(message.duration.low) && $util.isInteger(message.duration.high)))
                                return "duration: integer|Long expected";
                        if (message.projectName != null && message.hasOwnProperty("projectName"))
                            if (!$util.isString(message.projectName))
                                return "projectName: string expected";
                        return null;
                    };

                    /**
                     * Creates a ProjectCreatedProto message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof ai.talecast.webapp.proto.ProjectCreatedProto
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {ai.talecast.webapp.proto.ProjectCreatedProto} ProjectCreatedProto
                     */
                    ProjectCreatedProto.fromObject = function fromObject(object) {
                        if (object instanceof $root.ai.talecast.webapp.proto.ProjectCreatedProto)
                            return object;
                        const message = new $root.ai.talecast.webapp.proto.ProjectCreatedProto();
                        if (object.projectId != null)
                            if ($util.Long)
                                (message.projectId = $util.Long.fromValue(object.projectId)).unsigned = false;
                            else if (typeof object.projectId === "string")
                                message.projectId = parseInt(object.projectId, 10);
                            else if (typeof object.projectId === "number")
                                message.projectId = object.projectId;
                            else if (typeof object.projectId === "object")
                                message.projectId = new $util.LongBits(object.projectId.low >>> 0, object.projectId.high >>> 0).toNumber();
                        if (object.isSucceed != null)
                            message.isSucceed = Boolean(object.isSucceed);
                        if (object.duration != null)
                            if ($util.Long)
                                (message.duration = $util.Long.fromValue(object.duration)).unsigned = false;
                            else if (typeof object.duration === "string")
                                message.duration = parseInt(object.duration, 10);
                            else if (typeof object.duration === "number")
                                message.duration = object.duration;
                            else if (typeof object.duration === "object")
                                message.duration = new $util.LongBits(object.duration.low >>> 0, object.duration.high >>> 0).toNumber();
                        if (object.projectName != null)
                            message.projectName = String(object.projectName);
                        return message;
                    };

                    /**
                     * Creates a plain object from a ProjectCreatedProto message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof ai.talecast.webapp.proto.ProjectCreatedProto
                     * @static
                     * @param {ai.talecast.webapp.proto.ProjectCreatedProto} message ProjectCreatedProto
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ProjectCreatedProto.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        const object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                const long = new $util.Long(0, 0, false);
                                object.projectId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.projectId = options.longs === String ? "0" : 0;
                            object.isSucceed = false;
                            if ($util.Long) {
                                const long = new $util.Long(0, 0, false);
                                object.duration = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.duration = options.longs === String ? "0" : 0;
                            object.projectName = "";
                        }
                        if (message.projectId != null && message.hasOwnProperty("projectId"))
                            if (typeof message.projectId === "number")
                                object.projectId = options.longs === String ? String(message.projectId) : message.projectId;
                            else
                                object.projectId = options.longs === String ? $util.Long.prototype.toString.call(message.projectId) : options.longs === Number ? new $util.LongBits(message.projectId.low >>> 0, message.projectId.high >>> 0).toNumber() : message.projectId;
                        if (message.isSucceed != null && message.hasOwnProperty("isSucceed"))
                            object.isSucceed = message.isSucceed;
                        if (message.duration != null && message.hasOwnProperty("duration"))
                            if (typeof message.duration === "number")
                                object.duration = options.longs === String ? String(message.duration) : message.duration;
                            else
                                object.duration = options.longs === String ? $util.Long.prototype.toString.call(message.duration) : options.longs === Number ? new $util.LongBits(message.duration.low >>> 0, message.duration.high >>> 0).toNumber() : message.duration;
                        if (message.projectName != null && message.hasOwnProperty("projectName"))
                            object.projectName = message.projectName;
                        return object;
                    };

                    /**
                     * Converts this ProjectCreatedProto to JSON.
                     * @function toJSON
                     * @memberof ai.talecast.webapp.proto.ProjectCreatedProto
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ProjectCreatedProto.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for ProjectCreatedProto
                     * @function getTypeUrl
                     * @memberof ai.talecast.webapp.proto.ProjectCreatedProto
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    ProjectCreatedProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/ai.talecast.webapp.proto.ProjectCreatedProto";
                    };

                    return ProjectCreatedProto;
                })();

                proto.TtsDetailsProto = (function() {

                    /**
                     * Properties of a TtsDetailsProto.
                     * @memberof ai.talecast.webapp.proto
                     * @interface ITtsDetailsProto
                     * @property {boolean|null} [isSucceed] TtsDetailsProto isSucceed
                     * @property {number|Long|null} [projectId] TtsDetailsProto projectId
                     * @property {ai.talecast.webapp.proto.ISentenceProto|null} [sentence] TtsDetailsProto sentence
                     */

                    /**
                     * Constructs a new TtsDetailsProto.
                     * @memberof ai.talecast.webapp.proto
                     * @classdesc Represents a TtsDetailsProto.
                     * @implements ITtsDetailsProto
                     * @constructor
                     * @param {ai.talecast.webapp.proto.ITtsDetailsProto=} [properties] Properties to set
                     */
                    function TtsDetailsProto(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * TtsDetailsProto isSucceed.
                     * @member {boolean} isSucceed
                     * @memberof ai.talecast.webapp.proto.TtsDetailsProto
                     * @instance
                     */
                    TtsDetailsProto.prototype.isSucceed = false;

                    /**
                     * TtsDetailsProto projectId.
                     * @member {number|Long} projectId
                     * @memberof ai.talecast.webapp.proto.TtsDetailsProto
                     * @instance
                     */
                    TtsDetailsProto.prototype.projectId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                    /**
                     * TtsDetailsProto sentence.
                     * @member {ai.talecast.webapp.proto.ISentenceProto|null|undefined} sentence
                     * @memberof ai.talecast.webapp.proto.TtsDetailsProto
                     * @instance
                     */
                    TtsDetailsProto.prototype.sentence = null;

                    /**
                     * Creates a new TtsDetailsProto instance using the specified properties.
                     * @function create
                     * @memberof ai.talecast.webapp.proto.TtsDetailsProto
                     * @static
                     * @param {ai.talecast.webapp.proto.ITtsDetailsProto=} [properties] Properties to set
                     * @returns {ai.talecast.webapp.proto.TtsDetailsProto} TtsDetailsProto instance
                     */
                    TtsDetailsProto.create = function create(properties) {
                        return new TtsDetailsProto(properties);
                    };

                    /**
                     * Encodes the specified TtsDetailsProto message. Does not implicitly {@link ai.talecast.webapp.proto.TtsDetailsProto.verify|verify} messages.
                     * @function encode
                     * @memberof ai.talecast.webapp.proto.TtsDetailsProto
                     * @static
                     * @param {ai.talecast.webapp.proto.ITtsDetailsProto} message TtsDetailsProto message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TtsDetailsProto.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.isSucceed != null && Object.hasOwnProperty.call(message, "isSucceed"))
                            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.isSucceed);
                        if (message.projectId != null && Object.hasOwnProperty.call(message, "projectId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.projectId);
                        if (message.sentence != null && Object.hasOwnProperty.call(message, "sentence"))
                            $root.ai.talecast.webapp.proto.SentenceProto.encode(message.sentence, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                        return writer;
                    };

                    /**
                     * Encodes the specified TtsDetailsProto message, length delimited. Does not implicitly {@link ai.talecast.webapp.proto.TtsDetailsProto.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof ai.talecast.webapp.proto.TtsDetailsProto
                     * @static
                     * @param {ai.talecast.webapp.proto.ITtsDetailsProto} message TtsDetailsProto message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TtsDetailsProto.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a TtsDetailsProto message from the specified reader or buffer.
                     * @function decode
                     * @memberof ai.talecast.webapp.proto.TtsDetailsProto
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {ai.talecast.webapp.proto.TtsDetailsProto} TtsDetailsProto
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TtsDetailsProto.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        const end = length === undefined ? reader.len : reader.pos + length, message = new $root.ai.talecast.webapp.proto.TtsDetailsProto();
                        while (reader.pos < end) {
                            const tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.isSucceed = reader.bool();
                                    break;
                                }
                            case 2: {
                                    message.projectId = reader.int64();
                                    break;
                                }
                            case 3: {
                                    message.sentence = $root.ai.talecast.webapp.proto.SentenceProto.decode(reader, reader.uint32());
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a TtsDetailsProto message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof ai.talecast.webapp.proto.TtsDetailsProto
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {ai.talecast.webapp.proto.TtsDetailsProto} TtsDetailsProto
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TtsDetailsProto.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a TtsDetailsProto message.
                     * @function verify
                     * @memberof ai.talecast.webapp.proto.TtsDetailsProto
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    TtsDetailsProto.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.isSucceed != null && message.hasOwnProperty("isSucceed"))
                            if (typeof message.isSucceed !== "boolean")
                                return "isSucceed: boolean expected";
                        if (message.projectId != null && message.hasOwnProperty("projectId"))
                            if (!$util.isInteger(message.projectId) && !(message.projectId && $util.isInteger(message.projectId.low) && $util.isInteger(message.projectId.high)))
                                return "projectId: integer|Long expected";
                        if (message.sentence != null && message.hasOwnProperty("sentence")) {
                            const error = $root.ai.talecast.webapp.proto.SentenceProto.verify(message.sentence);
                            if (error)
                                return "sentence." + error;
                        }
                        return null;
                    };

                    /**
                     * Creates a TtsDetailsProto message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof ai.talecast.webapp.proto.TtsDetailsProto
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {ai.talecast.webapp.proto.TtsDetailsProto} TtsDetailsProto
                     */
                    TtsDetailsProto.fromObject = function fromObject(object) {
                        if (object instanceof $root.ai.talecast.webapp.proto.TtsDetailsProto)
                            return object;
                        const message = new $root.ai.talecast.webapp.proto.TtsDetailsProto();
                        if (object.isSucceed != null)
                            message.isSucceed = Boolean(object.isSucceed);
                        if (object.projectId != null)
                            if ($util.Long)
                                (message.projectId = $util.Long.fromValue(object.projectId)).unsigned = false;
                            else if (typeof object.projectId === "string")
                                message.projectId = parseInt(object.projectId, 10);
                            else if (typeof object.projectId === "number")
                                message.projectId = object.projectId;
                            else if (typeof object.projectId === "object")
                                message.projectId = new $util.LongBits(object.projectId.low >>> 0, object.projectId.high >>> 0).toNumber();
                        if (object.sentence != null) {
                            if (typeof object.sentence !== "object")
                                throw TypeError(".ai.talecast.webapp.proto.TtsDetailsProto.sentence: object expected");
                            message.sentence = $root.ai.talecast.webapp.proto.SentenceProto.fromObject(object.sentence);
                        }
                        return message;
                    };

                    /**
                     * Creates a plain object from a TtsDetailsProto message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof ai.talecast.webapp.proto.TtsDetailsProto
                     * @static
                     * @param {ai.talecast.webapp.proto.TtsDetailsProto} message TtsDetailsProto
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    TtsDetailsProto.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        const object = {};
                        if (options.defaults) {
                            object.isSucceed = false;
                            if ($util.Long) {
                                const long = new $util.Long(0, 0, false);
                                object.projectId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.projectId = options.longs === String ? "0" : 0;
                            object.sentence = null;
                        }
                        if (message.isSucceed != null && message.hasOwnProperty("isSucceed"))
                            object.isSucceed = message.isSucceed;
                        if (message.projectId != null && message.hasOwnProperty("projectId"))
                            if (typeof message.projectId === "number")
                                object.projectId = options.longs === String ? String(message.projectId) : message.projectId;
                            else
                                object.projectId = options.longs === String ? $util.Long.prototype.toString.call(message.projectId) : options.longs === Number ? new $util.LongBits(message.projectId.low >>> 0, message.projectId.high >>> 0).toNumber() : message.projectId;
                        if (message.sentence != null && message.hasOwnProperty("sentence"))
                            object.sentence = $root.ai.talecast.webapp.proto.SentenceProto.toObject(message.sentence, options);
                        return object;
                    };

                    /**
                     * Converts this TtsDetailsProto to JSON.
                     * @function toJSON
                     * @memberof ai.talecast.webapp.proto.TtsDetailsProto
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    TtsDetailsProto.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for TtsDetailsProto
                     * @function getTypeUrl
                     * @memberof ai.talecast.webapp.proto.TtsDetailsProto
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    TtsDetailsProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/ai.talecast.webapp.proto.TtsDetailsProto";
                    };

                    return TtsDetailsProto;
                })();

                proto.SentenceProto = (function() {

                    /**
                     * Properties of a SentenceProto.
                     * @memberof ai.talecast.webapp.proto
                     * @interface ISentenceProto
                     * @property {number|null} [number] SentenceProto number
                     * @property {number|null} [order] SentenceProto order
                     * @property {string|null} [text] SentenceProto text
                     * @property {string|null} [audioUrl] SentenceProto audioUrl
                     * @property {number|null} [duration] SentenceProto duration
                     * @property {number|null} [audioDuration] SentenceProto audioDuration
                     * @property {string|null} [initialText] SentenceProto initialText
                     * @property {boolean|null} [isEdit] SentenceProto isEdit
                     * @property {number|null} [offset] SentenceProto offset
                     * @property {number|null} [status] SentenceProto status
                     * @property {ai.talecast.webapp.proto.IVoice|null} [voice] SentenceProto voice
                     */

                    /**
                     * Constructs a new SentenceProto.
                     * @memberof ai.talecast.webapp.proto
                     * @classdesc Represents a SentenceProto.
                     * @implements ISentenceProto
                     * @constructor
                     * @param {ai.talecast.webapp.proto.ISentenceProto=} [properties] Properties to set
                     */
                    function SentenceProto(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * SentenceProto number.
                     * @member {number|null|undefined} number
                     * @memberof ai.talecast.webapp.proto.SentenceProto
                     * @instance
                     */
                    SentenceProto.prototype.number = null;

                    /**
                     * SentenceProto order.
                     * @member {number|null|undefined} order
                     * @memberof ai.talecast.webapp.proto.SentenceProto
                     * @instance
                     */
                    SentenceProto.prototype.order = null;

                    /**
                     * SentenceProto text.
                     * @member {string} text
                     * @memberof ai.talecast.webapp.proto.SentenceProto
                     * @instance
                     */
                    SentenceProto.prototype.text = "";

                    /**
                     * SentenceProto audioUrl.
                     * @member {string} audioUrl
                     * @memberof ai.talecast.webapp.proto.SentenceProto
                     * @instance
                     */
                    SentenceProto.prototype.audioUrl = "";

                    /**
                     * SentenceProto duration.
                     * @member {number|null|undefined} duration
                     * @memberof ai.talecast.webapp.proto.SentenceProto
                     * @instance
                     */
                    SentenceProto.prototype.duration = null;

                    /**
                     * SentenceProto audioDuration.
                     * @member {number|null|undefined} audioDuration
                     * @memberof ai.talecast.webapp.proto.SentenceProto
                     * @instance
                     */
                    SentenceProto.prototype.audioDuration = null;

                    /**
                     * SentenceProto initialText.
                     * @member {string} initialText
                     * @memberof ai.talecast.webapp.proto.SentenceProto
                     * @instance
                     */
                    SentenceProto.prototype.initialText = "";

                    /**
                     * SentenceProto isEdit.
                     * @member {boolean} isEdit
                     * @memberof ai.talecast.webapp.proto.SentenceProto
                     * @instance
                     */
                    SentenceProto.prototype.isEdit = false;

                    /**
                     * SentenceProto offset.
                     * @member {number|null|undefined} offset
                     * @memberof ai.talecast.webapp.proto.SentenceProto
                     * @instance
                     */
                    SentenceProto.prototype.offset = null;

                    /**
                     * SentenceProto status.
                     * @member {number|null|undefined} status
                     * @memberof ai.talecast.webapp.proto.SentenceProto
                     * @instance
                     */
                    SentenceProto.prototype.status = null;

                    /**
                     * SentenceProto voice.
                     * @member {ai.talecast.webapp.proto.IVoice|null|undefined} voice
                     * @memberof ai.talecast.webapp.proto.SentenceProto
                     * @instance
                     */
                    SentenceProto.prototype.voice = null;

                    // OneOf field names bound to virtual getters and setters
                    let $oneOfFields;

                    // Virtual OneOf for proto3 optional field
                    Object.defineProperty(SentenceProto.prototype, "_number", {
                        get: $util.oneOfGetter($oneOfFields = ["number"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    // Virtual OneOf for proto3 optional field
                    Object.defineProperty(SentenceProto.prototype, "_order", {
                        get: $util.oneOfGetter($oneOfFields = ["order"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    // Virtual OneOf for proto3 optional field
                    Object.defineProperty(SentenceProto.prototype, "_duration", {
                        get: $util.oneOfGetter($oneOfFields = ["duration"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    // Virtual OneOf for proto3 optional field
                    Object.defineProperty(SentenceProto.prototype, "_audioDuration", {
                        get: $util.oneOfGetter($oneOfFields = ["audioDuration"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    // Virtual OneOf for proto3 optional field
                    Object.defineProperty(SentenceProto.prototype, "_offset", {
                        get: $util.oneOfGetter($oneOfFields = ["offset"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    // Virtual OneOf for proto3 optional field
                    Object.defineProperty(SentenceProto.prototype, "_status", {
                        get: $util.oneOfGetter($oneOfFields = ["status"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    /**
                     * Creates a new SentenceProto instance using the specified properties.
                     * @function create
                     * @memberof ai.talecast.webapp.proto.SentenceProto
                     * @static
                     * @param {ai.talecast.webapp.proto.ISentenceProto=} [properties] Properties to set
                     * @returns {ai.talecast.webapp.proto.SentenceProto} SentenceProto instance
                     */
                    SentenceProto.create = function create(properties) {
                        return new SentenceProto(properties);
                    };

                    /**
                     * Encodes the specified SentenceProto message. Does not implicitly {@link ai.talecast.webapp.proto.SentenceProto.verify|verify} messages.
                     * @function encode
                     * @memberof ai.talecast.webapp.proto.SentenceProto
                     * @static
                     * @param {ai.talecast.webapp.proto.ISentenceProto} message SentenceProto message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    SentenceProto.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.number != null && Object.hasOwnProperty.call(message, "number"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.number);
                        if (message.order != null && Object.hasOwnProperty.call(message, "order"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.order);
                        if (message.text != null && Object.hasOwnProperty.call(message, "text"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.text);
                        if (message.audioUrl != null && Object.hasOwnProperty.call(message, "audioUrl"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.audioUrl);
                        if (message.duration != null && Object.hasOwnProperty.call(message, "duration"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.duration);
                        if (message.audioDuration != null && Object.hasOwnProperty.call(message, "audioDuration"))
                            writer.uint32(/* id 6, wireType 0 =*/48).int32(message.audioDuration);
                        if (message.initialText != null && Object.hasOwnProperty.call(message, "initialText"))
                            writer.uint32(/* id 7, wireType 2 =*/58).string(message.initialText);
                        if (message.isEdit != null && Object.hasOwnProperty.call(message, "isEdit"))
                            writer.uint32(/* id 8, wireType 0 =*/64).bool(message.isEdit);
                        if (message.offset != null && Object.hasOwnProperty.call(message, "offset"))
                            writer.uint32(/* id 9, wireType 0 =*/72).int32(message.offset);
                        if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                            writer.uint32(/* id 10, wireType 0 =*/80).int32(message.status);
                        if (message.voice != null && Object.hasOwnProperty.call(message, "voice"))
                            $root.ai.talecast.webapp.proto.Voice.encode(message.voice, writer.uint32(/* id 11, wireType 2 =*/90).fork()).ldelim();
                        return writer;
                    };

                    /**
                     * Encodes the specified SentenceProto message, length delimited. Does not implicitly {@link ai.talecast.webapp.proto.SentenceProto.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof ai.talecast.webapp.proto.SentenceProto
                     * @static
                     * @param {ai.talecast.webapp.proto.ISentenceProto} message SentenceProto message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    SentenceProto.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a SentenceProto message from the specified reader or buffer.
                     * @function decode
                     * @memberof ai.talecast.webapp.proto.SentenceProto
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {ai.talecast.webapp.proto.SentenceProto} SentenceProto
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    SentenceProto.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        const end = length === undefined ? reader.len : reader.pos + length, message = new $root.ai.talecast.webapp.proto.SentenceProto();
                        while (reader.pos < end) {
                            const tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.number = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.order = reader.int32();
                                    break;
                                }
                            case 3: {
                                    message.text = reader.string();
                                    break;
                                }
                            case 4: {
                                    message.audioUrl = reader.string();
                                    break;
                                }
                            case 5: {
                                    message.duration = reader.int32();
                                    break;
                                }
                            case 6: {
                                    message.audioDuration = reader.int32();
                                    break;
                                }
                            case 7: {
                                    message.initialText = reader.string();
                                    break;
                                }
                            case 8: {
                                    message.isEdit = reader.bool();
                                    break;
                                }
                            case 9: {
                                    message.offset = reader.int32();
                                    break;
                                }
                            case 10: {
                                    message.status = reader.int32();
                                    break;
                                }
                            case 11: {
                                    message.voice = $root.ai.talecast.webapp.proto.Voice.decode(reader, reader.uint32());
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a SentenceProto message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof ai.talecast.webapp.proto.SentenceProto
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {ai.talecast.webapp.proto.SentenceProto} SentenceProto
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    SentenceProto.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a SentenceProto message.
                     * @function verify
                     * @memberof ai.talecast.webapp.proto.SentenceProto
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    SentenceProto.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        const properties = {};
                        if (message.number != null && message.hasOwnProperty("number")) {
                            properties._number = 1;
                            if (!$util.isInteger(message.number))
                                return "number: integer expected";
                        }
                        if (message.order != null && message.hasOwnProperty("order")) {
                            properties._order = 1;
                            if (!$util.isInteger(message.order))
                                return "order: integer expected";
                        }
                        if (message.text != null && message.hasOwnProperty("text"))
                            if (!$util.isString(message.text))
                                return "text: string expected";
                        if (message.audioUrl != null && message.hasOwnProperty("audioUrl"))
                            if (!$util.isString(message.audioUrl))
                                return "audioUrl: string expected";
                        if (message.duration != null && message.hasOwnProperty("duration")) {
                            properties._duration = 1;
                            if (!$util.isInteger(message.duration))
                                return "duration: integer expected";
                        }
                        if (message.audioDuration != null && message.hasOwnProperty("audioDuration")) {
                            properties._audioDuration = 1;
                            if (!$util.isInteger(message.audioDuration))
                                return "audioDuration: integer expected";
                        }
                        if (message.initialText != null && message.hasOwnProperty("initialText"))
                            if (!$util.isString(message.initialText))
                                return "initialText: string expected";
                        if (message.isEdit != null && message.hasOwnProperty("isEdit"))
                            if (typeof message.isEdit !== "boolean")
                                return "isEdit: boolean expected";
                        if (message.offset != null && message.hasOwnProperty("offset")) {
                            properties._offset = 1;
                            if (!$util.isInteger(message.offset))
                                return "offset: integer expected";
                        }
                        if (message.status != null && message.hasOwnProperty("status")) {
                            properties._status = 1;
                            if (!$util.isInteger(message.status))
                                return "status: integer expected";
                        }
                        if (message.voice != null && message.hasOwnProperty("voice")) {
                            const error = $root.ai.talecast.webapp.proto.Voice.verify(message.voice);
                            if (error)
                                return "voice." + error;
                        }
                        return null;
                    };

                    /**
                     * Creates a SentenceProto message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof ai.talecast.webapp.proto.SentenceProto
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {ai.talecast.webapp.proto.SentenceProto} SentenceProto
                     */
                    SentenceProto.fromObject = function fromObject(object) {
                        if (object instanceof $root.ai.talecast.webapp.proto.SentenceProto)
                            return object;
                        const message = new $root.ai.talecast.webapp.proto.SentenceProto();
                        if (object.number != null)
                            message.number = object.number | 0;
                        if (object.order != null)
                            message.order = object.order | 0;
                        if (object.text != null)
                            message.text = String(object.text);
                        if (object.audioUrl != null)
                            message.audioUrl = String(object.audioUrl);
                        if (object.duration != null)
                            message.duration = object.duration | 0;
                        if (object.audioDuration != null)
                            message.audioDuration = object.audioDuration | 0;
                        if (object.initialText != null)
                            message.initialText = String(object.initialText);
                        if (object.isEdit != null)
                            message.isEdit = Boolean(object.isEdit);
                        if (object.offset != null)
                            message.offset = object.offset | 0;
                        if (object.status != null)
                            message.status = object.status | 0;
                        if (object.voice != null) {
                            if (typeof object.voice !== "object")
                                throw TypeError(".ai.talecast.webapp.proto.SentenceProto.voice: object expected");
                            message.voice = $root.ai.talecast.webapp.proto.Voice.fromObject(object.voice);
                        }
                        return message;
                    };

                    /**
                     * Creates a plain object from a SentenceProto message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof ai.talecast.webapp.proto.SentenceProto
                     * @static
                     * @param {ai.talecast.webapp.proto.SentenceProto} message SentenceProto
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    SentenceProto.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        const object = {};
                        if (options.defaults) {
                            object.text = "";
                            object.audioUrl = "";
                            object.initialText = "";
                            object.isEdit = false;
                            object.voice = null;
                        }
                        if (message.number != null && message.hasOwnProperty("number")) {
                            object.number = message.number;
                            if (options.oneofs)
                                object._number = "number";
                        }
                        if (message.order != null && message.hasOwnProperty("order")) {
                            object.order = message.order;
                            if (options.oneofs)
                                object._order = "order";
                        }
                        if (message.text != null && message.hasOwnProperty("text"))
                            object.text = message.text;
                        if (message.audioUrl != null && message.hasOwnProperty("audioUrl"))
                            object.audioUrl = message.audioUrl;
                        if (message.duration != null && message.hasOwnProperty("duration")) {
                            object.duration = message.duration;
                            if (options.oneofs)
                                object._duration = "duration";
                        }
                        if (message.audioDuration != null && message.hasOwnProperty("audioDuration")) {
                            object.audioDuration = message.audioDuration;
                            if (options.oneofs)
                                object._audioDuration = "audioDuration";
                        }
                        if (message.initialText != null && message.hasOwnProperty("initialText"))
                            object.initialText = message.initialText;
                        if (message.isEdit != null && message.hasOwnProperty("isEdit"))
                            object.isEdit = message.isEdit;
                        if (message.offset != null && message.hasOwnProperty("offset")) {
                            object.offset = message.offset;
                            if (options.oneofs)
                                object._offset = "offset";
                        }
                        if (message.status != null && message.hasOwnProperty("status")) {
                            object.status = message.status;
                            if (options.oneofs)
                                object._status = "status";
                        }
                        if (message.voice != null && message.hasOwnProperty("voice"))
                            object.voice = $root.ai.talecast.webapp.proto.Voice.toObject(message.voice, options);
                        return object;
                    };

                    /**
                     * Converts this SentenceProto to JSON.
                     * @function toJSON
                     * @memberof ai.talecast.webapp.proto.SentenceProto
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    SentenceProto.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for SentenceProto
                     * @function getTypeUrl
                     * @memberof ai.talecast.webapp.proto.SentenceProto
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    SentenceProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/ai.talecast.webapp.proto.SentenceProto";
                    };

                    return SentenceProto;
                })();

                proto.TtsMessageProto = (function() {

                    /**
                     * Properties of a TtsMessageProto.
                     * @memberof ai.talecast.webapp.proto
                     * @interface ITtsMessageProto
                     * @property {boolean|null} [isSucceed] TtsMessageProto isSucceed
                     * @property {number|Long|null} [projectId] TtsMessageProto projectId
                     * @property {ai.talecast.webapp.proto.IAudioDetailProto|null} [detail] TtsMessageProto detail
                     * @property {ai.talecast.webapp.proto.IAudioDetailProto|null} [extraDetail] TtsMessageProto extraDetail
                     */

                    /**
                     * Constructs a new TtsMessageProto.
                     * @memberof ai.talecast.webapp.proto
                     * @classdesc Represents a TtsMessageProto.
                     * @implements ITtsMessageProto
                     * @constructor
                     * @param {ai.talecast.webapp.proto.ITtsMessageProto=} [properties] Properties to set
                     */
                    function TtsMessageProto(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * TtsMessageProto isSucceed.
                     * @member {boolean} isSucceed
                     * @memberof ai.talecast.webapp.proto.TtsMessageProto
                     * @instance
                     */
                    TtsMessageProto.prototype.isSucceed = false;

                    /**
                     * TtsMessageProto projectId.
                     * @member {number|Long} projectId
                     * @memberof ai.talecast.webapp.proto.TtsMessageProto
                     * @instance
                     */
                    TtsMessageProto.prototype.projectId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                    /**
                     * TtsMessageProto detail.
                     * @member {ai.talecast.webapp.proto.IAudioDetailProto|null|undefined} detail
                     * @memberof ai.talecast.webapp.proto.TtsMessageProto
                     * @instance
                     */
                    TtsMessageProto.prototype.detail = null;

                    /**
                     * TtsMessageProto extraDetail.
                     * @member {ai.talecast.webapp.proto.IAudioDetailProto|null|undefined} extraDetail
                     * @memberof ai.talecast.webapp.proto.TtsMessageProto
                     * @instance
                     */
                    TtsMessageProto.prototype.extraDetail = null;

                    // OneOf field names bound to virtual getters and setters
                    let $oneOfFields;

                    // Virtual OneOf for proto3 optional field
                    Object.defineProperty(TtsMessageProto.prototype, "_extraDetail", {
                        get: $util.oneOfGetter($oneOfFields = ["extraDetail"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    /**
                     * Creates a new TtsMessageProto instance using the specified properties.
                     * @function create
                     * @memberof ai.talecast.webapp.proto.TtsMessageProto
                     * @static
                     * @param {ai.talecast.webapp.proto.ITtsMessageProto=} [properties] Properties to set
                     * @returns {ai.talecast.webapp.proto.TtsMessageProto} TtsMessageProto instance
                     */
                    TtsMessageProto.create = function create(properties) {
                        return new TtsMessageProto(properties);
                    };

                    /**
                     * Encodes the specified TtsMessageProto message. Does not implicitly {@link ai.talecast.webapp.proto.TtsMessageProto.verify|verify} messages.
                     * @function encode
                     * @memberof ai.talecast.webapp.proto.TtsMessageProto
                     * @static
                     * @param {ai.talecast.webapp.proto.ITtsMessageProto} message TtsMessageProto message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TtsMessageProto.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.isSucceed != null && Object.hasOwnProperty.call(message, "isSucceed"))
                            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.isSucceed);
                        if (message.projectId != null && Object.hasOwnProperty.call(message, "projectId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.projectId);
                        if (message.detail != null && Object.hasOwnProperty.call(message, "detail"))
                            $root.ai.talecast.webapp.proto.AudioDetailProto.encode(message.detail, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                        if (message.extraDetail != null && Object.hasOwnProperty.call(message, "extraDetail"))
                            $root.ai.talecast.webapp.proto.AudioDetailProto.encode(message.extraDetail, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                        return writer;
                    };

                    /**
                     * Encodes the specified TtsMessageProto message, length delimited. Does not implicitly {@link ai.talecast.webapp.proto.TtsMessageProto.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof ai.talecast.webapp.proto.TtsMessageProto
                     * @static
                     * @param {ai.talecast.webapp.proto.ITtsMessageProto} message TtsMessageProto message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TtsMessageProto.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a TtsMessageProto message from the specified reader or buffer.
                     * @function decode
                     * @memberof ai.talecast.webapp.proto.TtsMessageProto
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {ai.talecast.webapp.proto.TtsMessageProto} TtsMessageProto
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TtsMessageProto.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        const end = length === undefined ? reader.len : reader.pos + length, message = new $root.ai.talecast.webapp.proto.TtsMessageProto();
                        while (reader.pos < end) {
                            const tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.isSucceed = reader.bool();
                                    break;
                                }
                            case 2: {
                                    message.projectId = reader.int64();
                                    break;
                                }
                            case 3: {
                                    message.detail = $root.ai.talecast.webapp.proto.AudioDetailProto.decode(reader, reader.uint32());
                                    break;
                                }
                            case 4: {
                                    message.extraDetail = $root.ai.talecast.webapp.proto.AudioDetailProto.decode(reader, reader.uint32());
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a TtsMessageProto message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof ai.talecast.webapp.proto.TtsMessageProto
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {ai.talecast.webapp.proto.TtsMessageProto} TtsMessageProto
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TtsMessageProto.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a TtsMessageProto message.
                     * @function verify
                     * @memberof ai.talecast.webapp.proto.TtsMessageProto
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    TtsMessageProto.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        const properties = {};
                        if (message.isSucceed != null && message.hasOwnProperty("isSucceed"))
                            if (typeof message.isSucceed !== "boolean")
                                return "isSucceed: boolean expected";
                        if (message.projectId != null && message.hasOwnProperty("projectId"))
                            if (!$util.isInteger(message.projectId) && !(message.projectId && $util.isInteger(message.projectId.low) && $util.isInteger(message.projectId.high)))
                                return "projectId: integer|Long expected";
                        if (message.detail != null && message.hasOwnProperty("detail")) {
                            const error = $root.ai.talecast.webapp.proto.AudioDetailProto.verify(message.detail);
                            if (error)
                                return "detail." + error;
                        }
                        if (message.extraDetail != null && message.hasOwnProperty("extraDetail")) {
                            properties._extraDetail = 1;
                            {
                                const error = $root.ai.talecast.webapp.proto.AudioDetailProto.verify(message.extraDetail);
                                if (error)
                                    return "extraDetail." + error;
                            }
                        }
                        return null;
                    };

                    /**
                     * Creates a TtsMessageProto message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof ai.talecast.webapp.proto.TtsMessageProto
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {ai.talecast.webapp.proto.TtsMessageProto} TtsMessageProto
                     */
                    TtsMessageProto.fromObject = function fromObject(object) {
                        if (object instanceof $root.ai.talecast.webapp.proto.TtsMessageProto)
                            return object;
                        const message = new $root.ai.talecast.webapp.proto.TtsMessageProto();
                        if (object.isSucceed != null)
                            message.isSucceed = Boolean(object.isSucceed);
                        if (object.projectId != null)
                            if ($util.Long)
                                (message.projectId = $util.Long.fromValue(object.projectId)).unsigned = false;
                            else if (typeof object.projectId === "string")
                                message.projectId = parseInt(object.projectId, 10);
                            else if (typeof object.projectId === "number")
                                message.projectId = object.projectId;
                            else if (typeof object.projectId === "object")
                                message.projectId = new $util.LongBits(object.projectId.low >>> 0, object.projectId.high >>> 0).toNumber();
                        if (object.detail != null) {
                            if (typeof object.detail !== "object")
                                throw TypeError(".ai.talecast.webapp.proto.TtsMessageProto.detail: object expected");
                            message.detail = $root.ai.talecast.webapp.proto.AudioDetailProto.fromObject(object.detail);
                        }
                        if (object.extraDetail != null) {
                            if (typeof object.extraDetail !== "object")
                                throw TypeError(".ai.talecast.webapp.proto.TtsMessageProto.extraDetail: object expected");
                            message.extraDetail = $root.ai.talecast.webapp.proto.AudioDetailProto.fromObject(object.extraDetail);
                        }
                        return message;
                    };

                    /**
                     * Creates a plain object from a TtsMessageProto message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof ai.talecast.webapp.proto.TtsMessageProto
                     * @static
                     * @param {ai.talecast.webapp.proto.TtsMessageProto} message TtsMessageProto
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    TtsMessageProto.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        const object = {};
                        if (options.defaults) {
                            object.isSucceed = false;
                            if ($util.Long) {
                                const long = new $util.Long(0, 0, false);
                                object.projectId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.projectId = options.longs === String ? "0" : 0;
                            object.detail = null;
                        }
                        if (message.isSucceed != null && message.hasOwnProperty("isSucceed"))
                            object.isSucceed = message.isSucceed;
                        if (message.projectId != null && message.hasOwnProperty("projectId"))
                            if (typeof message.projectId === "number")
                                object.projectId = options.longs === String ? String(message.projectId) : message.projectId;
                            else
                                object.projectId = options.longs === String ? $util.Long.prototype.toString.call(message.projectId) : options.longs === Number ? new $util.LongBits(message.projectId.low >>> 0, message.projectId.high >>> 0).toNumber() : message.projectId;
                        if (message.detail != null && message.hasOwnProperty("detail"))
                            object.detail = $root.ai.talecast.webapp.proto.AudioDetailProto.toObject(message.detail, options);
                        if (message.extraDetail != null && message.hasOwnProperty("extraDetail")) {
                            object.extraDetail = $root.ai.talecast.webapp.proto.AudioDetailProto.toObject(message.extraDetail, options);
                            if (options.oneofs)
                                object._extraDetail = "extraDetail";
                        }
                        return object;
                    };

                    /**
                     * Converts this TtsMessageProto to JSON.
                     * @function toJSON
                     * @memberof ai.talecast.webapp.proto.TtsMessageProto
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    TtsMessageProto.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for TtsMessageProto
                     * @function getTypeUrl
                     * @memberof ai.talecast.webapp.proto.TtsMessageProto
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    TtsMessageProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/ai.talecast.webapp.proto.TtsMessageProto";
                    };

                    return TtsMessageProto;
                })();

                proto.AudioDetailProto = (function() {

                    /**
                     * Properties of an AudioDetailProto.
                     * @memberof ai.talecast.webapp.proto
                     * @interface IAudioDetailProto
                     * @property {number|Long|null} [id] AudioDetailProto id
                     * @property {number|null} [volume] AudioDetailProto volume
                     * @property {number|null} [speed] AudioDetailProto speed
                     * @property {string|null} [sentence] AudioDetailProto sentence
                     * @property {string|null} [sentenceUrl] AudioDetailProto sentenceUrl
                     * @property {string|null} [speaker] AudioDetailProto speaker
                     * @property {number|null} [speakerId] AudioDetailProto speakerId
                     * @property {number|null} [from] AudioDetailProto from
                     * @property {number|null} [to] AudioDetailProto to
                     * @property {ai.talecast.webapp.proto.ISubtitle|null} [subtitle] AudioDetailProto subtitle
                     * @property {number|null} [timeLineFrom] AudioDetailProto timeLineFrom
                     * @property {number|null} [timeLineTo] AudioDetailProto timeLineTo
                     * @property {boolean|null} [isEdit] AudioDetailProto isEdit
                     * @property {boolean|null} [generating] AudioDetailProto generating
                     * @property {number|null} [type] AudioDetailProto type
                     * @property {boolean|null} [sentenceShow] AudioDetailProto sentenceShow
                     * @property {number|null} [trackIndex] AudioDetailProto trackIndex
                     * @property {boolean|null} [mute] AudioDetailProto mute
                     * @property {Array.<ai.talecast.webapp.proto.ITempCaptionsDetail>|null} [subtitleSegmented] AudioDetailProto subtitleSegmented
                     * @property {boolean|null} [translating] AudioDetailProto translating
                     * @property {boolean|null} [subtitleEdit] AudioDetailProto subtitleEdit
                     * @property {string|null} [language] AudioDetailProto language
                     */

                    /**
                     * Constructs a new AudioDetailProto.
                     * @memberof ai.talecast.webapp.proto
                     * @classdesc Represents an AudioDetailProto.
                     * @implements IAudioDetailProto
                     * @constructor
                     * @param {ai.talecast.webapp.proto.IAudioDetailProto=} [properties] Properties to set
                     */
                    function AudioDetailProto(properties) {
                        this.subtitleSegmented = [];
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * AudioDetailProto id.
                     * @member {number|Long} id
                     * @memberof ai.talecast.webapp.proto.AudioDetailProto
                     * @instance
                     */
                    AudioDetailProto.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                    /**
                     * AudioDetailProto volume.
                     * @member {number|null|undefined} volume
                     * @memberof ai.talecast.webapp.proto.AudioDetailProto
                     * @instance
                     */
                    AudioDetailProto.prototype.volume = null;

                    /**
                     * AudioDetailProto speed.
                     * @member {number|null|undefined} speed
                     * @memberof ai.talecast.webapp.proto.AudioDetailProto
                     * @instance
                     */
                    AudioDetailProto.prototype.speed = null;

                    /**
                     * AudioDetailProto sentence.
                     * @member {string|null|undefined} sentence
                     * @memberof ai.talecast.webapp.proto.AudioDetailProto
                     * @instance
                     */
                    AudioDetailProto.prototype.sentence = null;

                    /**
                     * AudioDetailProto sentenceUrl.
                     * @member {string|null|undefined} sentenceUrl
                     * @memberof ai.talecast.webapp.proto.AudioDetailProto
                     * @instance
                     */
                    AudioDetailProto.prototype.sentenceUrl = null;

                    /**
                     * AudioDetailProto speaker.
                     * @member {string} speaker
                     * @memberof ai.talecast.webapp.proto.AudioDetailProto
                     * @instance
                     */
                    AudioDetailProto.prototype.speaker = "";

                    /**
                     * AudioDetailProto speakerId.
                     * @member {number} speakerId
                     * @memberof ai.talecast.webapp.proto.AudioDetailProto
                     * @instance
                     */
                    AudioDetailProto.prototype.speakerId = 0;

                    /**
                     * AudioDetailProto from.
                     * @member {number|null|undefined} from
                     * @memberof ai.talecast.webapp.proto.AudioDetailProto
                     * @instance
                     */
                    AudioDetailProto.prototype.from = null;

                    /**
                     * AudioDetailProto to.
                     * @member {number|null|undefined} to
                     * @memberof ai.talecast.webapp.proto.AudioDetailProto
                     * @instance
                     */
                    AudioDetailProto.prototype.to = null;

                    /**
                     * AudioDetailProto subtitle.
                     * @member {ai.talecast.webapp.proto.ISubtitle|null|undefined} subtitle
                     * @memberof ai.talecast.webapp.proto.AudioDetailProto
                     * @instance
                     */
                    AudioDetailProto.prototype.subtitle = null;

                    /**
                     * AudioDetailProto timeLineFrom.
                     * @member {number|null|undefined} timeLineFrom
                     * @memberof ai.talecast.webapp.proto.AudioDetailProto
                     * @instance
                     */
                    AudioDetailProto.prototype.timeLineFrom = null;

                    /**
                     * AudioDetailProto timeLineTo.
                     * @member {number|null|undefined} timeLineTo
                     * @memberof ai.talecast.webapp.proto.AudioDetailProto
                     * @instance
                     */
                    AudioDetailProto.prototype.timeLineTo = null;

                    /**
                     * AudioDetailProto isEdit.
                     * @member {boolean|null|undefined} isEdit
                     * @memberof ai.talecast.webapp.proto.AudioDetailProto
                     * @instance
                     */
                    AudioDetailProto.prototype.isEdit = null;

                    /**
                     * AudioDetailProto generating.
                     * @member {boolean|null|undefined} generating
                     * @memberof ai.talecast.webapp.proto.AudioDetailProto
                     * @instance
                     */
                    AudioDetailProto.prototype.generating = null;

                    /**
                     * AudioDetailProto type.
                     * @member {number|null|undefined} type
                     * @memberof ai.talecast.webapp.proto.AudioDetailProto
                     * @instance
                     */
                    AudioDetailProto.prototype.type = null;

                    /**
                     * AudioDetailProto sentenceShow.
                     * @member {boolean|null|undefined} sentenceShow
                     * @memberof ai.talecast.webapp.proto.AudioDetailProto
                     * @instance
                     */
                    AudioDetailProto.prototype.sentenceShow = null;

                    /**
                     * AudioDetailProto trackIndex.
                     * @member {number|null|undefined} trackIndex
                     * @memberof ai.talecast.webapp.proto.AudioDetailProto
                     * @instance
                     */
                    AudioDetailProto.prototype.trackIndex = null;

                    /**
                     * AudioDetailProto mute.
                     * @member {boolean|null|undefined} mute
                     * @memberof ai.talecast.webapp.proto.AudioDetailProto
                     * @instance
                     */
                    AudioDetailProto.prototype.mute = null;

                    /**
                     * AudioDetailProto subtitleSegmented.
                     * @member {Array.<ai.talecast.webapp.proto.ITempCaptionsDetail>} subtitleSegmented
                     * @memberof ai.talecast.webapp.proto.AudioDetailProto
                     * @instance
                     */
                    AudioDetailProto.prototype.subtitleSegmented = $util.emptyArray;

                    /**
                     * AudioDetailProto translating.
                     * @member {boolean|null|undefined} translating
                     * @memberof ai.talecast.webapp.proto.AudioDetailProto
                     * @instance
                     */
                    AudioDetailProto.prototype.translating = null;

                    /**
                     * AudioDetailProto subtitleEdit.
                     * @member {boolean|null|undefined} subtitleEdit
                     * @memberof ai.talecast.webapp.proto.AudioDetailProto
                     * @instance
                     */
                    AudioDetailProto.prototype.subtitleEdit = null;

                    /**
                     * AudioDetailProto language.
                     * @member {string|null|undefined} language
                     * @memberof ai.talecast.webapp.proto.AudioDetailProto
                     * @instance
                     */
                    AudioDetailProto.prototype.language = null;

                    // OneOf field names bound to virtual getters and setters
                    let $oneOfFields;

                    // Virtual OneOf for proto3 optional field
                    Object.defineProperty(AudioDetailProto.prototype, "_volume", {
                        get: $util.oneOfGetter($oneOfFields = ["volume"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    // Virtual OneOf for proto3 optional field
                    Object.defineProperty(AudioDetailProto.prototype, "_speed", {
                        get: $util.oneOfGetter($oneOfFields = ["speed"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    // Virtual OneOf for proto3 optional field
                    Object.defineProperty(AudioDetailProto.prototype, "_sentence", {
                        get: $util.oneOfGetter($oneOfFields = ["sentence"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    // Virtual OneOf for proto3 optional field
                    Object.defineProperty(AudioDetailProto.prototype, "_sentenceUrl", {
                        get: $util.oneOfGetter($oneOfFields = ["sentenceUrl"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    // Virtual OneOf for proto3 optional field
                    Object.defineProperty(AudioDetailProto.prototype, "_from", {
                        get: $util.oneOfGetter($oneOfFields = ["from"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    // Virtual OneOf for proto3 optional field
                    Object.defineProperty(AudioDetailProto.prototype, "_to", {
                        get: $util.oneOfGetter($oneOfFields = ["to"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    // Virtual OneOf for proto3 optional field
                    Object.defineProperty(AudioDetailProto.prototype, "_timeLineFrom", {
                        get: $util.oneOfGetter($oneOfFields = ["timeLineFrom"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    // Virtual OneOf for proto3 optional field
                    Object.defineProperty(AudioDetailProto.prototype, "_timeLineTo", {
                        get: $util.oneOfGetter($oneOfFields = ["timeLineTo"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    // Virtual OneOf for proto3 optional field
                    Object.defineProperty(AudioDetailProto.prototype, "_isEdit", {
                        get: $util.oneOfGetter($oneOfFields = ["isEdit"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    // Virtual OneOf for proto3 optional field
                    Object.defineProperty(AudioDetailProto.prototype, "_generating", {
                        get: $util.oneOfGetter($oneOfFields = ["generating"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    // Virtual OneOf for proto3 optional field
                    Object.defineProperty(AudioDetailProto.prototype, "_type", {
                        get: $util.oneOfGetter($oneOfFields = ["type"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    // Virtual OneOf for proto3 optional field
                    Object.defineProperty(AudioDetailProto.prototype, "_sentenceShow", {
                        get: $util.oneOfGetter($oneOfFields = ["sentenceShow"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    // Virtual OneOf for proto3 optional field
                    Object.defineProperty(AudioDetailProto.prototype, "_trackIndex", {
                        get: $util.oneOfGetter($oneOfFields = ["trackIndex"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    // Virtual OneOf for proto3 optional field
                    Object.defineProperty(AudioDetailProto.prototype, "_mute", {
                        get: $util.oneOfGetter($oneOfFields = ["mute"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    // Virtual OneOf for proto3 optional field
                    Object.defineProperty(AudioDetailProto.prototype, "_translating", {
                        get: $util.oneOfGetter($oneOfFields = ["translating"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    // Virtual OneOf for proto3 optional field
                    Object.defineProperty(AudioDetailProto.prototype, "_subtitleEdit", {
                        get: $util.oneOfGetter($oneOfFields = ["subtitleEdit"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    // Virtual OneOf for proto3 optional field
                    Object.defineProperty(AudioDetailProto.prototype, "_language", {
                        get: $util.oneOfGetter($oneOfFields = ["language"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    /**
                     * Creates a new AudioDetailProto instance using the specified properties.
                     * @function create
                     * @memberof ai.talecast.webapp.proto.AudioDetailProto
                     * @static
                     * @param {ai.talecast.webapp.proto.IAudioDetailProto=} [properties] Properties to set
                     * @returns {ai.talecast.webapp.proto.AudioDetailProto} AudioDetailProto instance
                     */
                    AudioDetailProto.create = function create(properties) {
                        return new AudioDetailProto(properties);
                    };

                    /**
                     * Encodes the specified AudioDetailProto message. Does not implicitly {@link ai.talecast.webapp.proto.AudioDetailProto.verify|verify} messages.
                     * @function encode
                     * @memberof ai.talecast.webapp.proto.AudioDetailProto
                     * @static
                     * @param {ai.talecast.webapp.proto.IAudioDetailProto} message AudioDetailProto message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    AudioDetailProto.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.volume != null && Object.hasOwnProperty.call(message, "volume"))
                            writer.uint32(/* id 2, wireType 1 =*/17).double(message.volume);
                        if (message.speed != null && Object.hasOwnProperty.call(message, "speed"))
                            writer.uint32(/* id 3, wireType 1 =*/25).double(message.speed);
                        if (message.sentence != null && Object.hasOwnProperty.call(message, "sentence"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.sentence);
                        if (message.sentenceUrl != null && Object.hasOwnProperty.call(message, "sentenceUrl"))
                            writer.uint32(/* id 5, wireType 2 =*/42).string(message.sentenceUrl);
                        if (message.speaker != null && Object.hasOwnProperty.call(message, "speaker"))
                            writer.uint32(/* id 6, wireType 2 =*/50).string(message.speaker);
                        if (message.speakerId != null && Object.hasOwnProperty.call(message, "speakerId"))
                            writer.uint32(/* id 7, wireType 0 =*/56).int32(message.speakerId);
                        if (message.from != null && Object.hasOwnProperty.call(message, "from"))
                            writer.uint32(/* id 8, wireType 0 =*/64).int32(message.from);
                        if (message.to != null && Object.hasOwnProperty.call(message, "to"))
                            writer.uint32(/* id 9, wireType 0 =*/72).int32(message.to);
                        if (message.subtitle != null && Object.hasOwnProperty.call(message, "subtitle"))
                            $root.ai.talecast.webapp.proto.Subtitle.encode(message.subtitle, writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
                        if (message.timeLineFrom != null && Object.hasOwnProperty.call(message, "timeLineFrom"))
                            writer.uint32(/* id 11, wireType 0 =*/88).int32(message.timeLineFrom);
                        if (message.timeLineTo != null && Object.hasOwnProperty.call(message, "timeLineTo"))
                            writer.uint32(/* id 12, wireType 0 =*/96).int32(message.timeLineTo);
                        if (message.isEdit != null && Object.hasOwnProperty.call(message, "isEdit"))
                            writer.uint32(/* id 13, wireType 0 =*/104).bool(message.isEdit);
                        if (message.generating != null && Object.hasOwnProperty.call(message, "generating"))
                            writer.uint32(/* id 14, wireType 0 =*/112).bool(message.generating);
                        if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                            writer.uint32(/* id 15, wireType 0 =*/120).int32(message.type);
                        if (message.sentenceShow != null && Object.hasOwnProperty.call(message, "sentenceShow"))
                            writer.uint32(/* id 16, wireType 0 =*/128).bool(message.sentenceShow);
                        if (message.trackIndex != null && Object.hasOwnProperty.call(message, "trackIndex"))
                            writer.uint32(/* id 17, wireType 1 =*/137).double(message.trackIndex);
                        if (message.mute != null && Object.hasOwnProperty.call(message, "mute"))
                            writer.uint32(/* id 18, wireType 0 =*/144).bool(message.mute);
                        if (message.subtitleSegmented != null && message.subtitleSegmented.length)
                            for (let i = 0; i < message.subtitleSegmented.length; ++i)
                                $root.ai.talecast.webapp.proto.TempCaptionsDetail.encode(message.subtitleSegmented[i], writer.uint32(/* id 19, wireType 2 =*/154).fork()).ldelim();
                        if (message.translating != null && Object.hasOwnProperty.call(message, "translating"))
                            writer.uint32(/* id 20, wireType 0 =*/160).bool(message.translating);
                        if (message.subtitleEdit != null && Object.hasOwnProperty.call(message, "subtitleEdit"))
                            writer.uint32(/* id 21, wireType 0 =*/168).bool(message.subtitleEdit);
                        if (message.language != null && Object.hasOwnProperty.call(message, "language"))
                            writer.uint32(/* id 22, wireType 2 =*/178).string(message.language);
                        return writer;
                    };

                    /**
                     * Encodes the specified AudioDetailProto message, length delimited. Does not implicitly {@link ai.talecast.webapp.proto.AudioDetailProto.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof ai.talecast.webapp.proto.AudioDetailProto
                     * @static
                     * @param {ai.talecast.webapp.proto.IAudioDetailProto} message AudioDetailProto message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    AudioDetailProto.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes an AudioDetailProto message from the specified reader or buffer.
                     * @function decode
                     * @memberof ai.talecast.webapp.proto.AudioDetailProto
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {ai.talecast.webapp.proto.AudioDetailProto} AudioDetailProto
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    AudioDetailProto.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        const end = length === undefined ? reader.len : reader.pos + length, message = new $root.ai.talecast.webapp.proto.AudioDetailProto();
                        while (reader.pos < end) {
                            const tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.id = reader.int64();
                                    break;
                                }
                            case 2: {
                                    message.volume = reader.double();
                                    break;
                                }
                            case 3: {
                                    message.speed = reader.double();
                                    break;
                                }
                            case 4: {
                                    message.sentence = reader.string();
                                    break;
                                }
                            case 5: {
                                    message.sentenceUrl = reader.string();
                                    break;
                                }
                            case 6: {
                                    message.speaker = reader.string();
                                    break;
                                }
                            case 7: {
                                    message.speakerId = reader.int32();
                                    break;
                                }
                            case 8: {
                                    message.from = reader.int32();
                                    break;
                                }
                            case 9: {
                                    message.to = reader.int32();
                                    break;
                                }
                            case 10: {
                                    message.subtitle = $root.ai.talecast.webapp.proto.Subtitle.decode(reader, reader.uint32());
                                    break;
                                }
                            case 11: {
                                    message.timeLineFrom = reader.int32();
                                    break;
                                }
                            case 12: {
                                    message.timeLineTo = reader.int32();
                                    break;
                                }
                            case 13: {
                                    message.isEdit = reader.bool();
                                    break;
                                }
                            case 14: {
                                    message.generating = reader.bool();
                                    break;
                                }
                            case 15: {
                                    message.type = reader.int32();
                                    break;
                                }
                            case 16: {
                                    message.sentenceShow = reader.bool();
                                    break;
                                }
                            case 17: {
                                    message.trackIndex = reader.double();
                                    break;
                                }
                            case 18: {
                                    message.mute = reader.bool();
                                    break;
                                }
                            case 19: {
                                    if (!(message.subtitleSegmented && message.subtitleSegmented.length))
                                        message.subtitleSegmented = [];
                                    message.subtitleSegmented.push($root.ai.talecast.webapp.proto.TempCaptionsDetail.decode(reader, reader.uint32()));
                                    break;
                                }
                            case 20: {
                                    message.translating = reader.bool();
                                    break;
                                }
                            case 21: {
                                    message.subtitleEdit = reader.bool();
                                    break;
                                }
                            case 22: {
                                    message.language = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes an AudioDetailProto message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof ai.talecast.webapp.proto.AudioDetailProto
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {ai.talecast.webapp.proto.AudioDetailProto} AudioDetailProto
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    AudioDetailProto.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies an AudioDetailProto message.
                     * @function verify
                     * @memberof ai.talecast.webapp.proto.AudioDetailProto
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    AudioDetailProto.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        const properties = {};
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.volume != null && message.hasOwnProperty("volume")) {
                            properties._volume = 1;
                            if (typeof message.volume !== "number")
                                return "volume: number expected";
                        }
                        if (message.speed != null && message.hasOwnProperty("speed")) {
                            properties._speed = 1;
                            if (typeof message.speed !== "number")
                                return "speed: number expected";
                        }
                        if (message.sentence != null && message.hasOwnProperty("sentence")) {
                            properties._sentence = 1;
                            if (!$util.isString(message.sentence))
                                return "sentence: string expected";
                        }
                        if (message.sentenceUrl != null && message.hasOwnProperty("sentenceUrl")) {
                            properties._sentenceUrl = 1;
                            if (!$util.isString(message.sentenceUrl))
                                return "sentenceUrl: string expected";
                        }
                        if (message.speaker != null && message.hasOwnProperty("speaker"))
                            if (!$util.isString(message.speaker))
                                return "speaker: string expected";
                        if (message.speakerId != null && message.hasOwnProperty("speakerId"))
                            if (!$util.isInteger(message.speakerId))
                                return "speakerId: integer expected";
                        if (message.from != null && message.hasOwnProperty("from")) {
                            properties._from = 1;
                            if (!$util.isInteger(message.from))
                                return "from: integer expected";
                        }
                        if (message.to != null && message.hasOwnProperty("to")) {
                            properties._to = 1;
                            if (!$util.isInteger(message.to))
                                return "to: integer expected";
                        }
                        if (message.subtitle != null && message.hasOwnProperty("subtitle")) {
                            const error = $root.ai.talecast.webapp.proto.Subtitle.verify(message.subtitle);
                            if (error)
                                return "subtitle." + error;
                        }
                        if (message.timeLineFrom != null && message.hasOwnProperty("timeLineFrom")) {
                            properties._timeLineFrom = 1;
                            if (!$util.isInteger(message.timeLineFrom))
                                return "timeLineFrom: integer expected";
                        }
                        if (message.timeLineTo != null && message.hasOwnProperty("timeLineTo")) {
                            properties._timeLineTo = 1;
                            if (!$util.isInteger(message.timeLineTo))
                                return "timeLineTo: integer expected";
                        }
                        if (message.isEdit != null && message.hasOwnProperty("isEdit")) {
                            properties._isEdit = 1;
                            if (typeof message.isEdit !== "boolean")
                                return "isEdit: boolean expected";
                        }
                        if (message.generating != null && message.hasOwnProperty("generating")) {
                            properties._generating = 1;
                            if (typeof message.generating !== "boolean")
                                return "generating: boolean expected";
                        }
                        if (message.type != null && message.hasOwnProperty("type")) {
                            properties._type = 1;
                            if (!$util.isInteger(message.type))
                                return "type: integer expected";
                        }
                        if (message.sentenceShow != null && message.hasOwnProperty("sentenceShow")) {
                            properties._sentenceShow = 1;
                            if (typeof message.sentenceShow !== "boolean")
                                return "sentenceShow: boolean expected";
                        }
                        if (message.trackIndex != null && message.hasOwnProperty("trackIndex")) {
                            properties._trackIndex = 1;
                            if (typeof message.trackIndex !== "number")
                                return "trackIndex: number expected";
                        }
                        if (message.mute != null && message.hasOwnProperty("mute")) {
                            properties._mute = 1;
                            if (typeof message.mute !== "boolean")
                                return "mute: boolean expected";
                        }
                        if (message.subtitleSegmented != null && message.hasOwnProperty("subtitleSegmented")) {
                            if (!Array.isArray(message.subtitleSegmented))
                                return "subtitleSegmented: array expected";
                            for (let i = 0; i < message.subtitleSegmented.length; ++i) {
                                const error = $root.ai.talecast.webapp.proto.TempCaptionsDetail.verify(message.subtitleSegmented[i]);
                                if (error)
                                    return "subtitleSegmented." + error;
                            }
                        }
                        if (message.translating != null && message.hasOwnProperty("translating")) {
                            properties._translating = 1;
                            if (typeof message.translating !== "boolean")
                                return "translating: boolean expected";
                        }
                        if (message.subtitleEdit != null && message.hasOwnProperty("subtitleEdit")) {
                            properties._subtitleEdit = 1;
                            if (typeof message.subtitleEdit !== "boolean")
                                return "subtitleEdit: boolean expected";
                        }
                        if (message.language != null && message.hasOwnProperty("language")) {
                            properties._language = 1;
                            if (!$util.isString(message.language))
                                return "language: string expected";
                        }
                        return null;
                    };

                    /**
                     * Creates an AudioDetailProto message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof ai.talecast.webapp.proto.AudioDetailProto
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {ai.talecast.webapp.proto.AudioDetailProto} AudioDetailProto
                     */
                    AudioDetailProto.fromObject = function fromObject(object) {
                        if (object instanceof $root.ai.talecast.webapp.proto.AudioDetailProto)
                            return object;
                        const message = new $root.ai.talecast.webapp.proto.AudioDetailProto();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.volume != null)
                            message.volume = Number(object.volume);
                        if (object.speed != null)
                            message.speed = Number(object.speed);
                        if (object.sentence != null)
                            message.sentence = String(object.sentence);
                        if (object.sentenceUrl != null)
                            message.sentenceUrl = String(object.sentenceUrl);
                        if (object.speaker != null)
                            message.speaker = String(object.speaker);
                        if (object.speakerId != null)
                            message.speakerId = object.speakerId | 0;
                        if (object.from != null)
                            message.from = object.from | 0;
                        if (object.to != null)
                            message.to = object.to | 0;
                        if (object.subtitle != null) {
                            if (typeof object.subtitle !== "object")
                                throw TypeError(".ai.talecast.webapp.proto.AudioDetailProto.subtitle: object expected");
                            message.subtitle = $root.ai.talecast.webapp.proto.Subtitle.fromObject(object.subtitle);
                        }
                        if (object.timeLineFrom != null)
                            message.timeLineFrom = object.timeLineFrom | 0;
                        if (object.timeLineTo != null)
                            message.timeLineTo = object.timeLineTo | 0;
                        if (object.isEdit != null)
                            message.isEdit = Boolean(object.isEdit);
                        if (object.generating != null)
                            message.generating = Boolean(object.generating);
                        if (object.type != null)
                            message.type = object.type | 0;
                        if (object.sentenceShow != null)
                            message.sentenceShow = Boolean(object.sentenceShow);
                        if (object.trackIndex != null)
                            message.trackIndex = Number(object.trackIndex);
                        if (object.mute != null)
                            message.mute = Boolean(object.mute);
                        if (object.subtitleSegmented) {
                            if (!Array.isArray(object.subtitleSegmented))
                                throw TypeError(".ai.talecast.webapp.proto.AudioDetailProto.subtitleSegmented: array expected");
                            message.subtitleSegmented = [];
                            for (let i = 0; i < object.subtitleSegmented.length; ++i) {
                                if (typeof object.subtitleSegmented[i] !== "object")
                                    throw TypeError(".ai.talecast.webapp.proto.AudioDetailProto.subtitleSegmented: object expected");
                                message.subtitleSegmented[i] = $root.ai.talecast.webapp.proto.TempCaptionsDetail.fromObject(object.subtitleSegmented[i]);
                            }
                        }
                        if (object.translating != null)
                            message.translating = Boolean(object.translating);
                        if (object.subtitleEdit != null)
                            message.subtitleEdit = Boolean(object.subtitleEdit);
                        if (object.language != null)
                            message.language = String(object.language);
                        return message;
                    };

                    /**
                     * Creates a plain object from an AudioDetailProto message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof ai.talecast.webapp.proto.AudioDetailProto
                     * @static
                     * @param {ai.talecast.webapp.proto.AudioDetailProto} message AudioDetailProto
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    AudioDetailProto.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        const object = {};
                        if (options.arrays || options.defaults)
                            object.subtitleSegmented = [];
                        if (options.defaults) {
                            if ($util.Long) {
                                const long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            object.speaker = "";
                            object.speakerId = 0;
                            object.subtitle = null;
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.volume != null && message.hasOwnProperty("volume")) {
                            object.volume = options.json && !isFinite(message.volume) ? String(message.volume) : message.volume;
                            if (options.oneofs)
                                object._volume = "volume";
                        }
                        if (message.speed != null && message.hasOwnProperty("speed")) {
                            object.speed = options.json && !isFinite(message.speed) ? String(message.speed) : message.speed;
                            if (options.oneofs)
                                object._speed = "speed";
                        }
                        if (message.sentence != null && message.hasOwnProperty("sentence")) {
                            object.sentence = message.sentence;
                            if (options.oneofs)
                                object._sentence = "sentence";
                        }
                        if (message.sentenceUrl != null && message.hasOwnProperty("sentenceUrl")) {
                            object.sentenceUrl = message.sentenceUrl;
                            if (options.oneofs)
                                object._sentenceUrl = "sentenceUrl";
                        }
                        if (message.speaker != null && message.hasOwnProperty("speaker"))
                            object.speaker = message.speaker;
                        if (message.speakerId != null && message.hasOwnProperty("speakerId"))
                            object.speakerId = message.speakerId;
                        if (message.from != null && message.hasOwnProperty("from")) {
                            object.from = message.from;
                            if (options.oneofs)
                                object._from = "from";
                        }
                        if (message.to != null && message.hasOwnProperty("to")) {
                            object.to = message.to;
                            if (options.oneofs)
                                object._to = "to";
                        }
                        if (message.subtitle != null && message.hasOwnProperty("subtitle"))
                            object.subtitle = $root.ai.talecast.webapp.proto.Subtitle.toObject(message.subtitle, options);
                        if (message.timeLineFrom != null && message.hasOwnProperty("timeLineFrom")) {
                            object.timeLineFrom = message.timeLineFrom;
                            if (options.oneofs)
                                object._timeLineFrom = "timeLineFrom";
                        }
                        if (message.timeLineTo != null && message.hasOwnProperty("timeLineTo")) {
                            object.timeLineTo = message.timeLineTo;
                            if (options.oneofs)
                                object._timeLineTo = "timeLineTo";
                        }
                        if (message.isEdit != null && message.hasOwnProperty("isEdit")) {
                            object.isEdit = message.isEdit;
                            if (options.oneofs)
                                object._isEdit = "isEdit";
                        }
                        if (message.generating != null && message.hasOwnProperty("generating")) {
                            object.generating = message.generating;
                            if (options.oneofs)
                                object._generating = "generating";
                        }
                        if (message.type != null && message.hasOwnProperty("type")) {
                            object.type = message.type;
                            if (options.oneofs)
                                object._type = "type";
                        }
                        if (message.sentenceShow != null && message.hasOwnProperty("sentenceShow")) {
                            object.sentenceShow = message.sentenceShow;
                            if (options.oneofs)
                                object._sentenceShow = "sentenceShow";
                        }
                        if (message.trackIndex != null && message.hasOwnProperty("trackIndex")) {
                            object.trackIndex = options.json && !isFinite(message.trackIndex) ? String(message.trackIndex) : message.trackIndex;
                            if (options.oneofs)
                                object._trackIndex = "trackIndex";
                        }
                        if (message.mute != null && message.hasOwnProperty("mute")) {
                            object.mute = message.mute;
                            if (options.oneofs)
                                object._mute = "mute";
                        }
                        if (message.subtitleSegmented && message.subtitleSegmented.length) {
                            object.subtitleSegmented = [];
                            for (let j = 0; j < message.subtitleSegmented.length; ++j)
                                object.subtitleSegmented[j] = $root.ai.talecast.webapp.proto.TempCaptionsDetail.toObject(message.subtitleSegmented[j], options);
                        }
                        if (message.translating != null && message.hasOwnProperty("translating")) {
                            object.translating = message.translating;
                            if (options.oneofs)
                                object._translating = "translating";
                        }
                        if (message.subtitleEdit != null && message.hasOwnProperty("subtitleEdit")) {
                            object.subtitleEdit = message.subtitleEdit;
                            if (options.oneofs)
                                object._subtitleEdit = "subtitleEdit";
                        }
                        if (message.language != null && message.hasOwnProperty("language")) {
                            object.language = message.language;
                            if (options.oneofs)
                                object._language = "language";
                        }
                        return object;
                    };

                    /**
                     * Converts this AudioDetailProto to JSON.
                     * @function toJSON
                     * @memberof ai.talecast.webapp.proto.AudioDetailProto
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    AudioDetailProto.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for AudioDetailProto
                     * @function getTypeUrl
                     * @memberof ai.talecast.webapp.proto.AudioDetailProto
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    AudioDetailProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/ai.talecast.webapp.proto.AudioDetailProto";
                    };

                    return AudioDetailProto;
                })();

                proto.TranslationMessageProto = (function() {

                    /**
                     * Properties of a TranslationMessageProto.
                     * @memberof ai.talecast.webapp.proto
                     * @interface ITranslationMessageProto
                     * @property {boolean|null} [isSucceed] TranslationMessageProto isSucceed
                     * @property {number|Long|null} [projectId] TranslationMessageProto projectId
                     * @property {ai.talecast.webapp.proto.ITranslateDetailProto|null} [detail] TranslationMessageProto detail
                     */

                    /**
                     * Constructs a new TranslationMessageProto.
                     * @memberof ai.talecast.webapp.proto
                     * @classdesc Represents a TranslationMessageProto.
                     * @implements ITranslationMessageProto
                     * @constructor
                     * @param {ai.talecast.webapp.proto.ITranslationMessageProto=} [properties] Properties to set
                     */
                    function TranslationMessageProto(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * TranslationMessageProto isSucceed.
                     * @member {boolean} isSucceed
                     * @memberof ai.talecast.webapp.proto.TranslationMessageProto
                     * @instance
                     */
                    TranslationMessageProto.prototype.isSucceed = false;

                    /**
                     * TranslationMessageProto projectId.
                     * @member {number|Long} projectId
                     * @memberof ai.talecast.webapp.proto.TranslationMessageProto
                     * @instance
                     */
                    TranslationMessageProto.prototype.projectId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                    /**
                     * TranslationMessageProto detail.
                     * @member {ai.talecast.webapp.proto.ITranslateDetailProto|null|undefined} detail
                     * @memberof ai.talecast.webapp.proto.TranslationMessageProto
                     * @instance
                     */
                    TranslationMessageProto.prototype.detail = null;

                    /**
                     * Creates a new TranslationMessageProto instance using the specified properties.
                     * @function create
                     * @memberof ai.talecast.webapp.proto.TranslationMessageProto
                     * @static
                     * @param {ai.talecast.webapp.proto.ITranslationMessageProto=} [properties] Properties to set
                     * @returns {ai.talecast.webapp.proto.TranslationMessageProto} TranslationMessageProto instance
                     */
                    TranslationMessageProto.create = function create(properties) {
                        return new TranslationMessageProto(properties);
                    };

                    /**
                     * Encodes the specified TranslationMessageProto message. Does not implicitly {@link ai.talecast.webapp.proto.TranslationMessageProto.verify|verify} messages.
                     * @function encode
                     * @memberof ai.talecast.webapp.proto.TranslationMessageProto
                     * @static
                     * @param {ai.talecast.webapp.proto.ITranslationMessageProto} message TranslationMessageProto message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TranslationMessageProto.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.isSucceed != null && Object.hasOwnProperty.call(message, "isSucceed"))
                            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.isSucceed);
                        if (message.projectId != null && Object.hasOwnProperty.call(message, "projectId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.projectId);
                        if (message.detail != null && Object.hasOwnProperty.call(message, "detail"))
                            $root.ai.talecast.webapp.proto.TranslateDetailProto.encode(message.detail, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                        return writer;
                    };

                    /**
                     * Encodes the specified TranslationMessageProto message, length delimited. Does not implicitly {@link ai.talecast.webapp.proto.TranslationMessageProto.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof ai.talecast.webapp.proto.TranslationMessageProto
                     * @static
                     * @param {ai.talecast.webapp.proto.ITranslationMessageProto} message TranslationMessageProto message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TranslationMessageProto.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a TranslationMessageProto message from the specified reader or buffer.
                     * @function decode
                     * @memberof ai.talecast.webapp.proto.TranslationMessageProto
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {ai.talecast.webapp.proto.TranslationMessageProto} TranslationMessageProto
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TranslationMessageProto.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        const end = length === undefined ? reader.len : reader.pos + length, message = new $root.ai.talecast.webapp.proto.TranslationMessageProto();
                        while (reader.pos < end) {
                            const tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.isSucceed = reader.bool();
                                    break;
                                }
                            case 2: {
                                    message.projectId = reader.int64();
                                    break;
                                }
                            case 3: {
                                    message.detail = $root.ai.talecast.webapp.proto.TranslateDetailProto.decode(reader, reader.uint32());
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a TranslationMessageProto message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof ai.talecast.webapp.proto.TranslationMessageProto
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {ai.talecast.webapp.proto.TranslationMessageProto} TranslationMessageProto
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TranslationMessageProto.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a TranslationMessageProto message.
                     * @function verify
                     * @memberof ai.talecast.webapp.proto.TranslationMessageProto
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    TranslationMessageProto.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.isSucceed != null && message.hasOwnProperty("isSucceed"))
                            if (typeof message.isSucceed !== "boolean")
                                return "isSucceed: boolean expected";
                        if (message.projectId != null && message.hasOwnProperty("projectId"))
                            if (!$util.isInteger(message.projectId) && !(message.projectId && $util.isInteger(message.projectId.low) && $util.isInteger(message.projectId.high)))
                                return "projectId: integer|Long expected";
                        if (message.detail != null && message.hasOwnProperty("detail")) {
                            const error = $root.ai.talecast.webapp.proto.TranslateDetailProto.verify(message.detail);
                            if (error)
                                return "detail." + error;
                        }
                        return null;
                    };

                    /**
                     * Creates a TranslationMessageProto message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof ai.talecast.webapp.proto.TranslationMessageProto
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {ai.talecast.webapp.proto.TranslationMessageProto} TranslationMessageProto
                     */
                    TranslationMessageProto.fromObject = function fromObject(object) {
                        if (object instanceof $root.ai.talecast.webapp.proto.TranslationMessageProto)
                            return object;
                        const message = new $root.ai.talecast.webapp.proto.TranslationMessageProto();
                        if (object.isSucceed != null)
                            message.isSucceed = Boolean(object.isSucceed);
                        if (object.projectId != null)
                            if ($util.Long)
                                (message.projectId = $util.Long.fromValue(object.projectId)).unsigned = false;
                            else if (typeof object.projectId === "string")
                                message.projectId = parseInt(object.projectId, 10);
                            else if (typeof object.projectId === "number")
                                message.projectId = object.projectId;
                            else if (typeof object.projectId === "object")
                                message.projectId = new $util.LongBits(object.projectId.low >>> 0, object.projectId.high >>> 0).toNumber();
                        if (object.detail != null) {
                            if (typeof object.detail !== "object")
                                throw TypeError(".ai.talecast.webapp.proto.TranslationMessageProto.detail: object expected");
                            message.detail = $root.ai.talecast.webapp.proto.TranslateDetailProto.fromObject(object.detail);
                        }
                        return message;
                    };

                    /**
                     * Creates a plain object from a TranslationMessageProto message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof ai.talecast.webapp.proto.TranslationMessageProto
                     * @static
                     * @param {ai.talecast.webapp.proto.TranslationMessageProto} message TranslationMessageProto
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    TranslationMessageProto.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        const object = {};
                        if (options.defaults) {
                            object.isSucceed = false;
                            if ($util.Long) {
                                const long = new $util.Long(0, 0, false);
                                object.projectId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.projectId = options.longs === String ? "0" : 0;
                            object.detail = null;
                        }
                        if (message.isSucceed != null && message.hasOwnProperty("isSucceed"))
                            object.isSucceed = message.isSucceed;
                        if (message.projectId != null && message.hasOwnProperty("projectId"))
                            if (typeof message.projectId === "number")
                                object.projectId = options.longs === String ? String(message.projectId) : message.projectId;
                            else
                                object.projectId = options.longs === String ? $util.Long.prototype.toString.call(message.projectId) : options.longs === Number ? new $util.LongBits(message.projectId.low >>> 0, message.projectId.high >>> 0).toNumber() : message.projectId;
                        if (message.detail != null && message.hasOwnProperty("detail"))
                            object.detail = $root.ai.talecast.webapp.proto.TranslateDetailProto.toObject(message.detail, options);
                        return object;
                    };

                    /**
                     * Converts this TranslationMessageProto to JSON.
                     * @function toJSON
                     * @memberof ai.talecast.webapp.proto.TranslationMessageProto
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    TranslationMessageProto.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for TranslationMessageProto
                     * @function getTypeUrl
                     * @memberof ai.talecast.webapp.proto.TranslationMessageProto
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    TranslationMessageProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/ai.talecast.webapp.proto.TranslationMessageProto";
                    };

                    return TranslationMessageProto;
                })();

                proto.TranslateDetailProto = (function() {

                    /**
                     * Properties of a TranslateDetailProto.
                     * @memberof ai.talecast.webapp.proto
                     * @interface ITranslateDetailProto
                     * @property {number|Long|null} [id] TranslateDetailProto id
                     * @property {number|null} [volume] TranslateDetailProto volume
                     * @property {number|null} [speed] TranslateDetailProto speed
                     * @property {string|null} [sentence] TranslateDetailProto sentence
                     * @property {string|null} [sentenceUrl] TranslateDetailProto sentenceUrl
                     * @property {string|null} [speaker] TranslateDetailProto speaker
                     * @property {number|null} [speakerId] TranslateDetailProto speakerId
                     * @property {number|null} [from] TranslateDetailProto from
                     * @property {number|null} [to] TranslateDetailProto to
                     * @property {ai.talecast.webapp.proto.ISubtitle|null} [subtitle] TranslateDetailProto subtitle
                     * @property {number|null} [timeLineFrom] TranslateDetailProto timeLineFrom
                     * @property {number|null} [timeLineTo] TranslateDetailProto timeLineTo
                     * @property {boolean|null} [isEdit] TranslateDetailProto isEdit
                     * @property {boolean|null} [generating] TranslateDetailProto generating
                     * @property {number|null} [type] TranslateDetailProto type
                     * @property {boolean|null} [sentenceShow] TranslateDetailProto sentenceShow
                     * @property {number|null} [trackIndex] TranslateDetailProto trackIndex
                     * @property {boolean|null} [mute] TranslateDetailProto mute
                     * @property {boolean|null} [translating] TranslateDetailProto translating
                     * @property {Array.<ai.talecast.webapp.proto.ITempCaptionsDetail>|null} [subtitleSegmented] TranslateDetailProto subtitleSegmented
                     * @property {boolean|null} [subtitleEdit] TranslateDetailProto subtitleEdit
                     * @property {string|null} [language] TranslateDetailProto language
                     */

                    /**
                     * Constructs a new TranslateDetailProto.
                     * @memberof ai.talecast.webapp.proto
                     * @classdesc Represents a TranslateDetailProto.
                     * @implements ITranslateDetailProto
                     * @constructor
                     * @param {ai.talecast.webapp.proto.ITranslateDetailProto=} [properties] Properties to set
                     */
                    function TranslateDetailProto(properties) {
                        this.subtitleSegmented = [];
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * TranslateDetailProto id.
                     * @member {number|Long} id
                     * @memberof ai.talecast.webapp.proto.TranslateDetailProto
                     * @instance
                     */
                    TranslateDetailProto.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                    /**
                     * TranslateDetailProto volume.
                     * @member {number|null|undefined} volume
                     * @memberof ai.talecast.webapp.proto.TranslateDetailProto
                     * @instance
                     */
                    TranslateDetailProto.prototype.volume = null;

                    /**
                     * TranslateDetailProto speed.
                     * @member {number|null|undefined} speed
                     * @memberof ai.talecast.webapp.proto.TranslateDetailProto
                     * @instance
                     */
                    TranslateDetailProto.prototype.speed = null;

                    /**
                     * TranslateDetailProto sentence.
                     * @member {string|null|undefined} sentence
                     * @memberof ai.talecast.webapp.proto.TranslateDetailProto
                     * @instance
                     */
                    TranslateDetailProto.prototype.sentence = null;

                    /**
                     * TranslateDetailProto sentenceUrl.
                     * @member {string|null|undefined} sentenceUrl
                     * @memberof ai.talecast.webapp.proto.TranslateDetailProto
                     * @instance
                     */
                    TranslateDetailProto.prototype.sentenceUrl = null;

                    /**
                     * TranslateDetailProto speaker.
                     * @member {string} speaker
                     * @memberof ai.talecast.webapp.proto.TranslateDetailProto
                     * @instance
                     */
                    TranslateDetailProto.prototype.speaker = "";

                    /**
                     * TranslateDetailProto speakerId.
                     * @member {number} speakerId
                     * @memberof ai.talecast.webapp.proto.TranslateDetailProto
                     * @instance
                     */
                    TranslateDetailProto.prototype.speakerId = 0;

                    /**
                     * TranslateDetailProto from.
                     * @member {number|null|undefined} from
                     * @memberof ai.talecast.webapp.proto.TranslateDetailProto
                     * @instance
                     */
                    TranslateDetailProto.prototype.from = null;

                    /**
                     * TranslateDetailProto to.
                     * @member {number|null|undefined} to
                     * @memberof ai.talecast.webapp.proto.TranslateDetailProto
                     * @instance
                     */
                    TranslateDetailProto.prototype.to = null;

                    /**
                     * TranslateDetailProto subtitle.
                     * @member {ai.talecast.webapp.proto.ISubtitle|null|undefined} subtitle
                     * @memberof ai.talecast.webapp.proto.TranslateDetailProto
                     * @instance
                     */
                    TranslateDetailProto.prototype.subtitle = null;

                    /**
                     * TranslateDetailProto timeLineFrom.
                     * @member {number|null|undefined} timeLineFrom
                     * @memberof ai.talecast.webapp.proto.TranslateDetailProto
                     * @instance
                     */
                    TranslateDetailProto.prototype.timeLineFrom = null;

                    /**
                     * TranslateDetailProto timeLineTo.
                     * @member {number|null|undefined} timeLineTo
                     * @memberof ai.talecast.webapp.proto.TranslateDetailProto
                     * @instance
                     */
                    TranslateDetailProto.prototype.timeLineTo = null;

                    /**
                     * TranslateDetailProto isEdit.
                     * @member {boolean|null|undefined} isEdit
                     * @memberof ai.talecast.webapp.proto.TranslateDetailProto
                     * @instance
                     */
                    TranslateDetailProto.prototype.isEdit = null;

                    /**
                     * TranslateDetailProto generating.
                     * @member {boolean|null|undefined} generating
                     * @memberof ai.talecast.webapp.proto.TranslateDetailProto
                     * @instance
                     */
                    TranslateDetailProto.prototype.generating = null;

                    /**
                     * TranslateDetailProto type.
                     * @member {number|null|undefined} type
                     * @memberof ai.talecast.webapp.proto.TranslateDetailProto
                     * @instance
                     */
                    TranslateDetailProto.prototype.type = null;

                    /**
                     * TranslateDetailProto sentenceShow.
                     * @member {boolean|null|undefined} sentenceShow
                     * @memberof ai.talecast.webapp.proto.TranslateDetailProto
                     * @instance
                     */
                    TranslateDetailProto.prototype.sentenceShow = null;

                    /**
                     * TranslateDetailProto trackIndex.
                     * @member {number|null|undefined} trackIndex
                     * @memberof ai.talecast.webapp.proto.TranslateDetailProto
                     * @instance
                     */
                    TranslateDetailProto.prototype.trackIndex = null;

                    /**
                     * TranslateDetailProto mute.
                     * @member {boolean|null|undefined} mute
                     * @memberof ai.talecast.webapp.proto.TranslateDetailProto
                     * @instance
                     */
                    TranslateDetailProto.prototype.mute = null;

                    /**
                     * TranslateDetailProto translating.
                     * @member {boolean|null|undefined} translating
                     * @memberof ai.talecast.webapp.proto.TranslateDetailProto
                     * @instance
                     */
                    TranslateDetailProto.prototype.translating = null;

                    /**
                     * TranslateDetailProto subtitleSegmented.
                     * @member {Array.<ai.talecast.webapp.proto.ITempCaptionsDetail>} subtitleSegmented
                     * @memberof ai.talecast.webapp.proto.TranslateDetailProto
                     * @instance
                     */
                    TranslateDetailProto.prototype.subtitleSegmented = $util.emptyArray;

                    /**
                     * TranslateDetailProto subtitleEdit.
                     * @member {boolean|null|undefined} subtitleEdit
                     * @memberof ai.talecast.webapp.proto.TranslateDetailProto
                     * @instance
                     */
                    TranslateDetailProto.prototype.subtitleEdit = null;

                    /**
                     * TranslateDetailProto language.
                     * @member {string|null|undefined} language
                     * @memberof ai.talecast.webapp.proto.TranslateDetailProto
                     * @instance
                     */
                    TranslateDetailProto.prototype.language = null;

                    // OneOf field names bound to virtual getters and setters
                    let $oneOfFields;

                    // Virtual OneOf for proto3 optional field
                    Object.defineProperty(TranslateDetailProto.prototype, "_volume", {
                        get: $util.oneOfGetter($oneOfFields = ["volume"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    // Virtual OneOf for proto3 optional field
                    Object.defineProperty(TranslateDetailProto.prototype, "_speed", {
                        get: $util.oneOfGetter($oneOfFields = ["speed"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    // Virtual OneOf for proto3 optional field
                    Object.defineProperty(TranslateDetailProto.prototype, "_sentence", {
                        get: $util.oneOfGetter($oneOfFields = ["sentence"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    // Virtual OneOf for proto3 optional field
                    Object.defineProperty(TranslateDetailProto.prototype, "_sentenceUrl", {
                        get: $util.oneOfGetter($oneOfFields = ["sentenceUrl"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    // Virtual OneOf for proto3 optional field
                    Object.defineProperty(TranslateDetailProto.prototype, "_from", {
                        get: $util.oneOfGetter($oneOfFields = ["from"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    // Virtual OneOf for proto3 optional field
                    Object.defineProperty(TranslateDetailProto.prototype, "_to", {
                        get: $util.oneOfGetter($oneOfFields = ["to"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    // Virtual OneOf for proto3 optional field
                    Object.defineProperty(TranslateDetailProto.prototype, "_subtitle", {
                        get: $util.oneOfGetter($oneOfFields = ["subtitle"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    // Virtual OneOf for proto3 optional field
                    Object.defineProperty(TranslateDetailProto.prototype, "_timeLineFrom", {
                        get: $util.oneOfGetter($oneOfFields = ["timeLineFrom"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    // Virtual OneOf for proto3 optional field
                    Object.defineProperty(TranslateDetailProto.prototype, "_timeLineTo", {
                        get: $util.oneOfGetter($oneOfFields = ["timeLineTo"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    // Virtual OneOf for proto3 optional field
                    Object.defineProperty(TranslateDetailProto.prototype, "_isEdit", {
                        get: $util.oneOfGetter($oneOfFields = ["isEdit"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    // Virtual OneOf for proto3 optional field
                    Object.defineProperty(TranslateDetailProto.prototype, "_generating", {
                        get: $util.oneOfGetter($oneOfFields = ["generating"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    // Virtual OneOf for proto3 optional field
                    Object.defineProperty(TranslateDetailProto.prototype, "_type", {
                        get: $util.oneOfGetter($oneOfFields = ["type"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    // Virtual OneOf for proto3 optional field
                    Object.defineProperty(TranslateDetailProto.prototype, "_sentenceShow", {
                        get: $util.oneOfGetter($oneOfFields = ["sentenceShow"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    // Virtual OneOf for proto3 optional field
                    Object.defineProperty(TranslateDetailProto.prototype, "_trackIndex", {
                        get: $util.oneOfGetter($oneOfFields = ["trackIndex"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    // Virtual OneOf for proto3 optional field
                    Object.defineProperty(TranslateDetailProto.prototype, "_mute", {
                        get: $util.oneOfGetter($oneOfFields = ["mute"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    // Virtual OneOf for proto3 optional field
                    Object.defineProperty(TranslateDetailProto.prototype, "_translating", {
                        get: $util.oneOfGetter($oneOfFields = ["translating"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    // Virtual OneOf for proto3 optional field
                    Object.defineProperty(TranslateDetailProto.prototype, "_subtitleEdit", {
                        get: $util.oneOfGetter($oneOfFields = ["subtitleEdit"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    // Virtual OneOf for proto3 optional field
                    Object.defineProperty(TranslateDetailProto.prototype, "_language", {
                        get: $util.oneOfGetter($oneOfFields = ["language"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    /**
                     * Creates a new TranslateDetailProto instance using the specified properties.
                     * @function create
                     * @memberof ai.talecast.webapp.proto.TranslateDetailProto
                     * @static
                     * @param {ai.talecast.webapp.proto.ITranslateDetailProto=} [properties] Properties to set
                     * @returns {ai.talecast.webapp.proto.TranslateDetailProto} TranslateDetailProto instance
                     */
                    TranslateDetailProto.create = function create(properties) {
                        return new TranslateDetailProto(properties);
                    };

                    /**
                     * Encodes the specified TranslateDetailProto message. Does not implicitly {@link ai.talecast.webapp.proto.TranslateDetailProto.verify|verify} messages.
                     * @function encode
                     * @memberof ai.talecast.webapp.proto.TranslateDetailProto
                     * @static
                     * @param {ai.talecast.webapp.proto.ITranslateDetailProto} message TranslateDetailProto message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TranslateDetailProto.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.volume != null && Object.hasOwnProperty.call(message, "volume"))
                            writer.uint32(/* id 2, wireType 1 =*/17).double(message.volume);
                        if (message.speed != null && Object.hasOwnProperty.call(message, "speed"))
                            writer.uint32(/* id 3, wireType 1 =*/25).double(message.speed);
                        if (message.sentence != null && Object.hasOwnProperty.call(message, "sentence"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.sentence);
                        if (message.sentenceUrl != null && Object.hasOwnProperty.call(message, "sentenceUrl"))
                            writer.uint32(/* id 5, wireType 2 =*/42).string(message.sentenceUrl);
                        if (message.speaker != null && Object.hasOwnProperty.call(message, "speaker"))
                            writer.uint32(/* id 6, wireType 2 =*/50).string(message.speaker);
                        if (message.speakerId != null && Object.hasOwnProperty.call(message, "speakerId"))
                            writer.uint32(/* id 7, wireType 0 =*/56).int32(message.speakerId);
                        if (message.from != null && Object.hasOwnProperty.call(message, "from"))
                            writer.uint32(/* id 8, wireType 0 =*/64).int32(message.from);
                        if (message.to != null && Object.hasOwnProperty.call(message, "to"))
                            writer.uint32(/* id 9, wireType 0 =*/72).int32(message.to);
                        if (message.subtitle != null && Object.hasOwnProperty.call(message, "subtitle"))
                            $root.ai.talecast.webapp.proto.Subtitle.encode(message.subtitle, writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
                        if (message.timeLineFrom != null && Object.hasOwnProperty.call(message, "timeLineFrom"))
                            writer.uint32(/* id 11, wireType 0 =*/88).int32(message.timeLineFrom);
                        if (message.timeLineTo != null && Object.hasOwnProperty.call(message, "timeLineTo"))
                            writer.uint32(/* id 12, wireType 0 =*/96).int32(message.timeLineTo);
                        if (message.isEdit != null && Object.hasOwnProperty.call(message, "isEdit"))
                            writer.uint32(/* id 13, wireType 0 =*/104).bool(message.isEdit);
                        if (message.generating != null && Object.hasOwnProperty.call(message, "generating"))
                            writer.uint32(/* id 14, wireType 0 =*/112).bool(message.generating);
                        if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                            writer.uint32(/* id 15, wireType 0 =*/120).int32(message.type);
                        if (message.sentenceShow != null && Object.hasOwnProperty.call(message, "sentenceShow"))
                            writer.uint32(/* id 16, wireType 0 =*/128).bool(message.sentenceShow);
                        if (message.trackIndex != null && Object.hasOwnProperty.call(message, "trackIndex"))
                            writer.uint32(/* id 17, wireType 1 =*/137).double(message.trackIndex);
                        if (message.mute != null && Object.hasOwnProperty.call(message, "mute"))
                            writer.uint32(/* id 18, wireType 0 =*/144).bool(message.mute);
                        if (message.translating != null && Object.hasOwnProperty.call(message, "translating"))
                            writer.uint32(/* id 19, wireType 0 =*/152).bool(message.translating);
                        if (message.subtitleSegmented != null && message.subtitleSegmented.length)
                            for (let i = 0; i < message.subtitleSegmented.length; ++i)
                                $root.ai.talecast.webapp.proto.TempCaptionsDetail.encode(message.subtitleSegmented[i], writer.uint32(/* id 20, wireType 2 =*/162).fork()).ldelim();
                        if (message.subtitleEdit != null && Object.hasOwnProperty.call(message, "subtitleEdit"))
                            writer.uint32(/* id 21, wireType 0 =*/168).bool(message.subtitleEdit);
                        if (message.language != null && Object.hasOwnProperty.call(message, "language"))
                            writer.uint32(/* id 22, wireType 2 =*/178).string(message.language);
                        return writer;
                    };

                    /**
                     * Encodes the specified TranslateDetailProto message, length delimited. Does not implicitly {@link ai.talecast.webapp.proto.TranslateDetailProto.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof ai.talecast.webapp.proto.TranslateDetailProto
                     * @static
                     * @param {ai.talecast.webapp.proto.ITranslateDetailProto} message TranslateDetailProto message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TranslateDetailProto.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a TranslateDetailProto message from the specified reader or buffer.
                     * @function decode
                     * @memberof ai.talecast.webapp.proto.TranslateDetailProto
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {ai.talecast.webapp.proto.TranslateDetailProto} TranslateDetailProto
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TranslateDetailProto.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        const end = length === undefined ? reader.len : reader.pos + length, message = new $root.ai.talecast.webapp.proto.TranslateDetailProto();
                        while (reader.pos < end) {
                            const tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.id = reader.int64();
                                    break;
                                }
                            case 2: {
                                    message.volume = reader.double();
                                    break;
                                }
                            case 3: {
                                    message.speed = reader.double();
                                    break;
                                }
                            case 4: {
                                    message.sentence = reader.string();
                                    break;
                                }
                            case 5: {
                                    message.sentenceUrl = reader.string();
                                    break;
                                }
                            case 6: {
                                    message.speaker = reader.string();
                                    break;
                                }
                            case 7: {
                                    message.speakerId = reader.int32();
                                    break;
                                }
                            case 8: {
                                    message.from = reader.int32();
                                    break;
                                }
                            case 9: {
                                    message.to = reader.int32();
                                    break;
                                }
                            case 10: {
                                    message.subtitle = $root.ai.talecast.webapp.proto.Subtitle.decode(reader, reader.uint32());
                                    break;
                                }
                            case 11: {
                                    message.timeLineFrom = reader.int32();
                                    break;
                                }
                            case 12: {
                                    message.timeLineTo = reader.int32();
                                    break;
                                }
                            case 13: {
                                    message.isEdit = reader.bool();
                                    break;
                                }
                            case 14: {
                                    message.generating = reader.bool();
                                    break;
                                }
                            case 15: {
                                    message.type = reader.int32();
                                    break;
                                }
                            case 16: {
                                    message.sentenceShow = reader.bool();
                                    break;
                                }
                            case 17: {
                                    message.trackIndex = reader.double();
                                    break;
                                }
                            case 18: {
                                    message.mute = reader.bool();
                                    break;
                                }
                            case 19: {
                                    message.translating = reader.bool();
                                    break;
                                }
                            case 20: {
                                    if (!(message.subtitleSegmented && message.subtitleSegmented.length))
                                        message.subtitleSegmented = [];
                                    message.subtitleSegmented.push($root.ai.talecast.webapp.proto.TempCaptionsDetail.decode(reader, reader.uint32()));
                                    break;
                                }
                            case 21: {
                                    message.subtitleEdit = reader.bool();
                                    break;
                                }
                            case 22: {
                                    message.language = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a TranslateDetailProto message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof ai.talecast.webapp.proto.TranslateDetailProto
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {ai.talecast.webapp.proto.TranslateDetailProto} TranslateDetailProto
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TranslateDetailProto.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a TranslateDetailProto message.
                     * @function verify
                     * @memberof ai.talecast.webapp.proto.TranslateDetailProto
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    TranslateDetailProto.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        const properties = {};
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.volume != null && message.hasOwnProperty("volume")) {
                            properties._volume = 1;
                            if (typeof message.volume !== "number")
                                return "volume: number expected";
                        }
                        if (message.speed != null && message.hasOwnProperty("speed")) {
                            properties._speed = 1;
                            if (typeof message.speed !== "number")
                                return "speed: number expected";
                        }
                        if (message.sentence != null && message.hasOwnProperty("sentence")) {
                            properties._sentence = 1;
                            if (!$util.isString(message.sentence))
                                return "sentence: string expected";
                        }
                        if (message.sentenceUrl != null && message.hasOwnProperty("sentenceUrl")) {
                            properties._sentenceUrl = 1;
                            if (!$util.isString(message.sentenceUrl))
                                return "sentenceUrl: string expected";
                        }
                        if (message.speaker != null && message.hasOwnProperty("speaker"))
                            if (!$util.isString(message.speaker))
                                return "speaker: string expected";
                        if (message.speakerId != null && message.hasOwnProperty("speakerId"))
                            if (!$util.isInteger(message.speakerId))
                                return "speakerId: integer expected";
                        if (message.from != null && message.hasOwnProperty("from")) {
                            properties._from = 1;
                            if (!$util.isInteger(message.from))
                                return "from: integer expected";
                        }
                        if (message.to != null && message.hasOwnProperty("to")) {
                            properties._to = 1;
                            if (!$util.isInteger(message.to))
                                return "to: integer expected";
                        }
                        if (message.subtitle != null && message.hasOwnProperty("subtitle")) {
                            properties._subtitle = 1;
                            {
                                const error = $root.ai.talecast.webapp.proto.Subtitle.verify(message.subtitle);
                                if (error)
                                    return "subtitle." + error;
                            }
                        }
                        if (message.timeLineFrom != null && message.hasOwnProperty("timeLineFrom")) {
                            properties._timeLineFrom = 1;
                            if (!$util.isInteger(message.timeLineFrom))
                                return "timeLineFrom: integer expected";
                        }
                        if (message.timeLineTo != null && message.hasOwnProperty("timeLineTo")) {
                            properties._timeLineTo = 1;
                            if (!$util.isInteger(message.timeLineTo))
                                return "timeLineTo: integer expected";
                        }
                        if (message.isEdit != null && message.hasOwnProperty("isEdit")) {
                            properties._isEdit = 1;
                            if (typeof message.isEdit !== "boolean")
                                return "isEdit: boolean expected";
                        }
                        if (message.generating != null && message.hasOwnProperty("generating")) {
                            properties._generating = 1;
                            if (typeof message.generating !== "boolean")
                                return "generating: boolean expected";
                        }
                        if (message.type != null && message.hasOwnProperty("type")) {
                            properties._type = 1;
                            if (!$util.isInteger(message.type))
                                return "type: integer expected";
                        }
                        if (message.sentenceShow != null && message.hasOwnProperty("sentenceShow")) {
                            properties._sentenceShow = 1;
                            if (typeof message.sentenceShow !== "boolean")
                                return "sentenceShow: boolean expected";
                        }
                        if (message.trackIndex != null && message.hasOwnProperty("trackIndex")) {
                            properties._trackIndex = 1;
                            if (typeof message.trackIndex !== "number")
                                return "trackIndex: number expected";
                        }
                        if (message.mute != null && message.hasOwnProperty("mute")) {
                            properties._mute = 1;
                            if (typeof message.mute !== "boolean")
                                return "mute: boolean expected";
                        }
                        if (message.translating != null && message.hasOwnProperty("translating")) {
                            properties._translating = 1;
                            if (typeof message.translating !== "boolean")
                                return "translating: boolean expected";
                        }
                        if (message.subtitleSegmented != null && message.hasOwnProperty("subtitleSegmented")) {
                            if (!Array.isArray(message.subtitleSegmented))
                                return "subtitleSegmented: array expected";
                            for (let i = 0; i < message.subtitleSegmented.length; ++i) {
                                const error = $root.ai.talecast.webapp.proto.TempCaptionsDetail.verify(message.subtitleSegmented[i]);
                                if (error)
                                    return "subtitleSegmented." + error;
                            }
                        }
                        if (message.subtitleEdit != null && message.hasOwnProperty("subtitleEdit")) {
                            properties._subtitleEdit = 1;
                            if (typeof message.subtitleEdit !== "boolean")
                                return "subtitleEdit: boolean expected";
                        }
                        if (message.language != null && message.hasOwnProperty("language")) {
                            properties._language = 1;
                            if (!$util.isString(message.language))
                                return "language: string expected";
                        }
                        return null;
                    };

                    /**
                     * Creates a TranslateDetailProto message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof ai.talecast.webapp.proto.TranslateDetailProto
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {ai.talecast.webapp.proto.TranslateDetailProto} TranslateDetailProto
                     */
                    TranslateDetailProto.fromObject = function fromObject(object) {
                        if (object instanceof $root.ai.talecast.webapp.proto.TranslateDetailProto)
                            return object;
                        const message = new $root.ai.talecast.webapp.proto.TranslateDetailProto();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.volume != null)
                            message.volume = Number(object.volume);
                        if (object.speed != null)
                            message.speed = Number(object.speed);
                        if (object.sentence != null)
                            message.sentence = String(object.sentence);
                        if (object.sentenceUrl != null)
                            message.sentenceUrl = String(object.sentenceUrl);
                        if (object.speaker != null)
                            message.speaker = String(object.speaker);
                        if (object.speakerId != null)
                            message.speakerId = object.speakerId | 0;
                        if (object.from != null)
                            message.from = object.from | 0;
                        if (object.to != null)
                            message.to = object.to | 0;
                        if (object.subtitle != null) {
                            if (typeof object.subtitle !== "object")
                                throw TypeError(".ai.talecast.webapp.proto.TranslateDetailProto.subtitle: object expected");
                            message.subtitle = $root.ai.talecast.webapp.proto.Subtitle.fromObject(object.subtitle);
                        }
                        if (object.timeLineFrom != null)
                            message.timeLineFrom = object.timeLineFrom | 0;
                        if (object.timeLineTo != null)
                            message.timeLineTo = object.timeLineTo | 0;
                        if (object.isEdit != null)
                            message.isEdit = Boolean(object.isEdit);
                        if (object.generating != null)
                            message.generating = Boolean(object.generating);
                        if (object.type != null)
                            message.type = object.type | 0;
                        if (object.sentenceShow != null)
                            message.sentenceShow = Boolean(object.sentenceShow);
                        if (object.trackIndex != null)
                            message.trackIndex = Number(object.trackIndex);
                        if (object.mute != null)
                            message.mute = Boolean(object.mute);
                        if (object.translating != null)
                            message.translating = Boolean(object.translating);
                        if (object.subtitleSegmented) {
                            if (!Array.isArray(object.subtitleSegmented))
                                throw TypeError(".ai.talecast.webapp.proto.TranslateDetailProto.subtitleSegmented: array expected");
                            message.subtitleSegmented = [];
                            for (let i = 0; i < object.subtitleSegmented.length; ++i) {
                                if (typeof object.subtitleSegmented[i] !== "object")
                                    throw TypeError(".ai.talecast.webapp.proto.TranslateDetailProto.subtitleSegmented: object expected");
                                message.subtitleSegmented[i] = $root.ai.talecast.webapp.proto.TempCaptionsDetail.fromObject(object.subtitleSegmented[i]);
                            }
                        }
                        if (object.subtitleEdit != null)
                            message.subtitleEdit = Boolean(object.subtitleEdit);
                        if (object.language != null)
                            message.language = String(object.language);
                        return message;
                    };

                    /**
                     * Creates a plain object from a TranslateDetailProto message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof ai.talecast.webapp.proto.TranslateDetailProto
                     * @static
                     * @param {ai.talecast.webapp.proto.TranslateDetailProto} message TranslateDetailProto
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    TranslateDetailProto.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        const object = {};
                        if (options.arrays || options.defaults)
                            object.subtitleSegmented = [];
                        if (options.defaults) {
                            if ($util.Long) {
                                const long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            object.speaker = "";
                            object.speakerId = 0;
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.volume != null && message.hasOwnProperty("volume")) {
                            object.volume = options.json && !isFinite(message.volume) ? String(message.volume) : message.volume;
                            if (options.oneofs)
                                object._volume = "volume";
                        }
                        if (message.speed != null && message.hasOwnProperty("speed")) {
                            object.speed = options.json && !isFinite(message.speed) ? String(message.speed) : message.speed;
                            if (options.oneofs)
                                object._speed = "speed";
                        }
                        if (message.sentence != null && message.hasOwnProperty("sentence")) {
                            object.sentence = message.sentence;
                            if (options.oneofs)
                                object._sentence = "sentence";
                        }
                        if (message.sentenceUrl != null && message.hasOwnProperty("sentenceUrl")) {
                            object.sentenceUrl = message.sentenceUrl;
                            if (options.oneofs)
                                object._sentenceUrl = "sentenceUrl";
                        }
                        if (message.speaker != null && message.hasOwnProperty("speaker"))
                            object.speaker = message.speaker;
                        if (message.speakerId != null && message.hasOwnProperty("speakerId"))
                            object.speakerId = message.speakerId;
                        if (message.from != null && message.hasOwnProperty("from")) {
                            object.from = message.from;
                            if (options.oneofs)
                                object._from = "from";
                        }
                        if (message.to != null && message.hasOwnProperty("to")) {
                            object.to = message.to;
                            if (options.oneofs)
                                object._to = "to";
                        }
                        if (message.subtitle != null && message.hasOwnProperty("subtitle")) {
                            object.subtitle = $root.ai.talecast.webapp.proto.Subtitle.toObject(message.subtitle, options);
                            if (options.oneofs)
                                object._subtitle = "subtitle";
                        }
                        if (message.timeLineFrom != null && message.hasOwnProperty("timeLineFrom")) {
                            object.timeLineFrom = message.timeLineFrom;
                            if (options.oneofs)
                                object._timeLineFrom = "timeLineFrom";
                        }
                        if (message.timeLineTo != null && message.hasOwnProperty("timeLineTo")) {
                            object.timeLineTo = message.timeLineTo;
                            if (options.oneofs)
                                object._timeLineTo = "timeLineTo";
                        }
                        if (message.isEdit != null && message.hasOwnProperty("isEdit")) {
                            object.isEdit = message.isEdit;
                            if (options.oneofs)
                                object._isEdit = "isEdit";
                        }
                        if (message.generating != null && message.hasOwnProperty("generating")) {
                            object.generating = message.generating;
                            if (options.oneofs)
                                object._generating = "generating";
                        }
                        if (message.type != null && message.hasOwnProperty("type")) {
                            object.type = message.type;
                            if (options.oneofs)
                                object._type = "type";
                        }
                        if (message.sentenceShow != null && message.hasOwnProperty("sentenceShow")) {
                            object.sentenceShow = message.sentenceShow;
                            if (options.oneofs)
                                object._sentenceShow = "sentenceShow";
                        }
                        if (message.trackIndex != null && message.hasOwnProperty("trackIndex")) {
                            object.trackIndex = options.json && !isFinite(message.trackIndex) ? String(message.trackIndex) : message.trackIndex;
                            if (options.oneofs)
                                object._trackIndex = "trackIndex";
                        }
                        if (message.mute != null && message.hasOwnProperty("mute")) {
                            object.mute = message.mute;
                            if (options.oneofs)
                                object._mute = "mute";
                        }
                        if (message.translating != null && message.hasOwnProperty("translating")) {
                            object.translating = message.translating;
                            if (options.oneofs)
                                object._translating = "translating";
                        }
                        if (message.subtitleSegmented && message.subtitleSegmented.length) {
                            object.subtitleSegmented = [];
                            for (let j = 0; j < message.subtitleSegmented.length; ++j)
                                object.subtitleSegmented[j] = $root.ai.talecast.webapp.proto.TempCaptionsDetail.toObject(message.subtitleSegmented[j], options);
                        }
                        if (message.subtitleEdit != null && message.hasOwnProperty("subtitleEdit")) {
                            object.subtitleEdit = message.subtitleEdit;
                            if (options.oneofs)
                                object._subtitleEdit = "subtitleEdit";
                        }
                        if (message.language != null && message.hasOwnProperty("language")) {
                            object.language = message.language;
                            if (options.oneofs)
                                object._language = "language";
                        }
                        return object;
                    };

                    /**
                     * Converts this TranslateDetailProto to JSON.
                     * @function toJSON
                     * @memberof ai.talecast.webapp.proto.TranslateDetailProto
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    TranslateDetailProto.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for TranslateDetailProto
                     * @function getTypeUrl
                     * @memberof ai.talecast.webapp.proto.TranslateDetailProto
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    TranslateDetailProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/ai.talecast.webapp.proto.TranslateDetailProto";
                    };

                    return TranslateDetailProto;
                })();

                proto.Voice = (function() {

                    /**
                     * Properties of a Voice.
                     * @memberof ai.talecast.webapp.proto
                     * @interface IVoice
                     * @property {number|null} [number] Voice number
                     * @property {string|null} [name] Voice name
                     * @property {number|null} [type] Voice type
                     */

                    /**
                     * Constructs a new Voice.
                     * @memberof ai.talecast.webapp.proto
                     * @classdesc Represents a Voice.
                     * @implements IVoice
                     * @constructor
                     * @param {ai.talecast.webapp.proto.IVoice=} [properties] Properties to set
                     */
                    function Voice(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Voice number.
                     * @member {number} number
                     * @memberof ai.talecast.webapp.proto.Voice
                     * @instance
                     */
                    Voice.prototype.number = 0;

                    /**
                     * Voice name.
                     * @member {string} name
                     * @memberof ai.talecast.webapp.proto.Voice
                     * @instance
                     */
                    Voice.prototype.name = "";

                    /**
                     * Voice type.
                     * @member {number} type
                     * @memberof ai.talecast.webapp.proto.Voice
                     * @instance
                     */
                    Voice.prototype.type = 0;

                    /**
                     * Creates a new Voice instance using the specified properties.
                     * @function create
                     * @memberof ai.talecast.webapp.proto.Voice
                     * @static
                     * @param {ai.talecast.webapp.proto.IVoice=} [properties] Properties to set
                     * @returns {ai.talecast.webapp.proto.Voice} Voice instance
                     */
                    Voice.create = function create(properties) {
                        return new Voice(properties);
                    };

                    /**
                     * Encodes the specified Voice message. Does not implicitly {@link ai.talecast.webapp.proto.Voice.verify|verify} messages.
                     * @function encode
                     * @memberof ai.talecast.webapp.proto.Voice
                     * @static
                     * @param {ai.talecast.webapp.proto.IVoice} message Voice message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Voice.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.number != null && Object.hasOwnProperty.call(message, "number"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.number);
                        if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.name);
                        if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.type);
                        return writer;
                    };

                    /**
                     * Encodes the specified Voice message, length delimited. Does not implicitly {@link ai.talecast.webapp.proto.Voice.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof ai.talecast.webapp.proto.Voice
                     * @static
                     * @param {ai.talecast.webapp.proto.IVoice} message Voice message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Voice.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a Voice message from the specified reader or buffer.
                     * @function decode
                     * @memberof ai.talecast.webapp.proto.Voice
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {ai.talecast.webapp.proto.Voice} Voice
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Voice.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        const end = length === undefined ? reader.len : reader.pos + length, message = new $root.ai.talecast.webapp.proto.Voice();
                        while (reader.pos < end) {
                            const tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.number = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.name = reader.string();
                                    break;
                                }
                            case 4: {
                                    message.type = reader.int32();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a Voice message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof ai.talecast.webapp.proto.Voice
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {ai.talecast.webapp.proto.Voice} Voice
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Voice.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a Voice message.
                     * @function verify
                     * @memberof ai.talecast.webapp.proto.Voice
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Voice.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.number != null && message.hasOwnProperty("number"))
                            if (!$util.isInteger(message.number))
                                return "number: integer expected";
                        if (message.name != null && message.hasOwnProperty("name"))
                            if (!$util.isString(message.name))
                                return "name: string expected";
                        if (message.type != null && message.hasOwnProperty("type"))
                            if (!$util.isInteger(message.type))
                                return "type: integer expected";
                        return null;
                    };

                    /**
                     * Creates a Voice message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof ai.talecast.webapp.proto.Voice
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {ai.talecast.webapp.proto.Voice} Voice
                     */
                    Voice.fromObject = function fromObject(object) {
                        if (object instanceof $root.ai.talecast.webapp.proto.Voice)
                            return object;
                        const message = new $root.ai.talecast.webapp.proto.Voice();
                        if (object.number != null)
                            message.number = object.number | 0;
                        if (object.name != null)
                            message.name = String(object.name);
                        if (object.type != null)
                            message.type = object.type | 0;
                        return message;
                    };

                    /**
                     * Creates a plain object from a Voice message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof ai.talecast.webapp.proto.Voice
                     * @static
                     * @param {ai.talecast.webapp.proto.Voice} message Voice
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Voice.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        const object = {};
                        if (options.defaults) {
                            object.number = 0;
                            object.name = "";
                            object.type = 0;
                        }
                        if (message.number != null && message.hasOwnProperty("number"))
                            object.number = message.number;
                        if (message.name != null && message.hasOwnProperty("name"))
                            object.name = message.name;
                        if (message.type != null && message.hasOwnProperty("type"))
                            object.type = message.type;
                        return object;
                    };

                    /**
                     * Converts this Voice to JSON.
                     * @function toJSON
                     * @memberof ai.talecast.webapp.proto.Voice
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Voice.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for Voice
                     * @function getTypeUrl
                     * @memberof ai.talecast.webapp.proto.Voice
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    Voice.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/ai.talecast.webapp.proto.Voice";
                    };

                    return Voice;
                })();

                proto.VoiceMessageProto = (function() {

                    /**
                     * Properties of a VoiceMessageProto.
                     * @memberof ai.talecast.webapp.proto
                     * @interface IVoiceMessageProto
                     * @property {number|null} [number] VoiceMessageProto number
                     * @property {ai.talecast.webapp.proto.VoiceStatus|null} [status] VoiceMessageProto status
                     */

                    /**
                     * Constructs a new VoiceMessageProto.
                     * @memberof ai.talecast.webapp.proto
                     * @classdesc Represents a VoiceMessageProto.
                     * @implements IVoiceMessageProto
                     * @constructor
                     * @param {ai.talecast.webapp.proto.IVoiceMessageProto=} [properties] Properties to set
                     */
                    function VoiceMessageProto(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * VoiceMessageProto number.
                     * @member {number} number
                     * @memberof ai.talecast.webapp.proto.VoiceMessageProto
                     * @instance
                     */
                    VoiceMessageProto.prototype.number = 0;

                    /**
                     * VoiceMessageProto status.
                     * @member {ai.talecast.webapp.proto.VoiceStatus} status
                     * @memberof ai.talecast.webapp.proto.VoiceMessageProto
                     * @instance
                     */
                    VoiceMessageProto.prototype.status = 0;

                    /**
                     * Creates a new VoiceMessageProto instance using the specified properties.
                     * @function create
                     * @memberof ai.talecast.webapp.proto.VoiceMessageProto
                     * @static
                     * @param {ai.talecast.webapp.proto.IVoiceMessageProto=} [properties] Properties to set
                     * @returns {ai.talecast.webapp.proto.VoiceMessageProto} VoiceMessageProto instance
                     */
                    VoiceMessageProto.create = function create(properties) {
                        return new VoiceMessageProto(properties);
                    };

                    /**
                     * Encodes the specified VoiceMessageProto message. Does not implicitly {@link ai.talecast.webapp.proto.VoiceMessageProto.verify|verify} messages.
                     * @function encode
                     * @memberof ai.talecast.webapp.proto.VoiceMessageProto
                     * @static
                     * @param {ai.talecast.webapp.proto.IVoiceMessageProto} message VoiceMessageProto message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    VoiceMessageProto.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.number != null && Object.hasOwnProperty.call(message, "number"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.number);
                        if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.status);
                        return writer;
                    };

                    /**
                     * Encodes the specified VoiceMessageProto message, length delimited. Does not implicitly {@link ai.talecast.webapp.proto.VoiceMessageProto.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof ai.talecast.webapp.proto.VoiceMessageProto
                     * @static
                     * @param {ai.talecast.webapp.proto.IVoiceMessageProto} message VoiceMessageProto message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    VoiceMessageProto.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a VoiceMessageProto message from the specified reader or buffer.
                     * @function decode
                     * @memberof ai.talecast.webapp.proto.VoiceMessageProto
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {ai.talecast.webapp.proto.VoiceMessageProto} VoiceMessageProto
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    VoiceMessageProto.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        const end = length === undefined ? reader.len : reader.pos + length, message = new $root.ai.talecast.webapp.proto.VoiceMessageProto();
                        while (reader.pos < end) {
                            const tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.number = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.status = reader.int32();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a VoiceMessageProto message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof ai.talecast.webapp.proto.VoiceMessageProto
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {ai.talecast.webapp.proto.VoiceMessageProto} VoiceMessageProto
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    VoiceMessageProto.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a VoiceMessageProto message.
                     * @function verify
                     * @memberof ai.talecast.webapp.proto.VoiceMessageProto
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    VoiceMessageProto.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.number != null && message.hasOwnProperty("number"))
                            if (!$util.isInteger(message.number))
                                return "number: integer expected";
                        if (message.status != null && message.hasOwnProperty("status"))
                            switch (message.status) {
                            default:
                                return "status: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        return null;
                    };

                    /**
                     * Creates a VoiceMessageProto message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof ai.talecast.webapp.proto.VoiceMessageProto
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {ai.talecast.webapp.proto.VoiceMessageProto} VoiceMessageProto
                     */
                    VoiceMessageProto.fromObject = function fromObject(object) {
                        if (object instanceof $root.ai.talecast.webapp.proto.VoiceMessageProto)
                            return object;
                        const message = new $root.ai.talecast.webapp.proto.VoiceMessageProto();
                        if (object.number != null)
                            message.number = object.number | 0;
                        switch (object.status) {
                        default:
                            if (typeof object.status === "number") {
                                message.status = object.status;
                                break;
                            }
                            break;
                        case "VOICE_STATUS_PROCESSING":
                        case 0:
                            message.status = 0;
                            break;
                        case "VOICE_STATUS_SUCCESS":
                        case 1:
                            message.status = 1;
                            break;
                        case "VOICE_STATUS_FAILED":
                        case 2:
                            message.status = 2;
                            break;
                        }
                        return message;
                    };

                    /**
                     * Creates a plain object from a VoiceMessageProto message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof ai.talecast.webapp.proto.VoiceMessageProto
                     * @static
                     * @param {ai.talecast.webapp.proto.VoiceMessageProto} message VoiceMessageProto
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    VoiceMessageProto.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        const object = {};
                        if (options.defaults) {
                            object.number = 0;
                            object.status = options.enums === String ? "VOICE_STATUS_PROCESSING" : 0;
                        }
                        if (message.number != null && message.hasOwnProperty("number"))
                            object.number = message.number;
                        if (message.status != null && message.hasOwnProperty("status"))
                            object.status = options.enums === String ? $root.ai.talecast.webapp.proto.VoiceStatus[message.status] === undefined ? message.status : $root.ai.talecast.webapp.proto.VoiceStatus[message.status] : message.status;
                        return object;
                    };

                    /**
                     * Converts this VoiceMessageProto to JSON.
                     * @function toJSON
                     * @memberof ai.talecast.webapp.proto.VoiceMessageProto
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    VoiceMessageProto.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for VoiceMessageProto
                     * @function getTypeUrl
                     * @memberof ai.talecast.webapp.proto.VoiceMessageProto
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    VoiceMessageProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/ai.talecast.webapp.proto.VoiceMessageProto";
                    };

                    return VoiceMessageProto;
                })();

                proto.ExportProcessProto = (function() {

                    /**
                     * Properties of an ExportProcessProto.
                     * @memberof ai.talecast.webapp.proto
                     * @interface IExportProcessProto
                     * @property {number|Long|null} [projectId] ExportProcessProto projectId
                     * @property {number|null} [process] ExportProcessProto process
                     */

                    /**
                     * Constructs a new ExportProcessProto.
                     * @memberof ai.talecast.webapp.proto
                     * @classdesc Represents an ExportProcessProto.
                     * @implements IExportProcessProto
                     * @constructor
                     * @param {ai.talecast.webapp.proto.IExportProcessProto=} [properties] Properties to set
                     */
                    function ExportProcessProto(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * ExportProcessProto projectId.
                     * @member {number|Long} projectId
                     * @memberof ai.talecast.webapp.proto.ExportProcessProto
                     * @instance
                     */
                    ExportProcessProto.prototype.projectId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                    /**
                     * ExportProcessProto process.
                     * @member {number} process
                     * @memberof ai.talecast.webapp.proto.ExportProcessProto
                     * @instance
                     */
                    ExportProcessProto.prototype.process = 0;

                    /**
                     * Creates a new ExportProcessProto instance using the specified properties.
                     * @function create
                     * @memberof ai.talecast.webapp.proto.ExportProcessProto
                     * @static
                     * @param {ai.talecast.webapp.proto.IExportProcessProto=} [properties] Properties to set
                     * @returns {ai.talecast.webapp.proto.ExportProcessProto} ExportProcessProto instance
                     */
                    ExportProcessProto.create = function create(properties) {
                        return new ExportProcessProto(properties);
                    };

                    /**
                     * Encodes the specified ExportProcessProto message. Does not implicitly {@link ai.talecast.webapp.proto.ExportProcessProto.verify|verify} messages.
                     * @function encode
                     * @memberof ai.talecast.webapp.proto.ExportProcessProto
                     * @static
                     * @param {ai.talecast.webapp.proto.IExportProcessProto} message ExportProcessProto message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ExportProcessProto.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.projectId != null && Object.hasOwnProperty.call(message, "projectId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.projectId);
                        if (message.process != null && Object.hasOwnProperty.call(message, "process"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.process);
                        return writer;
                    };

                    /**
                     * Encodes the specified ExportProcessProto message, length delimited. Does not implicitly {@link ai.talecast.webapp.proto.ExportProcessProto.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof ai.talecast.webapp.proto.ExportProcessProto
                     * @static
                     * @param {ai.talecast.webapp.proto.IExportProcessProto} message ExportProcessProto message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ExportProcessProto.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes an ExportProcessProto message from the specified reader or buffer.
                     * @function decode
                     * @memberof ai.talecast.webapp.proto.ExportProcessProto
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {ai.talecast.webapp.proto.ExportProcessProto} ExportProcessProto
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ExportProcessProto.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        const end = length === undefined ? reader.len : reader.pos + length, message = new $root.ai.talecast.webapp.proto.ExportProcessProto();
                        while (reader.pos < end) {
                            const tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.projectId = reader.int64();
                                    break;
                                }
                            case 2: {
                                    message.process = reader.int32();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes an ExportProcessProto message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof ai.talecast.webapp.proto.ExportProcessProto
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {ai.talecast.webapp.proto.ExportProcessProto} ExportProcessProto
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ExportProcessProto.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies an ExportProcessProto message.
                     * @function verify
                     * @memberof ai.talecast.webapp.proto.ExportProcessProto
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ExportProcessProto.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.projectId != null && message.hasOwnProperty("projectId"))
                            if (!$util.isInteger(message.projectId) && !(message.projectId && $util.isInteger(message.projectId.low) && $util.isInteger(message.projectId.high)))
                                return "projectId: integer|Long expected";
                        if (message.process != null && message.hasOwnProperty("process"))
                            if (!$util.isInteger(message.process))
                                return "process: integer expected";
                        return null;
                    };

                    /**
                     * Creates an ExportProcessProto message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof ai.talecast.webapp.proto.ExportProcessProto
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {ai.talecast.webapp.proto.ExportProcessProto} ExportProcessProto
                     */
                    ExportProcessProto.fromObject = function fromObject(object) {
                        if (object instanceof $root.ai.talecast.webapp.proto.ExportProcessProto)
                            return object;
                        const message = new $root.ai.talecast.webapp.proto.ExportProcessProto();
                        if (object.projectId != null)
                            if ($util.Long)
                                (message.projectId = $util.Long.fromValue(object.projectId)).unsigned = false;
                            else if (typeof object.projectId === "string")
                                message.projectId = parseInt(object.projectId, 10);
                            else if (typeof object.projectId === "number")
                                message.projectId = object.projectId;
                            else if (typeof object.projectId === "object")
                                message.projectId = new $util.LongBits(object.projectId.low >>> 0, object.projectId.high >>> 0).toNumber();
                        if (object.process != null)
                            message.process = object.process | 0;
                        return message;
                    };

                    /**
                     * Creates a plain object from an ExportProcessProto message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof ai.talecast.webapp.proto.ExportProcessProto
                     * @static
                     * @param {ai.talecast.webapp.proto.ExportProcessProto} message ExportProcessProto
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ExportProcessProto.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        const object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                const long = new $util.Long(0, 0, false);
                                object.projectId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.projectId = options.longs === String ? "0" : 0;
                            object.process = 0;
                        }
                        if (message.projectId != null && message.hasOwnProperty("projectId"))
                            if (typeof message.projectId === "number")
                                object.projectId = options.longs === String ? String(message.projectId) : message.projectId;
                            else
                                object.projectId = options.longs === String ? $util.Long.prototype.toString.call(message.projectId) : options.longs === Number ? new $util.LongBits(message.projectId.low >>> 0, message.projectId.high >>> 0).toNumber() : message.projectId;
                        if (message.process != null && message.hasOwnProperty("process"))
                            object.process = message.process;
                        return object;
                    };

                    /**
                     * Converts this ExportProcessProto to JSON.
                     * @function toJSON
                     * @memberof ai.talecast.webapp.proto.ExportProcessProto
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ExportProcessProto.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for ExportProcessProto
                     * @function getTypeUrl
                     * @memberof ai.talecast.webapp.proto.ExportProcessProto
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    ExportProcessProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/ai.talecast.webapp.proto.ExportProcessProto";
                    };

                    return ExportProcessProto;
                })();

                proto.SentenceGeneratedProto = (function() {

                    /**
                     * Properties of a SentenceGeneratedProto.
                     * @memberof ai.talecast.webapp.proto
                     * @interface ISentenceGeneratedProto
                     * @property {number|Long|null} [projectId] SentenceGeneratedProto projectId
                     * @property {Array.<ai.talecast.webapp.proto.ISentenceProto>|null} [sentence] SentenceGeneratedProto sentence
                     */

                    /**
                     * Constructs a new SentenceGeneratedProto.
                     * @memberof ai.talecast.webapp.proto
                     * @classdesc Represents a SentenceGeneratedProto.
                     * @implements ISentenceGeneratedProto
                     * @constructor
                     * @param {ai.talecast.webapp.proto.ISentenceGeneratedProto=} [properties] Properties to set
                     */
                    function SentenceGeneratedProto(properties) {
                        this.sentence = [];
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * SentenceGeneratedProto projectId.
                     * @member {number|Long} projectId
                     * @memberof ai.talecast.webapp.proto.SentenceGeneratedProto
                     * @instance
                     */
                    SentenceGeneratedProto.prototype.projectId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                    /**
                     * SentenceGeneratedProto sentence.
                     * @member {Array.<ai.talecast.webapp.proto.ISentenceProto>} sentence
                     * @memberof ai.talecast.webapp.proto.SentenceGeneratedProto
                     * @instance
                     */
                    SentenceGeneratedProto.prototype.sentence = $util.emptyArray;

                    /**
                     * Creates a new SentenceGeneratedProto instance using the specified properties.
                     * @function create
                     * @memberof ai.talecast.webapp.proto.SentenceGeneratedProto
                     * @static
                     * @param {ai.talecast.webapp.proto.ISentenceGeneratedProto=} [properties] Properties to set
                     * @returns {ai.talecast.webapp.proto.SentenceGeneratedProto} SentenceGeneratedProto instance
                     */
                    SentenceGeneratedProto.create = function create(properties) {
                        return new SentenceGeneratedProto(properties);
                    };

                    /**
                     * Encodes the specified SentenceGeneratedProto message. Does not implicitly {@link ai.talecast.webapp.proto.SentenceGeneratedProto.verify|verify} messages.
                     * @function encode
                     * @memberof ai.talecast.webapp.proto.SentenceGeneratedProto
                     * @static
                     * @param {ai.talecast.webapp.proto.ISentenceGeneratedProto} message SentenceGeneratedProto message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    SentenceGeneratedProto.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.projectId != null && Object.hasOwnProperty.call(message, "projectId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.projectId);
                        if (message.sentence != null && message.sentence.length)
                            for (let i = 0; i < message.sentence.length; ++i)
                                $root.ai.talecast.webapp.proto.SentenceProto.encode(message.sentence[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        return writer;
                    };

                    /**
                     * Encodes the specified SentenceGeneratedProto message, length delimited. Does not implicitly {@link ai.talecast.webapp.proto.SentenceGeneratedProto.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof ai.talecast.webapp.proto.SentenceGeneratedProto
                     * @static
                     * @param {ai.talecast.webapp.proto.ISentenceGeneratedProto} message SentenceGeneratedProto message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    SentenceGeneratedProto.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a SentenceGeneratedProto message from the specified reader or buffer.
                     * @function decode
                     * @memberof ai.talecast.webapp.proto.SentenceGeneratedProto
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {ai.talecast.webapp.proto.SentenceGeneratedProto} SentenceGeneratedProto
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    SentenceGeneratedProto.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        const end = length === undefined ? reader.len : reader.pos + length, message = new $root.ai.talecast.webapp.proto.SentenceGeneratedProto();
                        while (reader.pos < end) {
                            const tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.projectId = reader.int64();
                                    break;
                                }
                            case 2: {
                                    if (!(message.sentence && message.sentence.length))
                                        message.sentence = [];
                                    message.sentence.push($root.ai.talecast.webapp.proto.SentenceProto.decode(reader, reader.uint32()));
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a SentenceGeneratedProto message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof ai.talecast.webapp.proto.SentenceGeneratedProto
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {ai.talecast.webapp.proto.SentenceGeneratedProto} SentenceGeneratedProto
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    SentenceGeneratedProto.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a SentenceGeneratedProto message.
                     * @function verify
                     * @memberof ai.talecast.webapp.proto.SentenceGeneratedProto
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    SentenceGeneratedProto.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.projectId != null && message.hasOwnProperty("projectId"))
                            if (!$util.isInteger(message.projectId) && !(message.projectId && $util.isInteger(message.projectId.low) && $util.isInteger(message.projectId.high)))
                                return "projectId: integer|Long expected";
                        if (message.sentence != null && message.hasOwnProperty("sentence")) {
                            if (!Array.isArray(message.sentence))
                                return "sentence: array expected";
                            for (let i = 0; i < message.sentence.length; ++i) {
                                const error = $root.ai.talecast.webapp.proto.SentenceProto.verify(message.sentence[i]);
                                if (error)
                                    return "sentence." + error;
                            }
                        }
                        return null;
                    };

                    /**
                     * Creates a SentenceGeneratedProto message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof ai.talecast.webapp.proto.SentenceGeneratedProto
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {ai.talecast.webapp.proto.SentenceGeneratedProto} SentenceGeneratedProto
                     */
                    SentenceGeneratedProto.fromObject = function fromObject(object) {
                        if (object instanceof $root.ai.talecast.webapp.proto.SentenceGeneratedProto)
                            return object;
                        const message = new $root.ai.talecast.webapp.proto.SentenceGeneratedProto();
                        if (object.projectId != null)
                            if ($util.Long)
                                (message.projectId = $util.Long.fromValue(object.projectId)).unsigned = false;
                            else if (typeof object.projectId === "string")
                                message.projectId = parseInt(object.projectId, 10);
                            else if (typeof object.projectId === "number")
                                message.projectId = object.projectId;
                            else if (typeof object.projectId === "object")
                                message.projectId = new $util.LongBits(object.projectId.low >>> 0, object.projectId.high >>> 0).toNumber();
                        if (object.sentence) {
                            if (!Array.isArray(object.sentence))
                                throw TypeError(".ai.talecast.webapp.proto.SentenceGeneratedProto.sentence: array expected");
                            message.sentence = [];
                            for (let i = 0; i < object.sentence.length; ++i) {
                                if (typeof object.sentence[i] !== "object")
                                    throw TypeError(".ai.talecast.webapp.proto.SentenceGeneratedProto.sentence: object expected");
                                message.sentence[i] = $root.ai.talecast.webapp.proto.SentenceProto.fromObject(object.sentence[i]);
                            }
                        }
                        return message;
                    };

                    /**
                     * Creates a plain object from a SentenceGeneratedProto message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof ai.talecast.webapp.proto.SentenceGeneratedProto
                     * @static
                     * @param {ai.talecast.webapp.proto.SentenceGeneratedProto} message SentenceGeneratedProto
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    SentenceGeneratedProto.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        const object = {};
                        if (options.arrays || options.defaults)
                            object.sentence = [];
                        if (options.defaults)
                            if ($util.Long) {
                                const long = new $util.Long(0, 0, false);
                                object.projectId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.projectId = options.longs === String ? "0" : 0;
                        if (message.projectId != null && message.hasOwnProperty("projectId"))
                            if (typeof message.projectId === "number")
                                object.projectId = options.longs === String ? String(message.projectId) : message.projectId;
                            else
                                object.projectId = options.longs === String ? $util.Long.prototype.toString.call(message.projectId) : options.longs === Number ? new $util.LongBits(message.projectId.low >>> 0, message.projectId.high >>> 0).toNumber() : message.projectId;
                        if (message.sentence && message.sentence.length) {
                            object.sentence = [];
                            for (let j = 0; j < message.sentence.length; ++j)
                                object.sentence[j] = $root.ai.talecast.webapp.proto.SentenceProto.toObject(message.sentence[j], options);
                        }
                        return object;
                    };

                    /**
                     * Converts this SentenceGeneratedProto to JSON.
                     * @function toJSON
                     * @memberof ai.talecast.webapp.proto.SentenceGeneratedProto
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    SentenceGeneratedProto.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for SentenceGeneratedProto
                     * @function getTypeUrl
                     * @memberof ai.talecast.webapp.proto.SentenceGeneratedProto
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    SentenceGeneratedProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/ai.talecast.webapp.proto.SentenceGeneratedProto";
                    };

                    return SentenceGeneratedProto;
                })();

                proto.ExportSuccessProto = (function() {

                    /**
                     * Properties of an ExportSuccessProto.
                     * @memberof ai.talecast.webapp.proto
                     * @interface IExportSuccessProto
                     * @property {number|Long|null} [projectId] ExportSuccessProto projectId
                     * @property {string|null} [url] ExportSuccessProto url
                     * @property {string|null} [projectName] ExportSuccessProto projectName
                     * @property {boolean|null} [isSuccess] ExportSuccessProto isSuccess
                     * @property {string|null} [subtitleUrl] ExportSuccessProto subtitleUrl
                     */

                    /**
                     * Constructs a new ExportSuccessProto.
                     * @memberof ai.talecast.webapp.proto
                     * @classdesc Represents an ExportSuccessProto.
                     * @implements IExportSuccessProto
                     * @constructor
                     * @param {ai.talecast.webapp.proto.IExportSuccessProto=} [properties] Properties to set
                     */
                    function ExportSuccessProto(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * ExportSuccessProto projectId.
                     * @member {number|Long} projectId
                     * @memberof ai.talecast.webapp.proto.ExportSuccessProto
                     * @instance
                     */
                    ExportSuccessProto.prototype.projectId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                    /**
                     * ExportSuccessProto url.
                     * @member {string} url
                     * @memberof ai.talecast.webapp.proto.ExportSuccessProto
                     * @instance
                     */
                    ExportSuccessProto.prototype.url = "";

                    /**
                     * ExportSuccessProto projectName.
                     * @member {string} projectName
                     * @memberof ai.talecast.webapp.proto.ExportSuccessProto
                     * @instance
                     */
                    ExportSuccessProto.prototype.projectName = "";

                    /**
                     * ExportSuccessProto isSuccess.
                     * @member {boolean} isSuccess
                     * @memberof ai.talecast.webapp.proto.ExportSuccessProto
                     * @instance
                     */
                    ExportSuccessProto.prototype.isSuccess = false;

                    /**
                     * ExportSuccessProto subtitleUrl.
                     * @member {string|null|undefined} subtitleUrl
                     * @memberof ai.talecast.webapp.proto.ExportSuccessProto
                     * @instance
                     */
                    ExportSuccessProto.prototype.subtitleUrl = null;

                    // OneOf field names bound to virtual getters and setters
                    let $oneOfFields;

                    // Virtual OneOf for proto3 optional field
                    Object.defineProperty(ExportSuccessProto.prototype, "_subtitleUrl", {
                        get: $util.oneOfGetter($oneOfFields = ["subtitleUrl"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    /**
                     * Creates a new ExportSuccessProto instance using the specified properties.
                     * @function create
                     * @memberof ai.talecast.webapp.proto.ExportSuccessProto
                     * @static
                     * @param {ai.talecast.webapp.proto.IExportSuccessProto=} [properties] Properties to set
                     * @returns {ai.talecast.webapp.proto.ExportSuccessProto} ExportSuccessProto instance
                     */
                    ExportSuccessProto.create = function create(properties) {
                        return new ExportSuccessProto(properties);
                    };

                    /**
                     * Encodes the specified ExportSuccessProto message. Does not implicitly {@link ai.talecast.webapp.proto.ExportSuccessProto.verify|verify} messages.
                     * @function encode
                     * @memberof ai.talecast.webapp.proto.ExportSuccessProto
                     * @static
                     * @param {ai.talecast.webapp.proto.IExportSuccessProto} message ExportSuccessProto message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ExportSuccessProto.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.projectId != null && Object.hasOwnProperty.call(message, "projectId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.projectId);
                        if (message.url != null && Object.hasOwnProperty.call(message, "url"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.url);
                        if (message.projectName != null && Object.hasOwnProperty.call(message, "projectName"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.projectName);
                        if (message.isSuccess != null && Object.hasOwnProperty.call(message, "isSuccess"))
                            writer.uint32(/* id 4, wireType 0 =*/32).bool(message.isSuccess);
                        if (message.subtitleUrl != null && Object.hasOwnProperty.call(message, "subtitleUrl"))
                            writer.uint32(/* id 5, wireType 2 =*/42).string(message.subtitleUrl);
                        return writer;
                    };

                    /**
                     * Encodes the specified ExportSuccessProto message, length delimited. Does not implicitly {@link ai.talecast.webapp.proto.ExportSuccessProto.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof ai.talecast.webapp.proto.ExportSuccessProto
                     * @static
                     * @param {ai.talecast.webapp.proto.IExportSuccessProto} message ExportSuccessProto message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ExportSuccessProto.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes an ExportSuccessProto message from the specified reader or buffer.
                     * @function decode
                     * @memberof ai.talecast.webapp.proto.ExportSuccessProto
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {ai.talecast.webapp.proto.ExportSuccessProto} ExportSuccessProto
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ExportSuccessProto.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        const end = length === undefined ? reader.len : reader.pos + length, message = new $root.ai.talecast.webapp.proto.ExportSuccessProto();
                        while (reader.pos < end) {
                            const tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.projectId = reader.int64();
                                    break;
                                }
                            case 2: {
                                    message.url = reader.string();
                                    break;
                                }
                            case 3: {
                                    message.projectName = reader.string();
                                    break;
                                }
                            case 4: {
                                    message.isSuccess = reader.bool();
                                    break;
                                }
                            case 5: {
                                    message.subtitleUrl = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes an ExportSuccessProto message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof ai.talecast.webapp.proto.ExportSuccessProto
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {ai.talecast.webapp.proto.ExportSuccessProto} ExportSuccessProto
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ExportSuccessProto.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies an ExportSuccessProto message.
                     * @function verify
                     * @memberof ai.talecast.webapp.proto.ExportSuccessProto
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ExportSuccessProto.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        const properties = {};
                        if (message.projectId != null && message.hasOwnProperty("projectId"))
                            if (!$util.isInteger(message.projectId) && !(message.projectId && $util.isInteger(message.projectId.low) && $util.isInteger(message.projectId.high)))
                                return "projectId: integer|Long expected";
                        if (message.url != null && message.hasOwnProperty("url"))
                            if (!$util.isString(message.url))
                                return "url: string expected";
                        if (message.projectName != null && message.hasOwnProperty("projectName"))
                            if (!$util.isString(message.projectName))
                                return "projectName: string expected";
                        if (message.isSuccess != null && message.hasOwnProperty("isSuccess"))
                            if (typeof message.isSuccess !== "boolean")
                                return "isSuccess: boolean expected";
                        if (message.subtitleUrl != null && message.hasOwnProperty("subtitleUrl")) {
                            properties._subtitleUrl = 1;
                            if (!$util.isString(message.subtitleUrl))
                                return "subtitleUrl: string expected";
                        }
                        return null;
                    };

                    /**
                     * Creates an ExportSuccessProto message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof ai.talecast.webapp.proto.ExportSuccessProto
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {ai.talecast.webapp.proto.ExportSuccessProto} ExportSuccessProto
                     */
                    ExportSuccessProto.fromObject = function fromObject(object) {
                        if (object instanceof $root.ai.talecast.webapp.proto.ExportSuccessProto)
                            return object;
                        const message = new $root.ai.talecast.webapp.proto.ExportSuccessProto();
                        if (object.projectId != null)
                            if ($util.Long)
                                (message.projectId = $util.Long.fromValue(object.projectId)).unsigned = false;
                            else if (typeof object.projectId === "string")
                                message.projectId = parseInt(object.projectId, 10);
                            else if (typeof object.projectId === "number")
                                message.projectId = object.projectId;
                            else if (typeof object.projectId === "object")
                                message.projectId = new $util.LongBits(object.projectId.low >>> 0, object.projectId.high >>> 0).toNumber();
                        if (object.url != null)
                            message.url = String(object.url);
                        if (object.projectName != null)
                            message.projectName = String(object.projectName);
                        if (object.isSuccess != null)
                            message.isSuccess = Boolean(object.isSuccess);
                        if (object.subtitleUrl != null)
                            message.subtitleUrl = String(object.subtitleUrl);
                        return message;
                    };

                    /**
                     * Creates a plain object from an ExportSuccessProto message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof ai.talecast.webapp.proto.ExportSuccessProto
                     * @static
                     * @param {ai.talecast.webapp.proto.ExportSuccessProto} message ExportSuccessProto
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ExportSuccessProto.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        const object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                const long = new $util.Long(0, 0, false);
                                object.projectId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.projectId = options.longs === String ? "0" : 0;
                            object.url = "";
                            object.projectName = "";
                            object.isSuccess = false;
                        }
                        if (message.projectId != null && message.hasOwnProperty("projectId"))
                            if (typeof message.projectId === "number")
                                object.projectId = options.longs === String ? String(message.projectId) : message.projectId;
                            else
                                object.projectId = options.longs === String ? $util.Long.prototype.toString.call(message.projectId) : options.longs === Number ? new $util.LongBits(message.projectId.low >>> 0, message.projectId.high >>> 0).toNumber() : message.projectId;
                        if (message.url != null && message.hasOwnProperty("url"))
                            object.url = message.url;
                        if (message.projectName != null && message.hasOwnProperty("projectName"))
                            object.projectName = message.projectName;
                        if (message.isSuccess != null && message.hasOwnProperty("isSuccess"))
                            object.isSuccess = message.isSuccess;
                        if (message.subtitleUrl != null && message.hasOwnProperty("subtitleUrl")) {
                            object.subtitleUrl = message.subtitleUrl;
                            if (options.oneofs)
                                object._subtitleUrl = "subtitleUrl";
                        }
                        return object;
                    };

                    /**
                     * Converts this ExportSuccessProto to JSON.
                     * @function toJSON
                     * @memberof ai.talecast.webapp.proto.ExportSuccessProto
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ExportSuccessProto.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for ExportSuccessProto
                     * @function getTypeUrl
                     * @memberof ai.talecast.webapp.proto.ExportSuccessProto
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    ExportSuccessProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/ai.talecast.webapp.proto.ExportSuccessProto";
                    };

                    return ExportSuccessProto;
                })();

                proto.SpriteInfoProto = (function() {

                    /**
                     * Properties of a SpriteInfoProto.
                     * @memberof ai.talecast.webapp.proto
                     * @interface ISpriteInfoProto
                     * @property {number|Long|null} [projectId] SpriteInfoProto projectId
                     * @property {string|null} [vttUrl] SpriteInfoProto vttUrl
                     * @property {number|null} [type] SpriteInfoProto type
                     */

                    /**
                     * Constructs a new SpriteInfoProto.
                     * @memberof ai.talecast.webapp.proto
                     * @classdesc Represents a SpriteInfoProto.
                     * @implements ISpriteInfoProto
                     * @constructor
                     * @param {ai.talecast.webapp.proto.ISpriteInfoProto=} [properties] Properties to set
                     */
                    function SpriteInfoProto(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * SpriteInfoProto projectId.
                     * @member {number|Long} projectId
                     * @memberof ai.talecast.webapp.proto.SpriteInfoProto
                     * @instance
                     */
                    SpriteInfoProto.prototype.projectId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                    /**
                     * SpriteInfoProto vttUrl.
                     * @member {string} vttUrl
                     * @memberof ai.talecast.webapp.proto.SpriteInfoProto
                     * @instance
                     */
                    SpriteInfoProto.prototype.vttUrl = "";

                    /**
                     * SpriteInfoProto type.
                     * @member {number} type
                     * @memberof ai.talecast.webapp.proto.SpriteInfoProto
                     * @instance
                     */
                    SpriteInfoProto.prototype.type = 0;

                    /**
                     * Creates a new SpriteInfoProto instance using the specified properties.
                     * @function create
                     * @memberof ai.talecast.webapp.proto.SpriteInfoProto
                     * @static
                     * @param {ai.talecast.webapp.proto.ISpriteInfoProto=} [properties] Properties to set
                     * @returns {ai.talecast.webapp.proto.SpriteInfoProto} SpriteInfoProto instance
                     */
                    SpriteInfoProto.create = function create(properties) {
                        return new SpriteInfoProto(properties);
                    };

                    /**
                     * Encodes the specified SpriteInfoProto message. Does not implicitly {@link ai.talecast.webapp.proto.SpriteInfoProto.verify|verify} messages.
                     * @function encode
                     * @memberof ai.talecast.webapp.proto.SpriteInfoProto
                     * @static
                     * @param {ai.talecast.webapp.proto.ISpriteInfoProto} message SpriteInfoProto message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    SpriteInfoProto.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.projectId != null && Object.hasOwnProperty.call(message, "projectId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.projectId);
                        if (message.vttUrl != null && Object.hasOwnProperty.call(message, "vttUrl"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.vttUrl);
                        if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.type);
                        return writer;
                    };

                    /**
                     * Encodes the specified SpriteInfoProto message, length delimited. Does not implicitly {@link ai.talecast.webapp.proto.SpriteInfoProto.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof ai.talecast.webapp.proto.SpriteInfoProto
                     * @static
                     * @param {ai.talecast.webapp.proto.ISpriteInfoProto} message SpriteInfoProto message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    SpriteInfoProto.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a SpriteInfoProto message from the specified reader or buffer.
                     * @function decode
                     * @memberof ai.talecast.webapp.proto.SpriteInfoProto
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {ai.talecast.webapp.proto.SpriteInfoProto} SpriteInfoProto
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    SpriteInfoProto.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        const end = length === undefined ? reader.len : reader.pos + length, message = new $root.ai.talecast.webapp.proto.SpriteInfoProto();
                        while (reader.pos < end) {
                            const tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.projectId = reader.int64();
                                    break;
                                }
                            case 2: {
                                    message.vttUrl = reader.string();
                                    break;
                                }
                            case 3: {
                                    message.type = reader.int32();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a SpriteInfoProto message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof ai.talecast.webapp.proto.SpriteInfoProto
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {ai.talecast.webapp.proto.SpriteInfoProto} SpriteInfoProto
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    SpriteInfoProto.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a SpriteInfoProto message.
                     * @function verify
                     * @memberof ai.talecast.webapp.proto.SpriteInfoProto
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    SpriteInfoProto.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.projectId != null && message.hasOwnProperty("projectId"))
                            if (!$util.isInteger(message.projectId) && !(message.projectId && $util.isInteger(message.projectId.low) && $util.isInteger(message.projectId.high)))
                                return "projectId: integer|Long expected";
                        if (message.vttUrl != null && message.hasOwnProperty("vttUrl"))
                            if (!$util.isString(message.vttUrl))
                                return "vttUrl: string expected";
                        if (message.type != null && message.hasOwnProperty("type"))
                            if (!$util.isInteger(message.type))
                                return "type: integer expected";
                        return null;
                    };

                    /**
                     * Creates a SpriteInfoProto message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof ai.talecast.webapp.proto.SpriteInfoProto
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {ai.talecast.webapp.proto.SpriteInfoProto} SpriteInfoProto
                     */
                    SpriteInfoProto.fromObject = function fromObject(object) {
                        if (object instanceof $root.ai.talecast.webapp.proto.SpriteInfoProto)
                            return object;
                        const message = new $root.ai.talecast.webapp.proto.SpriteInfoProto();
                        if (object.projectId != null)
                            if ($util.Long)
                                (message.projectId = $util.Long.fromValue(object.projectId)).unsigned = false;
                            else if (typeof object.projectId === "string")
                                message.projectId = parseInt(object.projectId, 10);
                            else if (typeof object.projectId === "number")
                                message.projectId = object.projectId;
                            else if (typeof object.projectId === "object")
                                message.projectId = new $util.LongBits(object.projectId.low >>> 0, object.projectId.high >>> 0).toNumber();
                        if (object.vttUrl != null)
                            message.vttUrl = String(object.vttUrl);
                        if (object.type != null)
                            message.type = object.type | 0;
                        return message;
                    };

                    /**
                     * Creates a plain object from a SpriteInfoProto message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof ai.talecast.webapp.proto.SpriteInfoProto
                     * @static
                     * @param {ai.talecast.webapp.proto.SpriteInfoProto} message SpriteInfoProto
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    SpriteInfoProto.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        const object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                const long = new $util.Long(0, 0, false);
                                object.projectId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.projectId = options.longs === String ? "0" : 0;
                            object.vttUrl = "";
                            object.type = 0;
                        }
                        if (message.projectId != null && message.hasOwnProperty("projectId"))
                            if (typeof message.projectId === "number")
                                object.projectId = options.longs === String ? String(message.projectId) : message.projectId;
                            else
                                object.projectId = options.longs === String ? $util.Long.prototype.toString.call(message.projectId) : options.longs === Number ? new $util.LongBits(message.projectId.low >>> 0, message.projectId.high >>> 0).toNumber() : message.projectId;
                        if (message.vttUrl != null && message.hasOwnProperty("vttUrl"))
                            object.vttUrl = message.vttUrl;
                        if (message.type != null && message.hasOwnProperty("type"))
                            object.type = message.type;
                        return object;
                    };

                    /**
                     * Converts this SpriteInfoProto to JSON.
                     * @function toJSON
                     * @memberof ai.talecast.webapp.proto.SpriteInfoProto
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    SpriteInfoProto.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for SpriteInfoProto
                     * @function getTypeUrl
                     * @memberof ai.talecast.webapp.proto.SpriteInfoProto
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    SpriteInfoProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/ai.talecast.webapp.proto.SpriteInfoProto";
                    };

                    return SpriteInfoProto;
                })();

                proto.ExportInterruptedProto = (function() {

                    /**
                     * Properties of an ExportInterruptedProto.
                     * @memberof ai.talecast.webapp.proto
                     * @interface IExportInterruptedProto
                     * @property {number|Long|null} [projectId] ExportInterruptedProto projectId
                     */

                    /**
                     * Constructs a new ExportInterruptedProto.
                     * @memberof ai.talecast.webapp.proto
                     * @classdesc Represents an ExportInterruptedProto.
                     * @implements IExportInterruptedProto
                     * @constructor
                     * @param {ai.talecast.webapp.proto.IExportInterruptedProto=} [properties] Properties to set
                     */
                    function ExportInterruptedProto(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * ExportInterruptedProto projectId.
                     * @member {number|Long} projectId
                     * @memberof ai.talecast.webapp.proto.ExportInterruptedProto
                     * @instance
                     */
                    ExportInterruptedProto.prototype.projectId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                    /**
                     * Creates a new ExportInterruptedProto instance using the specified properties.
                     * @function create
                     * @memberof ai.talecast.webapp.proto.ExportInterruptedProto
                     * @static
                     * @param {ai.talecast.webapp.proto.IExportInterruptedProto=} [properties] Properties to set
                     * @returns {ai.talecast.webapp.proto.ExportInterruptedProto} ExportInterruptedProto instance
                     */
                    ExportInterruptedProto.create = function create(properties) {
                        return new ExportInterruptedProto(properties);
                    };

                    /**
                     * Encodes the specified ExportInterruptedProto message. Does not implicitly {@link ai.talecast.webapp.proto.ExportInterruptedProto.verify|verify} messages.
                     * @function encode
                     * @memberof ai.talecast.webapp.proto.ExportInterruptedProto
                     * @static
                     * @param {ai.talecast.webapp.proto.IExportInterruptedProto} message ExportInterruptedProto message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ExportInterruptedProto.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.projectId != null && Object.hasOwnProperty.call(message, "projectId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.projectId);
                        return writer;
                    };

                    /**
                     * Encodes the specified ExportInterruptedProto message, length delimited. Does not implicitly {@link ai.talecast.webapp.proto.ExportInterruptedProto.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof ai.talecast.webapp.proto.ExportInterruptedProto
                     * @static
                     * @param {ai.talecast.webapp.proto.IExportInterruptedProto} message ExportInterruptedProto message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ExportInterruptedProto.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes an ExportInterruptedProto message from the specified reader or buffer.
                     * @function decode
                     * @memberof ai.talecast.webapp.proto.ExportInterruptedProto
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {ai.talecast.webapp.proto.ExportInterruptedProto} ExportInterruptedProto
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ExportInterruptedProto.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        const end = length === undefined ? reader.len : reader.pos + length, message = new $root.ai.talecast.webapp.proto.ExportInterruptedProto();
                        while (reader.pos < end) {
                            const tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.projectId = reader.int64();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes an ExportInterruptedProto message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof ai.talecast.webapp.proto.ExportInterruptedProto
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {ai.talecast.webapp.proto.ExportInterruptedProto} ExportInterruptedProto
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ExportInterruptedProto.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies an ExportInterruptedProto message.
                     * @function verify
                     * @memberof ai.talecast.webapp.proto.ExportInterruptedProto
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ExportInterruptedProto.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.projectId != null && message.hasOwnProperty("projectId"))
                            if (!$util.isInteger(message.projectId) && !(message.projectId && $util.isInteger(message.projectId.low) && $util.isInteger(message.projectId.high)))
                                return "projectId: integer|Long expected";
                        return null;
                    };

                    /**
                     * Creates an ExportInterruptedProto message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof ai.talecast.webapp.proto.ExportInterruptedProto
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {ai.talecast.webapp.proto.ExportInterruptedProto} ExportInterruptedProto
                     */
                    ExportInterruptedProto.fromObject = function fromObject(object) {
                        if (object instanceof $root.ai.talecast.webapp.proto.ExportInterruptedProto)
                            return object;
                        const message = new $root.ai.talecast.webapp.proto.ExportInterruptedProto();
                        if (object.projectId != null)
                            if ($util.Long)
                                (message.projectId = $util.Long.fromValue(object.projectId)).unsigned = false;
                            else if (typeof object.projectId === "string")
                                message.projectId = parseInt(object.projectId, 10);
                            else if (typeof object.projectId === "number")
                                message.projectId = object.projectId;
                            else if (typeof object.projectId === "object")
                                message.projectId = new $util.LongBits(object.projectId.low >>> 0, object.projectId.high >>> 0).toNumber();
                        return message;
                    };

                    /**
                     * Creates a plain object from an ExportInterruptedProto message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof ai.talecast.webapp.proto.ExportInterruptedProto
                     * @static
                     * @param {ai.talecast.webapp.proto.ExportInterruptedProto} message ExportInterruptedProto
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ExportInterruptedProto.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        const object = {};
                        if (options.defaults)
                            if ($util.Long) {
                                const long = new $util.Long(0, 0, false);
                                object.projectId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.projectId = options.longs === String ? "0" : 0;
                        if (message.projectId != null && message.hasOwnProperty("projectId"))
                            if (typeof message.projectId === "number")
                                object.projectId = options.longs === String ? String(message.projectId) : message.projectId;
                            else
                                object.projectId = options.longs === String ? $util.Long.prototype.toString.call(message.projectId) : options.longs === Number ? new $util.LongBits(message.projectId.low >>> 0, message.projectId.high >>> 0).toNumber() : message.projectId;
                        return object;
                    };

                    /**
                     * Converts this ExportInterruptedProto to JSON.
                     * @function toJSON
                     * @memberof ai.talecast.webapp.proto.ExportInterruptedProto
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ExportInterruptedProto.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for ExportInterruptedProto
                     * @function getTypeUrl
                     * @memberof ai.talecast.webapp.proto.ExportInterruptedProto
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    ExportInterruptedProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/ai.talecast.webapp.proto.ExportInterruptedProto";
                    };

                    return ExportInterruptedProto;
                })();

                proto.TranscodeSuccessProto = (function() {

                    /**
                     * Properties of a TranscodeSuccessProto.
                     * @memberof ai.talecast.webapp.proto
                     * @interface ITranscodeSuccessProto
                     * @property {number|Long|null} [projectId] TranscodeSuccessProto projectId
                     */

                    /**
                     * Constructs a new TranscodeSuccessProto.
                     * @memberof ai.talecast.webapp.proto
                     * @classdesc Represents a TranscodeSuccessProto.
                     * @implements ITranscodeSuccessProto
                     * @constructor
                     * @param {ai.talecast.webapp.proto.ITranscodeSuccessProto=} [properties] Properties to set
                     */
                    function TranscodeSuccessProto(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * TranscodeSuccessProto projectId.
                     * @member {number|Long} projectId
                     * @memberof ai.talecast.webapp.proto.TranscodeSuccessProto
                     * @instance
                     */
                    TranscodeSuccessProto.prototype.projectId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                    /**
                     * Creates a new TranscodeSuccessProto instance using the specified properties.
                     * @function create
                     * @memberof ai.talecast.webapp.proto.TranscodeSuccessProto
                     * @static
                     * @param {ai.talecast.webapp.proto.ITranscodeSuccessProto=} [properties] Properties to set
                     * @returns {ai.talecast.webapp.proto.TranscodeSuccessProto} TranscodeSuccessProto instance
                     */
                    TranscodeSuccessProto.create = function create(properties) {
                        return new TranscodeSuccessProto(properties);
                    };

                    /**
                     * Encodes the specified TranscodeSuccessProto message. Does not implicitly {@link ai.talecast.webapp.proto.TranscodeSuccessProto.verify|verify} messages.
                     * @function encode
                     * @memberof ai.talecast.webapp.proto.TranscodeSuccessProto
                     * @static
                     * @param {ai.talecast.webapp.proto.ITranscodeSuccessProto} message TranscodeSuccessProto message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TranscodeSuccessProto.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.projectId != null && Object.hasOwnProperty.call(message, "projectId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.projectId);
                        return writer;
                    };

                    /**
                     * Encodes the specified TranscodeSuccessProto message, length delimited. Does not implicitly {@link ai.talecast.webapp.proto.TranscodeSuccessProto.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof ai.talecast.webapp.proto.TranscodeSuccessProto
                     * @static
                     * @param {ai.talecast.webapp.proto.ITranscodeSuccessProto} message TranscodeSuccessProto message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TranscodeSuccessProto.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a TranscodeSuccessProto message from the specified reader or buffer.
                     * @function decode
                     * @memberof ai.talecast.webapp.proto.TranscodeSuccessProto
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {ai.talecast.webapp.proto.TranscodeSuccessProto} TranscodeSuccessProto
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TranscodeSuccessProto.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        const end = length === undefined ? reader.len : reader.pos + length, message = new $root.ai.talecast.webapp.proto.TranscodeSuccessProto();
                        while (reader.pos < end) {
                            const tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.projectId = reader.int64();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a TranscodeSuccessProto message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof ai.talecast.webapp.proto.TranscodeSuccessProto
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {ai.talecast.webapp.proto.TranscodeSuccessProto} TranscodeSuccessProto
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TranscodeSuccessProto.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a TranscodeSuccessProto message.
                     * @function verify
                     * @memberof ai.talecast.webapp.proto.TranscodeSuccessProto
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    TranscodeSuccessProto.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.projectId != null && message.hasOwnProperty("projectId"))
                            if (!$util.isInteger(message.projectId) && !(message.projectId && $util.isInteger(message.projectId.low) && $util.isInteger(message.projectId.high)))
                                return "projectId: integer|Long expected";
                        return null;
                    };

                    /**
                     * Creates a TranscodeSuccessProto message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof ai.talecast.webapp.proto.TranscodeSuccessProto
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {ai.talecast.webapp.proto.TranscodeSuccessProto} TranscodeSuccessProto
                     */
                    TranscodeSuccessProto.fromObject = function fromObject(object) {
                        if (object instanceof $root.ai.talecast.webapp.proto.TranscodeSuccessProto)
                            return object;
                        const message = new $root.ai.talecast.webapp.proto.TranscodeSuccessProto();
                        if (object.projectId != null)
                            if ($util.Long)
                                (message.projectId = $util.Long.fromValue(object.projectId)).unsigned = false;
                            else if (typeof object.projectId === "string")
                                message.projectId = parseInt(object.projectId, 10);
                            else if (typeof object.projectId === "number")
                                message.projectId = object.projectId;
                            else if (typeof object.projectId === "object")
                                message.projectId = new $util.LongBits(object.projectId.low >>> 0, object.projectId.high >>> 0).toNumber();
                        return message;
                    };

                    /**
                     * Creates a plain object from a TranscodeSuccessProto message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof ai.talecast.webapp.proto.TranscodeSuccessProto
                     * @static
                     * @param {ai.talecast.webapp.proto.TranscodeSuccessProto} message TranscodeSuccessProto
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    TranscodeSuccessProto.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        const object = {};
                        if (options.defaults)
                            if ($util.Long) {
                                const long = new $util.Long(0, 0, false);
                                object.projectId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.projectId = options.longs === String ? "0" : 0;
                        if (message.projectId != null && message.hasOwnProperty("projectId"))
                            if (typeof message.projectId === "number")
                                object.projectId = options.longs === String ? String(message.projectId) : message.projectId;
                            else
                                object.projectId = options.longs === String ? $util.Long.prototype.toString.call(message.projectId) : options.longs === Number ? new $util.LongBits(message.projectId.low >>> 0, message.projectId.high >>> 0).toNumber() : message.projectId;
                        return object;
                    };

                    /**
                     * Converts this TranscodeSuccessProto to JSON.
                     * @function toJSON
                     * @memberof ai.talecast.webapp.proto.TranscodeSuccessProto
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    TranscodeSuccessProto.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for TranscodeSuccessProto
                     * @function getTypeUrl
                     * @memberof ai.talecast.webapp.proto.TranscodeSuccessProto
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    TranscodeSuccessProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/ai.talecast.webapp.proto.TranscodeSuccessProto";
                    };

                    return TranscodeSuccessProto;
                })();

                proto.PreDownloadProto = (function() {

                    /**
                     * Properties of a PreDownloadProto.
                     * @memberof ai.talecast.webapp.proto
                     * @interface IPreDownloadProto
                     * @property {number|Long|null} [projectId] PreDownloadProto projectId
                     * @property {string|null} [downloadUrl] PreDownloadProto downloadUrl
                     * @property {boolean|null} [isSuccess] PreDownloadProto isSuccess
                     */

                    /**
                     * Constructs a new PreDownloadProto.
                     * @memberof ai.talecast.webapp.proto
                     * @classdesc Represents a PreDownloadProto.
                     * @implements IPreDownloadProto
                     * @constructor
                     * @param {ai.talecast.webapp.proto.IPreDownloadProto=} [properties] Properties to set
                     */
                    function PreDownloadProto(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * PreDownloadProto projectId.
                     * @member {number|Long} projectId
                     * @memberof ai.talecast.webapp.proto.PreDownloadProto
                     * @instance
                     */
                    PreDownloadProto.prototype.projectId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                    /**
                     * PreDownloadProto downloadUrl.
                     * @member {string} downloadUrl
                     * @memberof ai.talecast.webapp.proto.PreDownloadProto
                     * @instance
                     */
                    PreDownloadProto.prototype.downloadUrl = "";

                    /**
                     * PreDownloadProto isSuccess.
                     * @member {boolean} isSuccess
                     * @memberof ai.talecast.webapp.proto.PreDownloadProto
                     * @instance
                     */
                    PreDownloadProto.prototype.isSuccess = false;

                    /**
                     * Creates a new PreDownloadProto instance using the specified properties.
                     * @function create
                     * @memberof ai.talecast.webapp.proto.PreDownloadProto
                     * @static
                     * @param {ai.talecast.webapp.proto.IPreDownloadProto=} [properties] Properties to set
                     * @returns {ai.talecast.webapp.proto.PreDownloadProto} PreDownloadProto instance
                     */
                    PreDownloadProto.create = function create(properties) {
                        return new PreDownloadProto(properties);
                    };

                    /**
                     * Encodes the specified PreDownloadProto message. Does not implicitly {@link ai.talecast.webapp.proto.PreDownloadProto.verify|verify} messages.
                     * @function encode
                     * @memberof ai.talecast.webapp.proto.PreDownloadProto
                     * @static
                     * @param {ai.talecast.webapp.proto.IPreDownloadProto} message PreDownloadProto message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PreDownloadProto.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.projectId != null && Object.hasOwnProperty.call(message, "projectId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.projectId);
                        if (message.downloadUrl != null && Object.hasOwnProperty.call(message, "downloadUrl"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.downloadUrl);
                        if (message.isSuccess != null && Object.hasOwnProperty.call(message, "isSuccess"))
                            writer.uint32(/* id 3, wireType 0 =*/24).bool(message.isSuccess);
                        return writer;
                    };

                    /**
                     * Encodes the specified PreDownloadProto message, length delimited. Does not implicitly {@link ai.talecast.webapp.proto.PreDownloadProto.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof ai.talecast.webapp.proto.PreDownloadProto
                     * @static
                     * @param {ai.talecast.webapp.proto.IPreDownloadProto} message PreDownloadProto message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PreDownloadProto.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a PreDownloadProto message from the specified reader or buffer.
                     * @function decode
                     * @memberof ai.talecast.webapp.proto.PreDownloadProto
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {ai.talecast.webapp.proto.PreDownloadProto} PreDownloadProto
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PreDownloadProto.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        const end = length === undefined ? reader.len : reader.pos + length, message = new $root.ai.talecast.webapp.proto.PreDownloadProto();
                        while (reader.pos < end) {
                            const tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.projectId = reader.int64();
                                    break;
                                }
                            case 2: {
                                    message.downloadUrl = reader.string();
                                    break;
                                }
                            case 3: {
                                    message.isSuccess = reader.bool();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a PreDownloadProto message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof ai.talecast.webapp.proto.PreDownloadProto
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {ai.talecast.webapp.proto.PreDownloadProto} PreDownloadProto
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PreDownloadProto.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a PreDownloadProto message.
                     * @function verify
                     * @memberof ai.talecast.webapp.proto.PreDownloadProto
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    PreDownloadProto.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.projectId != null && message.hasOwnProperty("projectId"))
                            if (!$util.isInteger(message.projectId) && !(message.projectId && $util.isInteger(message.projectId.low) && $util.isInteger(message.projectId.high)))
                                return "projectId: integer|Long expected";
                        if (message.downloadUrl != null && message.hasOwnProperty("downloadUrl"))
                            if (!$util.isString(message.downloadUrl))
                                return "downloadUrl: string expected";
                        if (message.isSuccess != null && message.hasOwnProperty("isSuccess"))
                            if (typeof message.isSuccess !== "boolean")
                                return "isSuccess: boolean expected";
                        return null;
                    };

                    /**
                     * Creates a PreDownloadProto message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof ai.talecast.webapp.proto.PreDownloadProto
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {ai.talecast.webapp.proto.PreDownloadProto} PreDownloadProto
                     */
                    PreDownloadProto.fromObject = function fromObject(object) {
                        if (object instanceof $root.ai.talecast.webapp.proto.PreDownloadProto)
                            return object;
                        const message = new $root.ai.talecast.webapp.proto.PreDownloadProto();
                        if (object.projectId != null)
                            if ($util.Long)
                                (message.projectId = $util.Long.fromValue(object.projectId)).unsigned = false;
                            else if (typeof object.projectId === "string")
                                message.projectId = parseInt(object.projectId, 10);
                            else if (typeof object.projectId === "number")
                                message.projectId = object.projectId;
                            else if (typeof object.projectId === "object")
                                message.projectId = new $util.LongBits(object.projectId.low >>> 0, object.projectId.high >>> 0).toNumber();
                        if (object.downloadUrl != null)
                            message.downloadUrl = String(object.downloadUrl);
                        if (object.isSuccess != null)
                            message.isSuccess = Boolean(object.isSuccess);
                        return message;
                    };

                    /**
                     * Creates a plain object from a PreDownloadProto message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof ai.talecast.webapp.proto.PreDownloadProto
                     * @static
                     * @param {ai.talecast.webapp.proto.PreDownloadProto} message PreDownloadProto
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    PreDownloadProto.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        const object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                const long = new $util.Long(0, 0, false);
                                object.projectId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.projectId = options.longs === String ? "0" : 0;
                            object.downloadUrl = "";
                            object.isSuccess = false;
                        }
                        if (message.projectId != null && message.hasOwnProperty("projectId"))
                            if (typeof message.projectId === "number")
                                object.projectId = options.longs === String ? String(message.projectId) : message.projectId;
                            else
                                object.projectId = options.longs === String ? $util.Long.prototype.toString.call(message.projectId) : options.longs === Number ? new $util.LongBits(message.projectId.low >>> 0, message.projectId.high >>> 0).toNumber() : message.projectId;
                        if (message.downloadUrl != null && message.hasOwnProperty("downloadUrl"))
                            object.downloadUrl = message.downloadUrl;
                        if (message.isSuccess != null && message.hasOwnProperty("isSuccess"))
                            object.isSuccess = message.isSuccess;
                        return object;
                    };

                    /**
                     * Converts this PreDownloadProto to JSON.
                     * @function toJSON
                     * @memberof ai.talecast.webapp.proto.PreDownloadProto
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    PreDownloadProto.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for PreDownloadProto
                     * @function getTypeUrl
                     * @memberof ai.talecast.webapp.proto.PreDownloadProto
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    PreDownloadProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/ai.talecast.webapp.proto.PreDownloadProto";
                    };

                    return PreDownloadProto;
                })();

                proto.TranslateProto = (function() {

                    /**
                     * Properties of a TranslateProto.
                     * @memberof ai.talecast.webapp.proto
                     * @interface ITranslateProto
                     * @property {number|Long|null} [projectId] TranslateProto projectId
                     * @property {boolean|null} [isSuccess] TranslateProto isSuccess
                     * @property {Array.<ai.talecast.webapp.proto.ITranslateSentenceProto>|null} [details] TranslateProto details
                     * @property {string|null} [id] TranslateProto id
                     * @property {string|null} [oriUrl] TranslateProto oriUrl
                     * @property {number|null} [zIndex] TranslateProto zIndex
                     * @property {number|null} [type] TranslateProto type
                     * @property {string|null} [oriLanguage] TranslateProto oriLanguage
                     * @property {string|null} [targetLanguage] TranslateProto targetLanguage
                     * @property {string|null} [translationLanguage] TranslateProto translationLanguage
                     * @property {Array.<string>|null} [translatedLanguages] TranslateProto translatedLanguages
                     */

                    /**
                     * Constructs a new TranslateProto.
                     * @memberof ai.talecast.webapp.proto
                     * @classdesc Represents a TranslateProto.
                     * @implements ITranslateProto
                     * @constructor
                     * @param {ai.talecast.webapp.proto.ITranslateProto=} [properties] Properties to set
                     */
                    function TranslateProto(properties) {
                        this.details = [];
                        this.translatedLanguages = [];
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * TranslateProto projectId.
                     * @member {number|Long} projectId
                     * @memberof ai.talecast.webapp.proto.TranslateProto
                     * @instance
                     */
                    TranslateProto.prototype.projectId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                    /**
                     * TranslateProto isSuccess.
                     * @member {boolean} isSuccess
                     * @memberof ai.talecast.webapp.proto.TranslateProto
                     * @instance
                     */
                    TranslateProto.prototype.isSuccess = false;

                    /**
                     * TranslateProto details.
                     * @member {Array.<ai.talecast.webapp.proto.ITranslateSentenceProto>} details
                     * @memberof ai.talecast.webapp.proto.TranslateProto
                     * @instance
                     */
                    TranslateProto.prototype.details = $util.emptyArray;

                    /**
                     * TranslateProto id.
                     * @member {string} id
                     * @memberof ai.talecast.webapp.proto.TranslateProto
                     * @instance
                     */
                    TranslateProto.prototype.id = "";

                    /**
                     * TranslateProto oriUrl.
                     * @member {string} oriUrl
                     * @memberof ai.talecast.webapp.proto.TranslateProto
                     * @instance
                     */
                    TranslateProto.prototype.oriUrl = "";

                    /**
                     * TranslateProto zIndex.
                     * @member {number|null|undefined} zIndex
                     * @memberof ai.talecast.webapp.proto.TranslateProto
                     * @instance
                     */
                    TranslateProto.prototype.zIndex = null;

                    /**
                     * TranslateProto type.
                     * @member {number|null|undefined} type
                     * @memberof ai.talecast.webapp.proto.TranslateProto
                     * @instance
                     */
                    TranslateProto.prototype.type = null;

                    /**
                     * TranslateProto oriLanguage.
                     * @member {string} oriLanguage
                     * @memberof ai.talecast.webapp.proto.TranslateProto
                     * @instance
                     */
                    TranslateProto.prototype.oriLanguage = "";

                    /**
                     * TranslateProto targetLanguage.
                     * @member {string} targetLanguage
                     * @memberof ai.talecast.webapp.proto.TranslateProto
                     * @instance
                     */
                    TranslateProto.prototype.targetLanguage = "";

                    /**
                     * TranslateProto translationLanguage.
                     * @member {string} translationLanguage
                     * @memberof ai.talecast.webapp.proto.TranslateProto
                     * @instance
                     */
                    TranslateProto.prototype.translationLanguage = "";

                    /**
                     * TranslateProto translatedLanguages.
                     * @member {Array.<string>} translatedLanguages
                     * @memberof ai.talecast.webapp.proto.TranslateProto
                     * @instance
                     */
                    TranslateProto.prototype.translatedLanguages = $util.emptyArray;

                    // OneOf field names bound to virtual getters and setters
                    let $oneOfFields;

                    // Virtual OneOf for proto3 optional field
                    Object.defineProperty(TranslateProto.prototype, "_zIndex", {
                        get: $util.oneOfGetter($oneOfFields = ["zIndex"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    // Virtual OneOf for proto3 optional field
                    Object.defineProperty(TranslateProto.prototype, "_type", {
                        get: $util.oneOfGetter($oneOfFields = ["type"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    /**
                     * Creates a new TranslateProto instance using the specified properties.
                     * @function create
                     * @memberof ai.talecast.webapp.proto.TranslateProto
                     * @static
                     * @param {ai.talecast.webapp.proto.ITranslateProto=} [properties] Properties to set
                     * @returns {ai.talecast.webapp.proto.TranslateProto} TranslateProto instance
                     */
                    TranslateProto.create = function create(properties) {
                        return new TranslateProto(properties);
                    };

                    /**
                     * Encodes the specified TranslateProto message. Does not implicitly {@link ai.talecast.webapp.proto.TranslateProto.verify|verify} messages.
                     * @function encode
                     * @memberof ai.talecast.webapp.proto.TranslateProto
                     * @static
                     * @param {ai.talecast.webapp.proto.ITranslateProto} message TranslateProto message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TranslateProto.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.projectId != null && Object.hasOwnProperty.call(message, "projectId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.projectId);
                        if (message.isSuccess != null && Object.hasOwnProperty.call(message, "isSuccess"))
                            writer.uint32(/* id 2, wireType 0 =*/16).bool(message.isSuccess);
                        if (message.details != null && message.details.length)
                            for (let i = 0; i < message.details.length; ++i)
                                $root.ai.talecast.webapp.proto.TranslateSentenceProto.encode(message.details[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.id);
                        if (message.oriUrl != null && Object.hasOwnProperty.call(message, "oriUrl"))
                            writer.uint32(/* id 5, wireType 2 =*/42).string(message.oriUrl);
                        if (message.zIndex != null && Object.hasOwnProperty.call(message, "zIndex"))
                            writer.uint32(/* id 6, wireType 0 =*/48).int32(message.zIndex);
                        if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                            writer.uint32(/* id 7, wireType 0 =*/56).int32(message.type);
                        if (message.oriLanguage != null && Object.hasOwnProperty.call(message, "oriLanguage"))
                            writer.uint32(/* id 8, wireType 2 =*/66).string(message.oriLanguage);
                        if (message.targetLanguage != null && Object.hasOwnProperty.call(message, "targetLanguage"))
                            writer.uint32(/* id 9, wireType 2 =*/74).string(message.targetLanguage);
                        if (message.translationLanguage != null && Object.hasOwnProperty.call(message, "translationLanguage"))
                            writer.uint32(/* id 10, wireType 2 =*/82).string(message.translationLanguage);
                        if (message.translatedLanguages != null && message.translatedLanguages.length)
                            for (let i = 0; i < message.translatedLanguages.length; ++i)
                                writer.uint32(/* id 11, wireType 2 =*/90).string(message.translatedLanguages[i]);
                        return writer;
                    };

                    /**
                     * Encodes the specified TranslateProto message, length delimited. Does not implicitly {@link ai.talecast.webapp.proto.TranslateProto.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof ai.talecast.webapp.proto.TranslateProto
                     * @static
                     * @param {ai.talecast.webapp.proto.ITranslateProto} message TranslateProto message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TranslateProto.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a TranslateProto message from the specified reader or buffer.
                     * @function decode
                     * @memberof ai.talecast.webapp.proto.TranslateProto
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {ai.talecast.webapp.proto.TranslateProto} TranslateProto
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TranslateProto.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        const end = length === undefined ? reader.len : reader.pos + length, message = new $root.ai.talecast.webapp.proto.TranslateProto();
                        while (reader.pos < end) {
                            const tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.projectId = reader.int64();
                                    break;
                                }
                            case 2: {
                                    message.isSuccess = reader.bool();
                                    break;
                                }
                            case 3: {
                                    if (!(message.details && message.details.length))
                                        message.details = [];
                                    message.details.push($root.ai.talecast.webapp.proto.TranslateSentenceProto.decode(reader, reader.uint32()));
                                    break;
                                }
                            case 4: {
                                    message.id = reader.string();
                                    break;
                                }
                            case 5: {
                                    message.oriUrl = reader.string();
                                    break;
                                }
                            case 6: {
                                    message.zIndex = reader.int32();
                                    break;
                                }
                            case 7: {
                                    message.type = reader.int32();
                                    break;
                                }
                            case 8: {
                                    message.oriLanguage = reader.string();
                                    break;
                                }
                            case 9: {
                                    message.targetLanguage = reader.string();
                                    break;
                                }
                            case 10: {
                                    message.translationLanguage = reader.string();
                                    break;
                                }
                            case 11: {
                                    if (!(message.translatedLanguages && message.translatedLanguages.length))
                                        message.translatedLanguages = [];
                                    message.translatedLanguages.push(reader.string());
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a TranslateProto message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof ai.talecast.webapp.proto.TranslateProto
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {ai.talecast.webapp.proto.TranslateProto} TranslateProto
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TranslateProto.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a TranslateProto message.
                     * @function verify
                     * @memberof ai.talecast.webapp.proto.TranslateProto
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    TranslateProto.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        const properties = {};
                        if (message.projectId != null && message.hasOwnProperty("projectId"))
                            if (!$util.isInteger(message.projectId) && !(message.projectId && $util.isInteger(message.projectId.low) && $util.isInteger(message.projectId.high)))
                                return "projectId: integer|Long expected";
                        if (message.isSuccess != null && message.hasOwnProperty("isSuccess"))
                            if (typeof message.isSuccess !== "boolean")
                                return "isSuccess: boolean expected";
                        if (message.details != null && message.hasOwnProperty("details")) {
                            if (!Array.isArray(message.details))
                                return "details: array expected";
                            for (let i = 0; i < message.details.length; ++i) {
                                const error = $root.ai.talecast.webapp.proto.TranslateSentenceProto.verify(message.details[i]);
                                if (error)
                                    return "details." + error;
                            }
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isString(message.id))
                                return "id: string expected";
                        if (message.oriUrl != null && message.hasOwnProperty("oriUrl"))
                            if (!$util.isString(message.oriUrl))
                                return "oriUrl: string expected";
                        if (message.zIndex != null && message.hasOwnProperty("zIndex")) {
                            properties._zIndex = 1;
                            if (!$util.isInteger(message.zIndex))
                                return "zIndex: integer expected";
                        }
                        if (message.type != null && message.hasOwnProperty("type")) {
                            properties._type = 1;
                            if (!$util.isInteger(message.type))
                                return "type: integer expected";
                        }
                        if (message.oriLanguage != null && message.hasOwnProperty("oriLanguage"))
                            if (!$util.isString(message.oriLanguage))
                                return "oriLanguage: string expected";
                        if (message.targetLanguage != null && message.hasOwnProperty("targetLanguage"))
                            if (!$util.isString(message.targetLanguage))
                                return "targetLanguage: string expected";
                        if (message.translationLanguage != null && message.hasOwnProperty("translationLanguage"))
                            if (!$util.isString(message.translationLanguage))
                                return "translationLanguage: string expected";
                        if (message.translatedLanguages != null && message.hasOwnProperty("translatedLanguages")) {
                            if (!Array.isArray(message.translatedLanguages))
                                return "translatedLanguages: array expected";
                            for (let i = 0; i < message.translatedLanguages.length; ++i)
                                if (!$util.isString(message.translatedLanguages[i]))
                                    return "translatedLanguages: string[] expected";
                        }
                        return null;
                    };

                    /**
                     * Creates a TranslateProto message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof ai.talecast.webapp.proto.TranslateProto
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {ai.talecast.webapp.proto.TranslateProto} TranslateProto
                     */
                    TranslateProto.fromObject = function fromObject(object) {
                        if (object instanceof $root.ai.talecast.webapp.proto.TranslateProto)
                            return object;
                        const message = new $root.ai.talecast.webapp.proto.TranslateProto();
                        if (object.projectId != null)
                            if ($util.Long)
                                (message.projectId = $util.Long.fromValue(object.projectId)).unsigned = false;
                            else if (typeof object.projectId === "string")
                                message.projectId = parseInt(object.projectId, 10);
                            else if (typeof object.projectId === "number")
                                message.projectId = object.projectId;
                            else if (typeof object.projectId === "object")
                                message.projectId = new $util.LongBits(object.projectId.low >>> 0, object.projectId.high >>> 0).toNumber();
                        if (object.isSuccess != null)
                            message.isSuccess = Boolean(object.isSuccess);
                        if (object.details) {
                            if (!Array.isArray(object.details))
                                throw TypeError(".ai.talecast.webapp.proto.TranslateProto.details: array expected");
                            message.details = [];
                            for (let i = 0; i < object.details.length; ++i) {
                                if (typeof object.details[i] !== "object")
                                    throw TypeError(".ai.talecast.webapp.proto.TranslateProto.details: object expected");
                                message.details[i] = $root.ai.talecast.webapp.proto.TranslateSentenceProto.fromObject(object.details[i]);
                            }
                        }
                        if (object.id != null)
                            message.id = String(object.id);
                        if (object.oriUrl != null)
                            message.oriUrl = String(object.oriUrl);
                        if (object.zIndex != null)
                            message.zIndex = object.zIndex | 0;
                        if (object.type != null)
                            message.type = object.type | 0;
                        if (object.oriLanguage != null)
                            message.oriLanguage = String(object.oriLanguage);
                        if (object.targetLanguage != null)
                            message.targetLanguage = String(object.targetLanguage);
                        if (object.translationLanguage != null)
                            message.translationLanguage = String(object.translationLanguage);
                        if (object.translatedLanguages) {
                            if (!Array.isArray(object.translatedLanguages))
                                throw TypeError(".ai.talecast.webapp.proto.TranslateProto.translatedLanguages: array expected");
                            message.translatedLanguages = [];
                            for (let i = 0; i < object.translatedLanguages.length; ++i)
                                message.translatedLanguages[i] = String(object.translatedLanguages[i]);
                        }
                        return message;
                    };

                    /**
                     * Creates a plain object from a TranslateProto message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof ai.talecast.webapp.proto.TranslateProto
                     * @static
                     * @param {ai.talecast.webapp.proto.TranslateProto} message TranslateProto
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    TranslateProto.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        const object = {};
                        if (options.arrays || options.defaults) {
                            object.details = [];
                            object.translatedLanguages = [];
                        }
                        if (options.defaults) {
                            if ($util.Long) {
                                const long = new $util.Long(0, 0, false);
                                object.projectId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.projectId = options.longs === String ? "0" : 0;
                            object.isSuccess = false;
                            object.id = "";
                            object.oriUrl = "";
                            object.oriLanguage = "";
                            object.targetLanguage = "";
                            object.translationLanguage = "";
                        }
                        if (message.projectId != null && message.hasOwnProperty("projectId"))
                            if (typeof message.projectId === "number")
                                object.projectId = options.longs === String ? String(message.projectId) : message.projectId;
                            else
                                object.projectId = options.longs === String ? $util.Long.prototype.toString.call(message.projectId) : options.longs === Number ? new $util.LongBits(message.projectId.low >>> 0, message.projectId.high >>> 0).toNumber() : message.projectId;
                        if (message.isSuccess != null && message.hasOwnProperty("isSuccess"))
                            object.isSuccess = message.isSuccess;
                        if (message.details && message.details.length) {
                            object.details = [];
                            for (let j = 0; j < message.details.length; ++j)
                                object.details[j] = $root.ai.talecast.webapp.proto.TranslateSentenceProto.toObject(message.details[j], options);
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            object.id = message.id;
                        if (message.oriUrl != null && message.hasOwnProperty("oriUrl"))
                            object.oriUrl = message.oriUrl;
                        if (message.zIndex != null && message.hasOwnProperty("zIndex")) {
                            object.zIndex = message.zIndex;
                            if (options.oneofs)
                                object._zIndex = "zIndex";
                        }
                        if (message.type != null && message.hasOwnProperty("type")) {
                            object.type = message.type;
                            if (options.oneofs)
                                object._type = "type";
                        }
                        if (message.oriLanguage != null && message.hasOwnProperty("oriLanguage"))
                            object.oriLanguage = message.oriLanguage;
                        if (message.targetLanguage != null && message.hasOwnProperty("targetLanguage"))
                            object.targetLanguage = message.targetLanguage;
                        if (message.translationLanguage != null && message.hasOwnProperty("translationLanguage"))
                            object.translationLanguage = message.translationLanguage;
                        if (message.translatedLanguages && message.translatedLanguages.length) {
                            object.translatedLanguages = [];
                            for (let j = 0; j < message.translatedLanguages.length; ++j)
                                object.translatedLanguages[j] = message.translatedLanguages[j];
                        }
                        return object;
                    };

                    /**
                     * Converts this TranslateProto to JSON.
                     * @function toJSON
                     * @memberof ai.talecast.webapp.proto.TranslateProto
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    TranslateProto.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for TranslateProto
                     * @function getTypeUrl
                     * @memberof ai.talecast.webapp.proto.TranslateProto
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    TranslateProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/ai.talecast.webapp.proto.TranslateProto";
                    };

                    return TranslateProto;
                })();

                proto.TranslateSentenceProto = (function() {

                    /**
                     * Properties of a TranslateSentenceProto.
                     * @memberof ai.talecast.webapp.proto
                     * @interface ITranslateSentenceProto
                     * @property {number|Long|null} [id] TranslateSentenceProto id
                     * @property {number|null} [volume] TranslateSentenceProto volume
                     * @property {number|null} [speed] TranslateSentenceProto speed
                     * @property {string|null} [sentence] TranslateSentenceProto sentence
                     * @property {string|null} [sentenceUrl] TranslateSentenceProto sentenceUrl
                     * @property {string|null} [speaker] TranslateSentenceProto speaker
                     * @property {number|null} [speakerId] TranslateSentenceProto speakerId
                     * @property {number|null} [from] TranslateSentenceProto from
                     * @property {number|null} [to] TranslateSentenceProto to
                     * @property {number|null} [timeLineFrom] TranslateSentenceProto timeLineFrom
                     * @property {number|null} [timeLineTo] TranslateSentenceProto timeLineTo
                     * @property {ai.talecast.webapp.proto.ISubtitle|null} [subtitle] TranslateSentenceProto subtitle
                     * @property {boolean|null} [isEdit] TranslateSentenceProto isEdit
                     * @property {boolean|null} [generating] TranslateSentenceProto generating
                     * @property {number|null} [type] TranslateSentenceProto type
                     * @property {boolean|null} [sentenceShow] TranslateSentenceProto sentenceShow
                     * @property {number|null} [trackIndex] TranslateSentenceProto trackIndex
                     */

                    /**
                     * Constructs a new TranslateSentenceProto.
                     * @memberof ai.talecast.webapp.proto
                     * @classdesc Represents a TranslateSentenceProto.
                     * @implements ITranslateSentenceProto
                     * @constructor
                     * @param {ai.talecast.webapp.proto.ITranslateSentenceProto=} [properties] Properties to set
                     */
                    function TranslateSentenceProto(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * TranslateSentenceProto id.
                     * @member {number|Long} id
                     * @memberof ai.talecast.webapp.proto.TranslateSentenceProto
                     * @instance
                     */
                    TranslateSentenceProto.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                    /**
                     * TranslateSentenceProto volume.
                     * @member {number|null|undefined} volume
                     * @memberof ai.talecast.webapp.proto.TranslateSentenceProto
                     * @instance
                     */
                    TranslateSentenceProto.prototype.volume = null;

                    /**
                     * TranslateSentenceProto speed.
                     * @member {number|null|undefined} speed
                     * @memberof ai.talecast.webapp.proto.TranslateSentenceProto
                     * @instance
                     */
                    TranslateSentenceProto.prototype.speed = null;

                    /**
                     * TranslateSentenceProto sentence.
                     * @member {string} sentence
                     * @memberof ai.talecast.webapp.proto.TranslateSentenceProto
                     * @instance
                     */
                    TranslateSentenceProto.prototype.sentence = "";

                    /**
                     * TranslateSentenceProto sentenceUrl.
                     * @member {string} sentenceUrl
                     * @memberof ai.talecast.webapp.proto.TranslateSentenceProto
                     * @instance
                     */
                    TranslateSentenceProto.prototype.sentenceUrl = "";

                    /**
                     * TranslateSentenceProto speaker.
                     * @member {string} speaker
                     * @memberof ai.talecast.webapp.proto.TranslateSentenceProto
                     * @instance
                     */
                    TranslateSentenceProto.prototype.speaker = "";

                    /**
                     * TranslateSentenceProto speakerId.
                     * @member {number} speakerId
                     * @memberof ai.talecast.webapp.proto.TranslateSentenceProto
                     * @instance
                     */
                    TranslateSentenceProto.prototype.speakerId = 0;

                    /**
                     * TranslateSentenceProto from.
                     * @member {number|null|undefined} from
                     * @memberof ai.talecast.webapp.proto.TranslateSentenceProto
                     * @instance
                     */
                    TranslateSentenceProto.prototype.from = null;

                    /**
                     * TranslateSentenceProto to.
                     * @member {number|null|undefined} to
                     * @memberof ai.talecast.webapp.proto.TranslateSentenceProto
                     * @instance
                     */
                    TranslateSentenceProto.prototype.to = null;

                    /**
                     * TranslateSentenceProto timeLineFrom.
                     * @member {number|null|undefined} timeLineFrom
                     * @memberof ai.talecast.webapp.proto.TranslateSentenceProto
                     * @instance
                     */
                    TranslateSentenceProto.prototype.timeLineFrom = null;

                    /**
                     * TranslateSentenceProto timeLineTo.
                     * @member {number|null|undefined} timeLineTo
                     * @memberof ai.talecast.webapp.proto.TranslateSentenceProto
                     * @instance
                     */
                    TranslateSentenceProto.prototype.timeLineTo = null;

                    /**
                     * TranslateSentenceProto subtitle.
                     * @member {ai.talecast.webapp.proto.ISubtitle|null|undefined} subtitle
                     * @memberof ai.talecast.webapp.proto.TranslateSentenceProto
                     * @instance
                     */
                    TranslateSentenceProto.prototype.subtitle = null;

                    /**
                     * TranslateSentenceProto isEdit.
                     * @member {boolean|null|undefined} isEdit
                     * @memberof ai.talecast.webapp.proto.TranslateSentenceProto
                     * @instance
                     */
                    TranslateSentenceProto.prototype.isEdit = null;

                    /**
                     * TranslateSentenceProto generating.
                     * @member {boolean|null|undefined} generating
                     * @memberof ai.talecast.webapp.proto.TranslateSentenceProto
                     * @instance
                     */
                    TranslateSentenceProto.prototype.generating = null;

                    /**
                     * TranslateSentenceProto type.
                     * @member {number|null|undefined} type
                     * @memberof ai.talecast.webapp.proto.TranslateSentenceProto
                     * @instance
                     */
                    TranslateSentenceProto.prototype.type = null;

                    /**
                     * TranslateSentenceProto sentenceShow.
                     * @member {boolean|null|undefined} sentenceShow
                     * @memberof ai.talecast.webapp.proto.TranslateSentenceProto
                     * @instance
                     */
                    TranslateSentenceProto.prototype.sentenceShow = null;

                    /**
                     * TranslateSentenceProto trackIndex.
                     * @member {number|null|undefined} trackIndex
                     * @memberof ai.talecast.webapp.proto.TranslateSentenceProto
                     * @instance
                     */
                    TranslateSentenceProto.prototype.trackIndex = null;

                    // OneOf field names bound to virtual getters and setters
                    let $oneOfFields;

                    // Virtual OneOf for proto3 optional field
                    Object.defineProperty(TranslateSentenceProto.prototype, "_volume", {
                        get: $util.oneOfGetter($oneOfFields = ["volume"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    // Virtual OneOf for proto3 optional field
                    Object.defineProperty(TranslateSentenceProto.prototype, "_speed", {
                        get: $util.oneOfGetter($oneOfFields = ["speed"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    // Virtual OneOf for proto3 optional field
                    Object.defineProperty(TranslateSentenceProto.prototype, "_from", {
                        get: $util.oneOfGetter($oneOfFields = ["from"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    // Virtual OneOf for proto3 optional field
                    Object.defineProperty(TranslateSentenceProto.prototype, "_to", {
                        get: $util.oneOfGetter($oneOfFields = ["to"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    // Virtual OneOf for proto3 optional field
                    Object.defineProperty(TranslateSentenceProto.prototype, "_timeLineFrom", {
                        get: $util.oneOfGetter($oneOfFields = ["timeLineFrom"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    // Virtual OneOf for proto3 optional field
                    Object.defineProperty(TranslateSentenceProto.prototype, "_timeLineTo", {
                        get: $util.oneOfGetter($oneOfFields = ["timeLineTo"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    // Virtual OneOf for proto3 optional field
                    Object.defineProperty(TranslateSentenceProto.prototype, "_isEdit", {
                        get: $util.oneOfGetter($oneOfFields = ["isEdit"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    // Virtual OneOf for proto3 optional field
                    Object.defineProperty(TranslateSentenceProto.prototype, "_generating", {
                        get: $util.oneOfGetter($oneOfFields = ["generating"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    // Virtual OneOf for proto3 optional field
                    Object.defineProperty(TranslateSentenceProto.prototype, "_type", {
                        get: $util.oneOfGetter($oneOfFields = ["type"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    // Virtual OneOf for proto3 optional field
                    Object.defineProperty(TranslateSentenceProto.prototype, "_sentenceShow", {
                        get: $util.oneOfGetter($oneOfFields = ["sentenceShow"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    // Virtual OneOf for proto3 optional field
                    Object.defineProperty(TranslateSentenceProto.prototype, "_trackIndex", {
                        get: $util.oneOfGetter($oneOfFields = ["trackIndex"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    /**
                     * Creates a new TranslateSentenceProto instance using the specified properties.
                     * @function create
                     * @memberof ai.talecast.webapp.proto.TranslateSentenceProto
                     * @static
                     * @param {ai.talecast.webapp.proto.ITranslateSentenceProto=} [properties] Properties to set
                     * @returns {ai.talecast.webapp.proto.TranslateSentenceProto} TranslateSentenceProto instance
                     */
                    TranslateSentenceProto.create = function create(properties) {
                        return new TranslateSentenceProto(properties);
                    };

                    /**
                     * Encodes the specified TranslateSentenceProto message. Does not implicitly {@link ai.talecast.webapp.proto.TranslateSentenceProto.verify|verify} messages.
                     * @function encode
                     * @memberof ai.talecast.webapp.proto.TranslateSentenceProto
                     * @static
                     * @param {ai.talecast.webapp.proto.ITranslateSentenceProto} message TranslateSentenceProto message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TranslateSentenceProto.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.volume != null && Object.hasOwnProperty.call(message, "volume"))
                            writer.uint32(/* id 2, wireType 1 =*/17).double(message.volume);
                        if (message.speed != null && Object.hasOwnProperty.call(message, "speed"))
                            writer.uint32(/* id 3, wireType 1 =*/25).double(message.speed);
                        if (message.sentence != null && Object.hasOwnProperty.call(message, "sentence"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.sentence);
                        if (message.sentenceUrl != null && Object.hasOwnProperty.call(message, "sentenceUrl"))
                            writer.uint32(/* id 5, wireType 2 =*/42).string(message.sentenceUrl);
                        if (message.speaker != null && Object.hasOwnProperty.call(message, "speaker"))
                            writer.uint32(/* id 6, wireType 2 =*/50).string(message.speaker);
                        if (message.speakerId != null && Object.hasOwnProperty.call(message, "speakerId"))
                            writer.uint32(/* id 7, wireType 0 =*/56).int32(message.speakerId);
                        if (message.from != null && Object.hasOwnProperty.call(message, "from"))
                            writer.uint32(/* id 8, wireType 0 =*/64).int32(message.from);
                        if (message.to != null && Object.hasOwnProperty.call(message, "to"))
                            writer.uint32(/* id 9, wireType 0 =*/72).int32(message.to);
                        if (message.timeLineFrom != null && Object.hasOwnProperty.call(message, "timeLineFrom"))
                            writer.uint32(/* id 10, wireType 0 =*/80).int32(message.timeLineFrom);
                        if (message.timeLineTo != null && Object.hasOwnProperty.call(message, "timeLineTo"))
                            writer.uint32(/* id 11, wireType 0 =*/88).int32(message.timeLineTo);
                        if (message.subtitle != null && Object.hasOwnProperty.call(message, "subtitle"))
                            $root.ai.talecast.webapp.proto.Subtitle.encode(message.subtitle, writer.uint32(/* id 12, wireType 2 =*/98).fork()).ldelim();
                        if (message.isEdit != null && Object.hasOwnProperty.call(message, "isEdit"))
                            writer.uint32(/* id 13, wireType 0 =*/104).bool(message.isEdit);
                        if (message.generating != null && Object.hasOwnProperty.call(message, "generating"))
                            writer.uint32(/* id 14, wireType 0 =*/112).bool(message.generating);
                        if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                            writer.uint32(/* id 15, wireType 0 =*/120).int32(message.type);
                        if (message.sentenceShow != null && Object.hasOwnProperty.call(message, "sentenceShow"))
                            writer.uint32(/* id 16, wireType 0 =*/128).bool(message.sentenceShow);
                        if (message.trackIndex != null && Object.hasOwnProperty.call(message, "trackIndex"))
                            writer.uint32(/* id 17, wireType 1 =*/137).double(message.trackIndex);
                        return writer;
                    };

                    /**
                     * Encodes the specified TranslateSentenceProto message, length delimited. Does not implicitly {@link ai.talecast.webapp.proto.TranslateSentenceProto.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof ai.talecast.webapp.proto.TranslateSentenceProto
                     * @static
                     * @param {ai.talecast.webapp.proto.ITranslateSentenceProto} message TranslateSentenceProto message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TranslateSentenceProto.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a TranslateSentenceProto message from the specified reader or buffer.
                     * @function decode
                     * @memberof ai.talecast.webapp.proto.TranslateSentenceProto
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {ai.talecast.webapp.proto.TranslateSentenceProto} TranslateSentenceProto
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TranslateSentenceProto.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        const end = length === undefined ? reader.len : reader.pos + length, message = new $root.ai.talecast.webapp.proto.TranslateSentenceProto();
                        while (reader.pos < end) {
                            const tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.id = reader.int64();
                                    break;
                                }
                            case 2: {
                                    message.volume = reader.double();
                                    break;
                                }
                            case 3: {
                                    message.speed = reader.double();
                                    break;
                                }
                            case 4: {
                                    message.sentence = reader.string();
                                    break;
                                }
                            case 5: {
                                    message.sentenceUrl = reader.string();
                                    break;
                                }
                            case 6: {
                                    message.speaker = reader.string();
                                    break;
                                }
                            case 7: {
                                    message.speakerId = reader.int32();
                                    break;
                                }
                            case 8: {
                                    message.from = reader.int32();
                                    break;
                                }
                            case 9: {
                                    message.to = reader.int32();
                                    break;
                                }
                            case 10: {
                                    message.timeLineFrom = reader.int32();
                                    break;
                                }
                            case 11: {
                                    message.timeLineTo = reader.int32();
                                    break;
                                }
                            case 12: {
                                    message.subtitle = $root.ai.talecast.webapp.proto.Subtitle.decode(reader, reader.uint32());
                                    break;
                                }
                            case 13: {
                                    message.isEdit = reader.bool();
                                    break;
                                }
                            case 14: {
                                    message.generating = reader.bool();
                                    break;
                                }
                            case 15: {
                                    message.type = reader.int32();
                                    break;
                                }
                            case 16: {
                                    message.sentenceShow = reader.bool();
                                    break;
                                }
                            case 17: {
                                    message.trackIndex = reader.double();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a TranslateSentenceProto message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof ai.talecast.webapp.proto.TranslateSentenceProto
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {ai.talecast.webapp.proto.TranslateSentenceProto} TranslateSentenceProto
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TranslateSentenceProto.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a TranslateSentenceProto message.
                     * @function verify
                     * @memberof ai.talecast.webapp.proto.TranslateSentenceProto
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    TranslateSentenceProto.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        const properties = {};
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.volume != null && message.hasOwnProperty("volume")) {
                            properties._volume = 1;
                            if (typeof message.volume !== "number")
                                return "volume: number expected";
                        }
                        if (message.speed != null && message.hasOwnProperty("speed")) {
                            properties._speed = 1;
                            if (typeof message.speed !== "number")
                                return "speed: number expected";
                        }
                        if (message.sentence != null && message.hasOwnProperty("sentence"))
                            if (!$util.isString(message.sentence))
                                return "sentence: string expected";
                        if (message.sentenceUrl != null && message.hasOwnProperty("sentenceUrl"))
                            if (!$util.isString(message.sentenceUrl))
                                return "sentenceUrl: string expected";
                        if (message.speaker != null && message.hasOwnProperty("speaker"))
                            if (!$util.isString(message.speaker))
                                return "speaker: string expected";
                        if (message.speakerId != null && message.hasOwnProperty("speakerId"))
                            if (!$util.isInteger(message.speakerId))
                                return "speakerId: integer expected";
                        if (message.from != null && message.hasOwnProperty("from")) {
                            properties._from = 1;
                            if (!$util.isInteger(message.from))
                                return "from: integer expected";
                        }
                        if (message.to != null && message.hasOwnProperty("to")) {
                            properties._to = 1;
                            if (!$util.isInteger(message.to))
                                return "to: integer expected";
                        }
                        if (message.timeLineFrom != null && message.hasOwnProperty("timeLineFrom")) {
                            properties._timeLineFrom = 1;
                            if (!$util.isInteger(message.timeLineFrom))
                                return "timeLineFrom: integer expected";
                        }
                        if (message.timeLineTo != null && message.hasOwnProperty("timeLineTo")) {
                            properties._timeLineTo = 1;
                            if (!$util.isInteger(message.timeLineTo))
                                return "timeLineTo: integer expected";
                        }
                        if (message.subtitle != null && message.hasOwnProperty("subtitle")) {
                            const error = $root.ai.talecast.webapp.proto.Subtitle.verify(message.subtitle);
                            if (error)
                                return "subtitle." + error;
                        }
                        if (message.isEdit != null && message.hasOwnProperty("isEdit")) {
                            properties._isEdit = 1;
                            if (typeof message.isEdit !== "boolean")
                                return "isEdit: boolean expected";
                        }
                        if (message.generating != null && message.hasOwnProperty("generating")) {
                            properties._generating = 1;
                            if (typeof message.generating !== "boolean")
                                return "generating: boolean expected";
                        }
                        if (message.type != null && message.hasOwnProperty("type")) {
                            properties._type = 1;
                            if (!$util.isInteger(message.type))
                                return "type: integer expected";
                        }
                        if (message.sentenceShow != null && message.hasOwnProperty("sentenceShow")) {
                            properties._sentenceShow = 1;
                            if (typeof message.sentenceShow !== "boolean")
                                return "sentenceShow: boolean expected";
                        }
                        if (message.trackIndex != null && message.hasOwnProperty("trackIndex")) {
                            properties._trackIndex = 1;
                            if (typeof message.trackIndex !== "number")
                                return "trackIndex: number expected";
                        }
                        return null;
                    };

                    /**
                     * Creates a TranslateSentenceProto message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof ai.talecast.webapp.proto.TranslateSentenceProto
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {ai.talecast.webapp.proto.TranslateSentenceProto} TranslateSentenceProto
                     */
                    TranslateSentenceProto.fromObject = function fromObject(object) {
                        if (object instanceof $root.ai.talecast.webapp.proto.TranslateSentenceProto)
                            return object;
                        const message = new $root.ai.talecast.webapp.proto.TranslateSentenceProto();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.volume != null)
                            message.volume = Number(object.volume);
                        if (object.speed != null)
                            message.speed = Number(object.speed);
                        if (object.sentence != null)
                            message.sentence = String(object.sentence);
                        if (object.sentenceUrl != null)
                            message.sentenceUrl = String(object.sentenceUrl);
                        if (object.speaker != null)
                            message.speaker = String(object.speaker);
                        if (object.speakerId != null)
                            message.speakerId = object.speakerId | 0;
                        if (object.from != null)
                            message.from = object.from | 0;
                        if (object.to != null)
                            message.to = object.to | 0;
                        if (object.timeLineFrom != null)
                            message.timeLineFrom = object.timeLineFrom | 0;
                        if (object.timeLineTo != null)
                            message.timeLineTo = object.timeLineTo | 0;
                        if (object.subtitle != null) {
                            if (typeof object.subtitle !== "object")
                                throw TypeError(".ai.talecast.webapp.proto.TranslateSentenceProto.subtitle: object expected");
                            message.subtitle = $root.ai.talecast.webapp.proto.Subtitle.fromObject(object.subtitle);
                        }
                        if (object.isEdit != null)
                            message.isEdit = Boolean(object.isEdit);
                        if (object.generating != null)
                            message.generating = Boolean(object.generating);
                        if (object.type != null)
                            message.type = object.type | 0;
                        if (object.sentenceShow != null)
                            message.sentenceShow = Boolean(object.sentenceShow);
                        if (object.trackIndex != null)
                            message.trackIndex = Number(object.trackIndex);
                        return message;
                    };

                    /**
                     * Creates a plain object from a TranslateSentenceProto message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof ai.talecast.webapp.proto.TranslateSentenceProto
                     * @static
                     * @param {ai.talecast.webapp.proto.TranslateSentenceProto} message TranslateSentenceProto
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    TranslateSentenceProto.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        const object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                const long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            object.sentence = "";
                            object.sentenceUrl = "";
                            object.speaker = "";
                            object.speakerId = 0;
                            object.subtitle = null;
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.volume != null && message.hasOwnProperty("volume")) {
                            object.volume = options.json && !isFinite(message.volume) ? String(message.volume) : message.volume;
                            if (options.oneofs)
                                object._volume = "volume";
                        }
                        if (message.speed != null && message.hasOwnProperty("speed")) {
                            object.speed = options.json && !isFinite(message.speed) ? String(message.speed) : message.speed;
                            if (options.oneofs)
                                object._speed = "speed";
                        }
                        if (message.sentence != null && message.hasOwnProperty("sentence"))
                            object.sentence = message.sentence;
                        if (message.sentenceUrl != null && message.hasOwnProperty("sentenceUrl"))
                            object.sentenceUrl = message.sentenceUrl;
                        if (message.speaker != null && message.hasOwnProperty("speaker"))
                            object.speaker = message.speaker;
                        if (message.speakerId != null && message.hasOwnProperty("speakerId"))
                            object.speakerId = message.speakerId;
                        if (message.from != null && message.hasOwnProperty("from")) {
                            object.from = message.from;
                            if (options.oneofs)
                                object._from = "from";
                        }
                        if (message.to != null && message.hasOwnProperty("to")) {
                            object.to = message.to;
                            if (options.oneofs)
                                object._to = "to";
                        }
                        if (message.timeLineFrom != null && message.hasOwnProperty("timeLineFrom")) {
                            object.timeLineFrom = message.timeLineFrom;
                            if (options.oneofs)
                                object._timeLineFrom = "timeLineFrom";
                        }
                        if (message.timeLineTo != null && message.hasOwnProperty("timeLineTo")) {
                            object.timeLineTo = message.timeLineTo;
                            if (options.oneofs)
                                object._timeLineTo = "timeLineTo";
                        }
                        if (message.subtitle != null && message.hasOwnProperty("subtitle"))
                            object.subtitle = $root.ai.talecast.webapp.proto.Subtitle.toObject(message.subtitle, options);
                        if (message.isEdit != null && message.hasOwnProperty("isEdit")) {
                            object.isEdit = message.isEdit;
                            if (options.oneofs)
                                object._isEdit = "isEdit";
                        }
                        if (message.generating != null && message.hasOwnProperty("generating")) {
                            object.generating = message.generating;
                            if (options.oneofs)
                                object._generating = "generating";
                        }
                        if (message.type != null && message.hasOwnProperty("type")) {
                            object.type = message.type;
                            if (options.oneofs)
                                object._type = "type";
                        }
                        if (message.sentenceShow != null && message.hasOwnProperty("sentenceShow")) {
                            object.sentenceShow = message.sentenceShow;
                            if (options.oneofs)
                                object._sentenceShow = "sentenceShow";
                        }
                        if (message.trackIndex != null && message.hasOwnProperty("trackIndex")) {
                            object.trackIndex = options.json && !isFinite(message.trackIndex) ? String(message.trackIndex) : message.trackIndex;
                            if (options.oneofs)
                                object._trackIndex = "trackIndex";
                        }
                        return object;
                    };

                    /**
                     * Converts this TranslateSentenceProto to JSON.
                     * @function toJSON
                     * @memberof ai.talecast.webapp.proto.TranslateSentenceProto
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    TranslateSentenceProto.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for TranslateSentenceProto
                     * @function getTypeUrl
                     * @memberof ai.talecast.webapp.proto.TranslateSentenceProto
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    TranslateSentenceProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/ai.talecast.webapp.proto.TranslateSentenceProto";
                    };

                    return TranslateSentenceProto;
                })();

                proto.Subtitle = (function() {

                    /**
                     * Properties of a Subtitle.
                     * @memberof ai.talecast.webapp.proto
                     * @interface ISubtitle
                     * @property {number|Long|null} [id] Subtitle id
                     * @property {string|null} [text] Subtitle text
                     * @property {number|null} [timeLineFrom] Subtitle timeLineFrom
                     * @property {number|null} [timeLineTo] Subtitle timeLineTo
                     * @property {number|null} [type] Subtitle type
                     * @property {boolean|null} [sentenceShow] Subtitle sentenceShow
                     */

                    /**
                     * Constructs a new Subtitle.
                     * @memberof ai.talecast.webapp.proto
                     * @classdesc Represents a Subtitle.
                     * @implements ISubtitle
                     * @constructor
                     * @param {ai.talecast.webapp.proto.ISubtitle=} [properties] Properties to set
                     */
                    function Subtitle(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Subtitle id.
                     * @member {number|Long} id
                     * @memberof ai.talecast.webapp.proto.Subtitle
                     * @instance
                     */
                    Subtitle.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                    /**
                     * Subtitle text.
                     * @member {string|null|undefined} text
                     * @memberof ai.talecast.webapp.proto.Subtitle
                     * @instance
                     */
                    Subtitle.prototype.text = null;

                    /**
                     * Subtitle timeLineFrom.
                     * @member {number|null|undefined} timeLineFrom
                     * @memberof ai.talecast.webapp.proto.Subtitle
                     * @instance
                     */
                    Subtitle.prototype.timeLineFrom = null;

                    /**
                     * Subtitle timeLineTo.
                     * @member {number|null|undefined} timeLineTo
                     * @memberof ai.talecast.webapp.proto.Subtitle
                     * @instance
                     */
                    Subtitle.prototype.timeLineTo = null;

                    /**
                     * Subtitle type.
                     * @member {number|null|undefined} type
                     * @memberof ai.talecast.webapp.proto.Subtitle
                     * @instance
                     */
                    Subtitle.prototype.type = null;

                    /**
                     * Subtitle sentenceShow.
                     * @member {boolean|null|undefined} sentenceShow
                     * @memberof ai.talecast.webapp.proto.Subtitle
                     * @instance
                     */
                    Subtitle.prototype.sentenceShow = null;

                    // OneOf field names bound to virtual getters and setters
                    let $oneOfFields;

                    // Virtual OneOf for proto3 optional field
                    Object.defineProperty(Subtitle.prototype, "_text", {
                        get: $util.oneOfGetter($oneOfFields = ["text"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    // Virtual OneOf for proto3 optional field
                    Object.defineProperty(Subtitle.prototype, "_timeLineFrom", {
                        get: $util.oneOfGetter($oneOfFields = ["timeLineFrom"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    // Virtual OneOf for proto3 optional field
                    Object.defineProperty(Subtitle.prototype, "_timeLineTo", {
                        get: $util.oneOfGetter($oneOfFields = ["timeLineTo"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    // Virtual OneOf for proto3 optional field
                    Object.defineProperty(Subtitle.prototype, "_type", {
                        get: $util.oneOfGetter($oneOfFields = ["type"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    // Virtual OneOf for proto3 optional field
                    Object.defineProperty(Subtitle.prototype, "_sentenceShow", {
                        get: $util.oneOfGetter($oneOfFields = ["sentenceShow"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    /**
                     * Creates a new Subtitle instance using the specified properties.
                     * @function create
                     * @memberof ai.talecast.webapp.proto.Subtitle
                     * @static
                     * @param {ai.talecast.webapp.proto.ISubtitle=} [properties] Properties to set
                     * @returns {ai.talecast.webapp.proto.Subtitle} Subtitle instance
                     */
                    Subtitle.create = function create(properties) {
                        return new Subtitle(properties);
                    };

                    /**
                     * Encodes the specified Subtitle message. Does not implicitly {@link ai.talecast.webapp.proto.Subtitle.verify|verify} messages.
                     * @function encode
                     * @memberof ai.talecast.webapp.proto.Subtitle
                     * @static
                     * @param {ai.talecast.webapp.proto.ISubtitle} message Subtitle message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Subtitle.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.text != null && Object.hasOwnProperty.call(message, "text"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.text);
                        if (message.timeLineFrom != null && Object.hasOwnProperty.call(message, "timeLineFrom"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.timeLineFrom);
                        if (message.timeLineTo != null && Object.hasOwnProperty.call(message, "timeLineTo"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.timeLineTo);
                        if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.type);
                        if (message.sentenceShow != null && Object.hasOwnProperty.call(message, "sentenceShow"))
                            writer.uint32(/* id 6, wireType 0 =*/48).bool(message.sentenceShow);
                        return writer;
                    };

                    /**
                     * Encodes the specified Subtitle message, length delimited. Does not implicitly {@link ai.talecast.webapp.proto.Subtitle.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof ai.talecast.webapp.proto.Subtitle
                     * @static
                     * @param {ai.talecast.webapp.proto.ISubtitle} message Subtitle message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Subtitle.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a Subtitle message from the specified reader or buffer.
                     * @function decode
                     * @memberof ai.talecast.webapp.proto.Subtitle
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {ai.talecast.webapp.proto.Subtitle} Subtitle
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Subtitle.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        const end = length === undefined ? reader.len : reader.pos + length, message = new $root.ai.talecast.webapp.proto.Subtitle();
                        while (reader.pos < end) {
                            const tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.id = reader.int64();
                                    break;
                                }
                            case 2: {
                                    message.text = reader.string();
                                    break;
                                }
                            case 3: {
                                    message.timeLineFrom = reader.int32();
                                    break;
                                }
                            case 4: {
                                    message.timeLineTo = reader.int32();
                                    break;
                                }
                            case 5: {
                                    message.type = reader.int32();
                                    break;
                                }
                            case 6: {
                                    message.sentenceShow = reader.bool();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a Subtitle message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof ai.talecast.webapp.proto.Subtitle
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {ai.talecast.webapp.proto.Subtitle} Subtitle
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Subtitle.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a Subtitle message.
                     * @function verify
                     * @memberof ai.talecast.webapp.proto.Subtitle
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Subtitle.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        const properties = {};
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.text != null && message.hasOwnProperty("text")) {
                            properties._text = 1;
                            if (!$util.isString(message.text))
                                return "text: string expected";
                        }
                        if (message.timeLineFrom != null && message.hasOwnProperty("timeLineFrom")) {
                            properties._timeLineFrom = 1;
                            if (!$util.isInteger(message.timeLineFrom))
                                return "timeLineFrom: integer expected";
                        }
                        if (message.timeLineTo != null && message.hasOwnProperty("timeLineTo")) {
                            properties._timeLineTo = 1;
                            if (!$util.isInteger(message.timeLineTo))
                                return "timeLineTo: integer expected";
                        }
                        if (message.type != null && message.hasOwnProperty("type")) {
                            properties._type = 1;
                            if (!$util.isInteger(message.type))
                                return "type: integer expected";
                        }
                        if (message.sentenceShow != null && message.hasOwnProperty("sentenceShow")) {
                            properties._sentenceShow = 1;
                            if (typeof message.sentenceShow !== "boolean")
                                return "sentenceShow: boolean expected";
                        }
                        return null;
                    };

                    /**
                     * Creates a Subtitle message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof ai.talecast.webapp.proto.Subtitle
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {ai.talecast.webapp.proto.Subtitle} Subtitle
                     */
                    Subtitle.fromObject = function fromObject(object) {
                        if (object instanceof $root.ai.talecast.webapp.proto.Subtitle)
                            return object;
                        const message = new $root.ai.talecast.webapp.proto.Subtitle();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.text != null)
                            message.text = String(object.text);
                        if (object.timeLineFrom != null)
                            message.timeLineFrom = object.timeLineFrom | 0;
                        if (object.timeLineTo != null)
                            message.timeLineTo = object.timeLineTo | 0;
                        if (object.type != null)
                            message.type = object.type | 0;
                        if (object.sentenceShow != null)
                            message.sentenceShow = Boolean(object.sentenceShow);
                        return message;
                    };

                    /**
                     * Creates a plain object from a Subtitle message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof ai.talecast.webapp.proto.Subtitle
                     * @static
                     * @param {ai.talecast.webapp.proto.Subtitle} message Subtitle
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Subtitle.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        const object = {};
                        if (options.defaults)
                            if ($util.Long) {
                                const long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.text != null && message.hasOwnProperty("text")) {
                            object.text = message.text;
                            if (options.oneofs)
                                object._text = "text";
                        }
                        if (message.timeLineFrom != null && message.hasOwnProperty("timeLineFrom")) {
                            object.timeLineFrom = message.timeLineFrom;
                            if (options.oneofs)
                                object._timeLineFrom = "timeLineFrom";
                        }
                        if (message.timeLineTo != null && message.hasOwnProperty("timeLineTo")) {
                            object.timeLineTo = message.timeLineTo;
                            if (options.oneofs)
                                object._timeLineTo = "timeLineTo";
                        }
                        if (message.type != null && message.hasOwnProperty("type")) {
                            object.type = message.type;
                            if (options.oneofs)
                                object._type = "type";
                        }
                        if (message.sentenceShow != null && message.hasOwnProperty("sentenceShow")) {
                            object.sentenceShow = message.sentenceShow;
                            if (options.oneofs)
                                object._sentenceShow = "sentenceShow";
                        }
                        return object;
                    };

                    /**
                     * Converts this Subtitle to JSON.
                     * @function toJSON
                     * @memberof ai.talecast.webapp.proto.Subtitle
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Subtitle.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for Subtitle
                     * @function getTypeUrl
                     * @memberof ai.talecast.webapp.proto.Subtitle
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    Subtitle.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/ai.talecast.webapp.proto.Subtitle";
                    };

                    return Subtitle;
                })();

                proto.TempCaptionsDetail = (function() {

                    /**
                     * Properties of a TempCaptionsDetail.
                     * @memberof ai.talecast.webapp.proto
                     * @interface ITempCaptionsDetail
                     * @property {number|Long|null} [id] TempCaptionsDetail id
                     * @property {number|Long|null} [subtitleId] TempCaptionsDetail subtitleId
                     * @property {string|null} [text] TempCaptionsDetail text
                     * @property {number|null} [timeLineFrom] TempCaptionsDetail timeLineFrom
                     * @property {number|null} [timeLineTo] TempCaptionsDetail timeLineTo
                     */

                    /**
                     * Constructs a new TempCaptionsDetail.
                     * @memberof ai.talecast.webapp.proto
                     * @classdesc Represents a TempCaptionsDetail.
                     * @implements ITempCaptionsDetail
                     * @constructor
                     * @param {ai.talecast.webapp.proto.ITempCaptionsDetail=} [properties] Properties to set
                     */
                    function TempCaptionsDetail(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * TempCaptionsDetail id.
                     * @member {number|Long} id
                     * @memberof ai.talecast.webapp.proto.TempCaptionsDetail
                     * @instance
                     */
                    TempCaptionsDetail.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                    /**
                     * TempCaptionsDetail subtitleId.
                     * @member {number|Long} subtitleId
                     * @memberof ai.talecast.webapp.proto.TempCaptionsDetail
                     * @instance
                     */
                    TempCaptionsDetail.prototype.subtitleId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                    /**
                     * TempCaptionsDetail text.
                     * @member {string|null|undefined} text
                     * @memberof ai.talecast.webapp.proto.TempCaptionsDetail
                     * @instance
                     */
                    TempCaptionsDetail.prototype.text = null;

                    /**
                     * TempCaptionsDetail timeLineFrom.
                     * @member {number|null|undefined} timeLineFrom
                     * @memberof ai.talecast.webapp.proto.TempCaptionsDetail
                     * @instance
                     */
                    TempCaptionsDetail.prototype.timeLineFrom = null;

                    /**
                     * TempCaptionsDetail timeLineTo.
                     * @member {number|null|undefined} timeLineTo
                     * @memberof ai.talecast.webapp.proto.TempCaptionsDetail
                     * @instance
                     */
                    TempCaptionsDetail.prototype.timeLineTo = null;

                    // OneOf field names bound to virtual getters and setters
                    let $oneOfFields;

                    // Virtual OneOf for proto3 optional field
                    Object.defineProperty(TempCaptionsDetail.prototype, "_text", {
                        get: $util.oneOfGetter($oneOfFields = ["text"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    // Virtual OneOf for proto3 optional field
                    Object.defineProperty(TempCaptionsDetail.prototype, "_timeLineFrom", {
                        get: $util.oneOfGetter($oneOfFields = ["timeLineFrom"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    // Virtual OneOf for proto3 optional field
                    Object.defineProperty(TempCaptionsDetail.prototype, "_timeLineTo", {
                        get: $util.oneOfGetter($oneOfFields = ["timeLineTo"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    /**
                     * Creates a new TempCaptionsDetail instance using the specified properties.
                     * @function create
                     * @memberof ai.talecast.webapp.proto.TempCaptionsDetail
                     * @static
                     * @param {ai.talecast.webapp.proto.ITempCaptionsDetail=} [properties] Properties to set
                     * @returns {ai.talecast.webapp.proto.TempCaptionsDetail} TempCaptionsDetail instance
                     */
                    TempCaptionsDetail.create = function create(properties) {
                        return new TempCaptionsDetail(properties);
                    };

                    /**
                     * Encodes the specified TempCaptionsDetail message. Does not implicitly {@link ai.talecast.webapp.proto.TempCaptionsDetail.verify|verify} messages.
                     * @function encode
                     * @memberof ai.talecast.webapp.proto.TempCaptionsDetail
                     * @static
                     * @param {ai.talecast.webapp.proto.ITempCaptionsDetail} message TempCaptionsDetail message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TempCaptionsDetail.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.subtitleId != null && Object.hasOwnProperty.call(message, "subtitleId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.subtitleId);
                        if (message.text != null && Object.hasOwnProperty.call(message, "text"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.text);
                        if (message.timeLineFrom != null && Object.hasOwnProperty.call(message, "timeLineFrom"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.timeLineFrom);
                        if (message.timeLineTo != null && Object.hasOwnProperty.call(message, "timeLineTo"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.timeLineTo);
                        return writer;
                    };

                    /**
                     * Encodes the specified TempCaptionsDetail message, length delimited. Does not implicitly {@link ai.talecast.webapp.proto.TempCaptionsDetail.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof ai.talecast.webapp.proto.TempCaptionsDetail
                     * @static
                     * @param {ai.talecast.webapp.proto.ITempCaptionsDetail} message TempCaptionsDetail message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TempCaptionsDetail.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a TempCaptionsDetail message from the specified reader or buffer.
                     * @function decode
                     * @memberof ai.talecast.webapp.proto.TempCaptionsDetail
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {ai.talecast.webapp.proto.TempCaptionsDetail} TempCaptionsDetail
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TempCaptionsDetail.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        const end = length === undefined ? reader.len : reader.pos + length, message = new $root.ai.talecast.webapp.proto.TempCaptionsDetail();
                        while (reader.pos < end) {
                            const tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.id = reader.int64();
                                    break;
                                }
                            case 2: {
                                    message.subtitleId = reader.int64();
                                    break;
                                }
                            case 3: {
                                    message.text = reader.string();
                                    break;
                                }
                            case 4: {
                                    message.timeLineFrom = reader.int32();
                                    break;
                                }
                            case 5: {
                                    message.timeLineTo = reader.int32();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a TempCaptionsDetail message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof ai.talecast.webapp.proto.TempCaptionsDetail
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {ai.talecast.webapp.proto.TempCaptionsDetail} TempCaptionsDetail
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TempCaptionsDetail.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a TempCaptionsDetail message.
                     * @function verify
                     * @memberof ai.talecast.webapp.proto.TempCaptionsDetail
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    TempCaptionsDetail.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        const properties = {};
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.subtitleId != null && message.hasOwnProperty("subtitleId"))
                            if (!$util.isInteger(message.subtitleId) && !(message.subtitleId && $util.isInteger(message.subtitleId.low) && $util.isInteger(message.subtitleId.high)))
                                return "subtitleId: integer|Long expected";
                        if (message.text != null && message.hasOwnProperty("text")) {
                            properties._text = 1;
                            if (!$util.isString(message.text))
                                return "text: string expected";
                        }
                        if (message.timeLineFrom != null && message.hasOwnProperty("timeLineFrom")) {
                            properties._timeLineFrom = 1;
                            if (!$util.isInteger(message.timeLineFrom))
                                return "timeLineFrom: integer expected";
                        }
                        if (message.timeLineTo != null && message.hasOwnProperty("timeLineTo")) {
                            properties._timeLineTo = 1;
                            if (!$util.isInteger(message.timeLineTo))
                                return "timeLineTo: integer expected";
                        }
                        return null;
                    };

                    /**
                     * Creates a TempCaptionsDetail message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof ai.talecast.webapp.proto.TempCaptionsDetail
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {ai.talecast.webapp.proto.TempCaptionsDetail} TempCaptionsDetail
                     */
                    TempCaptionsDetail.fromObject = function fromObject(object) {
                        if (object instanceof $root.ai.talecast.webapp.proto.TempCaptionsDetail)
                            return object;
                        const message = new $root.ai.talecast.webapp.proto.TempCaptionsDetail();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.subtitleId != null)
                            if ($util.Long)
                                (message.subtitleId = $util.Long.fromValue(object.subtitleId)).unsigned = false;
                            else if (typeof object.subtitleId === "string")
                                message.subtitleId = parseInt(object.subtitleId, 10);
                            else if (typeof object.subtitleId === "number")
                                message.subtitleId = object.subtitleId;
                            else if (typeof object.subtitleId === "object")
                                message.subtitleId = new $util.LongBits(object.subtitleId.low >>> 0, object.subtitleId.high >>> 0).toNumber();
                        if (object.text != null)
                            message.text = String(object.text);
                        if (object.timeLineFrom != null)
                            message.timeLineFrom = object.timeLineFrom | 0;
                        if (object.timeLineTo != null)
                            message.timeLineTo = object.timeLineTo | 0;
                        return message;
                    };

                    /**
                     * Creates a plain object from a TempCaptionsDetail message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof ai.talecast.webapp.proto.TempCaptionsDetail
                     * @static
                     * @param {ai.talecast.webapp.proto.TempCaptionsDetail} message TempCaptionsDetail
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    TempCaptionsDetail.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        const object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                const long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                const long = new $util.Long(0, 0, false);
                                object.subtitleId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.subtitleId = options.longs === String ? "0" : 0;
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.subtitleId != null && message.hasOwnProperty("subtitleId"))
                            if (typeof message.subtitleId === "number")
                                object.subtitleId = options.longs === String ? String(message.subtitleId) : message.subtitleId;
                            else
                                object.subtitleId = options.longs === String ? $util.Long.prototype.toString.call(message.subtitleId) : options.longs === Number ? new $util.LongBits(message.subtitleId.low >>> 0, message.subtitleId.high >>> 0).toNumber() : message.subtitleId;
                        if (message.text != null && message.hasOwnProperty("text")) {
                            object.text = message.text;
                            if (options.oneofs)
                                object._text = "text";
                        }
                        if (message.timeLineFrom != null && message.hasOwnProperty("timeLineFrom")) {
                            object.timeLineFrom = message.timeLineFrom;
                            if (options.oneofs)
                                object._timeLineFrom = "timeLineFrom";
                        }
                        if (message.timeLineTo != null && message.hasOwnProperty("timeLineTo")) {
                            object.timeLineTo = message.timeLineTo;
                            if (options.oneofs)
                                object._timeLineTo = "timeLineTo";
                        }
                        return object;
                    };

                    /**
                     * Converts this TempCaptionsDetail to JSON.
                     * @function toJSON
                     * @memberof ai.talecast.webapp.proto.TempCaptionsDetail
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    TempCaptionsDetail.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for TempCaptionsDetail
                     * @function getTypeUrl
                     * @memberof ai.talecast.webapp.proto.TempCaptionsDetail
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    TempCaptionsDetail.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/ai.talecast.webapp.proto.TempCaptionsDetail";
                    };

                    return TempCaptionsDetail;
                })();

                /**
                 * VoiceStatus enum.
                 * @name ai.talecast.webapp.proto.VoiceStatus
                 * @enum {number}
                 * @property {number} VOICE_STATUS_PROCESSING=0 VOICE_STATUS_PROCESSING value
                 * @property {number} VOICE_STATUS_SUCCESS=1 VOICE_STATUS_SUCCESS value
                 * @property {number} VOICE_STATUS_FAILED=2 VOICE_STATUS_FAILED value
                 */
                proto.VoiceStatus = (function() {
                    const valuesById = {}, values = Object.create(valuesById);
                    values[valuesById[0] = "VOICE_STATUS_PROCESSING"] = 0;
                    values[valuesById[1] = "VOICE_STATUS_SUCCESS"] = 1;
                    values[valuesById[2] = "VOICE_STATUS_FAILED"] = 2;
                    return values;
                })();

                proto.UserOrderInfoProto = (function() {

                    /**
                     * Properties of a UserOrderInfoProto.
                     * @memberof ai.talecast.webapp.proto
                     * @interface IUserOrderInfoProto
                     * @property {string|null} [orderId] UserOrderInfoProto orderId
                     * @property {string|null} [price] UserOrderInfoProto price
                     */

                    /**
                     * Constructs a new UserOrderInfoProto.
                     * @memberof ai.talecast.webapp.proto
                     * @classdesc Represents a UserOrderInfoProto.
                     * @implements IUserOrderInfoProto
                     * @constructor
                     * @param {ai.talecast.webapp.proto.IUserOrderInfoProto=} [properties] Properties to set
                     */
                    function UserOrderInfoProto(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * UserOrderInfoProto orderId.
                     * @member {string} orderId
                     * @memberof ai.talecast.webapp.proto.UserOrderInfoProto
                     * @instance
                     */
                    UserOrderInfoProto.prototype.orderId = "";

                    /**
                     * UserOrderInfoProto price.
                     * @member {string} price
                     * @memberof ai.talecast.webapp.proto.UserOrderInfoProto
                     * @instance
                     */
                    UserOrderInfoProto.prototype.price = "";

                    /**
                     * Creates a new UserOrderInfoProto instance using the specified properties.
                     * @function create
                     * @memberof ai.talecast.webapp.proto.UserOrderInfoProto
                     * @static
                     * @param {ai.talecast.webapp.proto.IUserOrderInfoProto=} [properties] Properties to set
                     * @returns {ai.talecast.webapp.proto.UserOrderInfoProto} UserOrderInfoProto instance
                     */
                    UserOrderInfoProto.create = function create(properties) {
                        return new UserOrderInfoProto(properties);
                    };

                    /**
                     * Encodes the specified UserOrderInfoProto message. Does not implicitly {@link ai.talecast.webapp.proto.UserOrderInfoProto.verify|verify} messages.
                     * @function encode
                     * @memberof ai.talecast.webapp.proto.UserOrderInfoProto
                     * @static
                     * @param {ai.talecast.webapp.proto.IUserOrderInfoProto} message UserOrderInfoProto message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UserOrderInfoProto.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.orderId != null && Object.hasOwnProperty.call(message, "orderId"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.orderId);
                        if (message.price != null && Object.hasOwnProperty.call(message, "price"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.price);
                        return writer;
                    };

                    /**
                     * Encodes the specified UserOrderInfoProto message, length delimited. Does not implicitly {@link ai.talecast.webapp.proto.UserOrderInfoProto.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof ai.talecast.webapp.proto.UserOrderInfoProto
                     * @static
                     * @param {ai.talecast.webapp.proto.IUserOrderInfoProto} message UserOrderInfoProto message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UserOrderInfoProto.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a UserOrderInfoProto message from the specified reader or buffer.
                     * @function decode
                     * @memberof ai.talecast.webapp.proto.UserOrderInfoProto
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {ai.talecast.webapp.proto.UserOrderInfoProto} UserOrderInfoProto
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UserOrderInfoProto.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        const end = length === undefined ? reader.len : reader.pos + length, message = new $root.ai.talecast.webapp.proto.UserOrderInfoProto();
                        while (reader.pos < end) {
                            const tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.orderId = reader.string();
                                    break;
                                }
                            case 2: {
                                    message.price = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a UserOrderInfoProto message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof ai.talecast.webapp.proto.UserOrderInfoProto
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {ai.talecast.webapp.proto.UserOrderInfoProto} UserOrderInfoProto
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UserOrderInfoProto.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a UserOrderInfoProto message.
                     * @function verify
                     * @memberof ai.talecast.webapp.proto.UserOrderInfoProto
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    UserOrderInfoProto.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.orderId != null && message.hasOwnProperty("orderId"))
                            if (!$util.isString(message.orderId))
                                return "orderId: string expected";
                        if (message.price != null && message.hasOwnProperty("price"))
                            if (!$util.isString(message.price))
                                return "price: string expected";
                        return null;
                    };

                    /**
                     * Creates a UserOrderInfoProto message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof ai.talecast.webapp.proto.UserOrderInfoProto
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {ai.talecast.webapp.proto.UserOrderInfoProto} UserOrderInfoProto
                     */
                    UserOrderInfoProto.fromObject = function fromObject(object) {
                        if (object instanceof $root.ai.talecast.webapp.proto.UserOrderInfoProto)
                            return object;
                        const message = new $root.ai.talecast.webapp.proto.UserOrderInfoProto();
                        if (object.orderId != null)
                            message.orderId = String(object.orderId);
                        if (object.price != null)
                            message.price = String(object.price);
                        return message;
                    };

                    /**
                     * Creates a plain object from a UserOrderInfoProto message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof ai.talecast.webapp.proto.UserOrderInfoProto
                     * @static
                     * @param {ai.talecast.webapp.proto.UserOrderInfoProto} message UserOrderInfoProto
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    UserOrderInfoProto.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        const object = {};
                        if (options.defaults) {
                            object.orderId = "";
                            object.price = "";
                        }
                        if (message.orderId != null && message.hasOwnProperty("orderId"))
                            object.orderId = message.orderId;
                        if (message.price != null && message.hasOwnProperty("price"))
                            object.price = message.price;
                        return object;
                    };

                    /**
                     * Converts this UserOrderInfoProto to JSON.
                     * @function toJSON
                     * @memberof ai.talecast.webapp.proto.UserOrderInfoProto
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    UserOrderInfoProto.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for UserOrderInfoProto
                     * @function getTypeUrl
                     * @memberof ai.talecast.webapp.proto.UserOrderInfoProto
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    UserOrderInfoProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/ai.talecast.webapp.proto.UserOrderInfoProto";
                    };

                    return UserOrderInfoProto;
                })();

                proto.InformMessage = (function() {

                    /**
                     * Properties of an InformMessage.
                     * @memberof ai.talecast.webapp.proto
                     * @interface IInformMessage
                     * @property {ai.talecast.webapp.proto.informType|null} [type] InformMessage type
                     * @property {string|null} [message] InformMessage message
                     */

                    /**
                     * Constructs a new InformMessage.
                     * @memberof ai.talecast.webapp.proto
                     * @classdesc Represents an InformMessage.
                     * @implements IInformMessage
                     * @constructor
                     * @param {ai.talecast.webapp.proto.IInformMessage=} [properties] Properties to set
                     */
                    function InformMessage(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * InformMessage type.
                     * @member {ai.talecast.webapp.proto.informType} type
                     * @memberof ai.talecast.webapp.proto.InformMessage
                     * @instance
                     */
                    InformMessage.prototype.type = 0;

                    /**
                     * InformMessage message.
                     * @member {string} message
                     * @memberof ai.talecast.webapp.proto.InformMessage
                     * @instance
                     */
                    InformMessage.prototype.message = "";

                    /**
                     * Creates a new InformMessage instance using the specified properties.
                     * @function create
                     * @memberof ai.talecast.webapp.proto.InformMessage
                     * @static
                     * @param {ai.talecast.webapp.proto.IInformMessage=} [properties] Properties to set
                     * @returns {ai.talecast.webapp.proto.InformMessage} InformMessage instance
                     */
                    InformMessage.create = function create(properties) {
                        return new InformMessage(properties);
                    };

                    /**
                     * Encodes the specified InformMessage message. Does not implicitly {@link ai.talecast.webapp.proto.InformMessage.verify|verify} messages.
                     * @function encode
                     * @memberof ai.talecast.webapp.proto.InformMessage
                     * @static
                     * @param {ai.talecast.webapp.proto.IInformMessage} message InformMessage message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    InformMessage.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.type);
                        if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
                        return writer;
                    };

                    /**
                     * Encodes the specified InformMessage message, length delimited. Does not implicitly {@link ai.talecast.webapp.proto.InformMessage.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof ai.talecast.webapp.proto.InformMessage
                     * @static
                     * @param {ai.talecast.webapp.proto.IInformMessage} message InformMessage message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    InformMessage.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes an InformMessage message from the specified reader or buffer.
                     * @function decode
                     * @memberof ai.talecast.webapp.proto.InformMessage
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {ai.talecast.webapp.proto.InformMessage} InformMessage
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    InformMessage.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        const end = length === undefined ? reader.len : reader.pos + length, message = new $root.ai.talecast.webapp.proto.InformMessage();
                        while (reader.pos < end) {
                            const tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.type = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.message = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes an InformMessage message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof ai.talecast.webapp.proto.InformMessage
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {ai.talecast.webapp.proto.InformMessage} InformMessage
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    InformMessage.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies an InformMessage message.
                     * @function verify
                     * @memberof ai.talecast.webapp.proto.InformMessage
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    InformMessage.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.type != null && message.hasOwnProperty("type"))
                            switch (message.type) {
                            default:
                                return "type: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        if (message.message != null && message.hasOwnProperty("message"))
                            if (!$util.isString(message.message))
                                return "message: string expected";
                        return null;
                    };

                    /**
                     * Creates an InformMessage message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof ai.talecast.webapp.proto.InformMessage
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {ai.talecast.webapp.proto.InformMessage} InformMessage
                     */
                    InformMessage.fromObject = function fromObject(object) {
                        if (object instanceof $root.ai.talecast.webapp.proto.InformMessage)
                            return object;
                        const message = new $root.ai.talecast.webapp.proto.InformMessage();
                        switch (object.type) {
                        default:
                            if (typeof object.type === "number") {
                                message.type = object.type;
                                break;
                            }
                            break;
                        case "PING":
                        case 0:
                            message.type = 0;
                            break;
                        case "ROUND":
                        case 1:
                            message.type = 1;
                            break;
                        case "REPORT":
                        case 2:
                            message.type = 2;
                            break;
                        }
                        if (object.message != null)
                            message.message = String(object.message);
                        return message;
                    };

                    /**
                     * Creates a plain object from an InformMessage message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof ai.talecast.webapp.proto.InformMessage
                     * @static
                     * @param {ai.talecast.webapp.proto.InformMessage} message InformMessage
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    InformMessage.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        const object = {};
                        if (options.defaults) {
                            object.type = options.enums === String ? "PING" : 0;
                            object.message = "";
                        }
                        if (message.type != null && message.hasOwnProperty("type"))
                            object.type = options.enums === String ? $root.ai.talecast.webapp.proto.informType[message.type] === undefined ? message.type : $root.ai.talecast.webapp.proto.informType[message.type] : message.type;
                        if (message.message != null && message.hasOwnProperty("message"))
                            object.message = message.message;
                        return object;
                    };

                    /**
                     * Converts this InformMessage to JSON.
                     * @function toJSON
                     * @memberof ai.talecast.webapp.proto.InformMessage
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    InformMessage.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for InformMessage
                     * @function getTypeUrl
                     * @memberof ai.talecast.webapp.proto.InformMessage
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    InformMessage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/ai.talecast.webapp.proto.InformMessage";
                    };

                    return InformMessage;
                })();

                /**
                 * informType enum.
                 * @name ai.talecast.webapp.proto.informType
                 * @enum {number}
                 * @property {number} PING=0 PING value
                 * @property {number} ROUND=1 ROUND value
                 * @property {number} REPORT=2 REPORT value
                 */
                proto.informType = (function() {
                    const valuesById = {}, values = Object.create(valuesById);
                    values[valuesById[0] = "PING"] = 0;
                    values[valuesById[1] = "ROUND"] = 1;
                    values[valuesById[2] = "REPORT"] = 2;
                    return values;
                })();

                return proto;
            })();

            return webapp;
        })();

        return talecast;
    })();

    return ai;
})();

export { $root as default };
